// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptInvitation, activateContract, addDocumentVersion, becomeOwner, cancelContract, cancelGdprErasure, changeOrganizationMemberRole, changePassword, changeRepairTicketStatus, changeTaskItemStatus, closeRepairTicket, confirmFiscalBasket, confirmFiscalDeclaration, confirmGdprErasure, confirmInvoice, confirmPaymentDeclaration, confirmTotp, confirmUtilityBill, createContract, createContractAmendment, createEquipment, createExpense, createExpenseCategory, createFiscalDeclarationCorrection, createInsurance, createInvoice, createPlatformAccount, createPortalAccount, createRecurringExpense, createRepairTicket, createSupplier, createTenant, createUtilityService, deactivateExpenseCategory, deactivateOrganizationMember, deactivateOwnerTenancy, deactivatePlatformAccount, deactivateRecurringExpense, declarePortalPayment, declarePortalUtilityBill, deleteApiV1PropertiesById, deleteApiV1PropertiesByPropertyIdUnitsByUnitId, deleteContract, deleteDocument, deleteEquipment, deleteExpense, deleteInsurance, deleteInvoice, deleteOwnerTenancy, deleteSupplier, deleteTenant, deleteUtilityService, disableMfa, downloadFiscalDossier, downloadGdprExport, downloadPortalDocument, downloadPortalGeneratedDocument, endOtherSessions, endSession, enrollTotp, exportAuditLog, exportReport, generateFiscalDeclaration, generatePortalLink, getApiV1Owners, getApiV1OwnersById, getApiV1PortfolioProperties, getApiV1PortfolioSummary, getApiV1Properties, getApiV1PropertiesById, getApiV1PropertiesByIdAssignableOwners, getApiV1PropertiesByIdHandoverRecipients, getApiV1PropertiesByIdHandovers, getApiV1PropertiesByIdOwnershipTransfers, getApiV1PropertiesByPropertyIdUnits, getApiV1PropertiesByPropertyIdUnitsByUnitId, getArrearsReport, getAuditLogByCorrelation, getCashLedger, getContract, getContractAmendment, getContractDeposit, getContractDocument, getCurrentUser, getDashboard, getDeclarationStatusReport, getDocument, getDocumentVersionContent, getEquipment, getExpense, getExpenseCategoryReport, getFiscalCalendar, getFiscalDeclaration, getFiscalDossier, getFiscalObligation, getFiscalObligationReport, getFiscalProfile, getFiscalRuleContext, getGdprErasure, getGdprExport, getIncomeReport, getInsurance, getInvestmentYieldReport, getInvitationPreview, getInvoice, getMyNotificationPreferences, getOccupancyReport, getOwnerTenancy, getOwnerTenancySummary, getPayment, getPlatformAccount, getPlatformEmailStatus, getPortalContractSchedule, getPortalIncident, getPortalLinkContext, getPortalUtilityMonth, getPortfolioCashFlow, getPortfolioEconomicPnl, getPortfolioHealthScores, getPropertyCashFlow, getPropertyEconomicPnl, getPropertyHealthScore, getRecurringExpense, getRepairTicket, getReportCatalog, getRetentionPolicy, getSupplier, getTenant, getTenantContacts, getUnreadNotificationCount, getUtilityConsumption, getUtilityService, inviteOrganizationMember, invitePortalUser, issuePortalAccountPassword, listActiveSessions, listAuditLog, listBankStatementImports, listContractAmendments, listContractRentSchedules, listContracts, listDocuments, listEquipment, listEquipmentTypeNames, listExpenseCategories, listExpenses, listFiscalDeclarations, listFiscalDossiers, listFiscalObligations, listGdprErasures, listGdprExports, listInsurances, listInvoices, listMeterReadings, listMyDocuments, listNotificationRules, listNotifications, listOrganizationInvitations, listOrganizationMembers, listOwnerTenancies, listOwnerTenancyExpenses, listOwnerTenancyRecurringExpenses, listOwnStaff, listPaymentDeclarations, listPayments, listPlatformAccounts, listPlatformAdminActions, listPlatformAudit, listPlatformOutboundEmails, listPortalContractDocuments, listPortalContractMeters, listPortalContracts, listPortalIncidents, listPortalMeterReadings, listPortalNotifications, listPortalPaymentDeclarations, listPropertyExpenses, listPropertyRentSchedules, listPropertyRepairTickets, listRecurringExpenses, listRentSchedules, listRepairTickets, listSuppliers, listTaskItems, listTenantContracts, listTenants, listUtilityBills, listUtilityServices, login, logout, markAllNotificationsRead, markAllPortalNotificationsRead, markNotificationRead, markPortalNotificationRead, openJobsDashboardSession, type Options, postApiV1Owners, postApiV1OwnershipTransfersByIdAccept, postApiV1OwnershipTransfersByIdDecline, postApiV1Properties, postApiV1PropertiesByIdCoOwnerInvitations, postApiV1PropertiesByIdHandovers, postApiV1PropertiesByIdHandoversByHandoverIdRevoke, postApiV1PropertiesByIdOwnershipTransfers, postApiV1PropertiesByPropertyIdUnits, postApiV1PropertyHandoversAccept, previewPaymentAllocation, previewRecurringExpense, putApiV1OwnersById, putApiV1PropertiesById, putApiV1PropertiesByIdAdministrator, putApiV1PropertiesByIdOwnershipShares, putApiV1PropertiesByPropertyIdUnitsByUnitId, reactivatePlatformAccount, reallocatePayment, recordEquipmentRevision, recordFiscalDeclarationOutcome, recordFiscalDeclarationSubmission, recordRepairTicketQuote, recordUtilityBill, refreshSession, regenerateRecoveryCodes, register, registerContractDeposit, registerPayment, rejectPaymentDeclaration, rejectUtilityBill, reportPortalIncident, reportPortalLinkIncident, requestFiscalDossier, requestGdprErasure, requestGdprExport, requestPasswordReset, resendEmailVerification, resetPassword, retainContractDeposit, returnContractDeposit, revertPlatformAuditCreation, revokeOrganizationInvitation, revokeOwnStaff, revokePortalLinks, runInvoiceOcr, sendMfaEmailCode, sendPlatformTestEmail, setMyTaxpayerType, setTenantContacts, submitMeterReading, submitPortalLinkMeterReading, submitPortalMeterReading, summarizeTaskItems, switchClient, switchOrganization, terminateContract, updateDraftContract, updateEquipment, updateExpense, updateExpenseCategory, updateInsurance, updateInvoice, updateMyNotificationPreferences, updateNotificationRules, updateOwnerTenancy, updatePlatformAccount, updateProfile, updateRecurringExpense, updateRepairTicket, updateRetentionPolicy, updateSupplier, updateTenant, updateUtilityService, uploadBankStatement, uploadDocument, uploadFiscalDeclarationRecipisa, uploadPortalLinkPhoto, uploadPortalPhoto, verifyEmail, verifyMfa, voidPayment } from '../sdk.gen';
import type { AcceptInvitationData, AcceptInvitationError, AcceptInvitationResponse, ActivateContractData, ActivateContractError, ActivateContractResponse, AddDocumentVersionData, AddDocumentVersionError, AddDocumentVersionResponse, BecomeOwnerData, BecomeOwnerError, BecomeOwnerResponse, CancelContractData, CancelContractError, CancelContractResponse, CancelGdprErasureData, CancelGdprErasureError, CancelGdprErasureResponse, ChangeOrganizationMemberRoleData, ChangeOrganizationMemberRoleError, ChangeOrganizationMemberRoleResponse, ChangePasswordData, ChangePasswordError, ChangePasswordResponse, ChangeRepairTicketStatusData, ChangeRepairTicketStatusError, ChangeRepairTicketStatusResponse, ChangeTaskItemStatusData, ChangeTaskItemStatusError, ChangeTaskItemStatusResponse, CloseRepairTicketData, CloseRepairTicketError, CloseRepairTicketResponse, ConfirmFiscalBasketData, ConfirmFiscalBasketError, ConfirmFiscalBasketResponse, ConfirmFiscalDeclarationData, ConfirmFiscalDeclarationError, ConfirmFiscalDeclarationResponse, ConfirmGdprErasureData, ConfirmGdprErasureError, ConfirmGdprErasureResponse, ConfirmInvoiceData, ConfirmInvoiceError, ConfirmInvoiceResponse, ConfirmPaymentDeclarationData, ConfirmPaymentDeclarationError, ConfirmPaymentDeclarationResponse, ConfirmTotpData, ConfirmTotpError, ConfirmTotpResponse, ConfirmUtilityBillData, ConfirmUtilityBillError, ConfirmUtilityBillResponse, CreateContractAmendmentData, CreateContractAmendmentError, CreateContractAmendmentResponse, CreateContractData, CreateContractError, CreateContractResponse, CreateEquipmentData, CreateEquipmentError, CreateEquipmentResponse, CreateExpenseCategoryData, CreateExpenseCategoryError, CreateExpenseCategoryResponse, CreateExpenseData, CreateExpenseError, CreateExpenseResponse, CreateFiscalDeclarationCorrectionData, CreateFiscalDeclarationCorrectionError, CreateFiscalDeclarationCorrectionResponse, CreateInsuranceData, CreateInsuranceError, CreateInsuranceResponse, CreateInvoiceData, CreateInvoiceError, CreateInvoiceResponse, CreatePlatformAccountData, CreatePlatformAccountError, CreatePlatformAccountResponse, CreatePortalAccountData, CreatePortalAccountError, CreatePortalAccountResponse, CreateRecurringExpenseData, CreateRecurringExpenseError, CreateRecurringExpenseResponse, CreateRepairTicketData, CreateRepairTicketError, CreateRepairTicketResponse, CreateSupplierData, CreateSupplierError, CreateSupplierResponse, CreateTenantData, CreateTenantError, CreateTenantResponse, CreateUtilityServiceData, CreateUtilityServiceError, CreateUtilityServiceResponse, DeactivateExpenseCategoryData, DeactivateExpenseCategoryError, DeactivateExpenseCategoryResponse, DeactivateOrganizationMemberData, DeactivateOrganizationMemberError, DeactivateOrganizationMemberResponse, DeactivateOwnerTenancyData, DeactivateOwnerTenancyError, DeactivateOwnerTenancyResponse, DeactivatePlatformAccountData, DeactivatePlatformAccountError, DeactivatePlatformAccountResponse, DeactivateRecurringExpenseData, DeactivateRecurringExpenseError, DeactivateRecurringExpenseResponse, DeclarePortalPaymentData, DeclarePortalPaymentError, DeclarePortalPaymentResponse, DeclarePortalUtilityBillData, DeclarePortalUtilityBillError, DeclarePortalUtilityBillResponse, DeleteApiV1PropertiesByIdData, DeleteApiV1PropertiesByIdError, DeleteApiV1PropertiesByIdResponse, DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdData, DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdError, DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, DeleteContractData, DeleteContractError, DeleteContractResponse, DeleteDocumentData, DeleteDocumentError, DeleteDocumentResponse, DeleteEquipmentData, DeleteEquipmentError, DeleteEquipmentResponse, DeleteExpenseData, DeleteExpenseError, DeleteExpenseResponse, DeleteInsuranceData, DeleteInsuranceError, DeleteInsuranceResponse, DeleteInvoiceData, DeleteInvoiceError, DeleteInvoiceResponse, DeleteOwnerTenancyData, DeleteOwnerTenancyError, DeleteOwnerTenancyResponse, DeleteSupplierData, DeleteSupplierError, DeleteSupplierResponse, DeleteTenantData, DeleteTenantError, DeleteTenantResponse, DeleteUtilityServiceData, DeleteUtilityServiceError, DeleteUtilityServiceResponse, DisableMfaData, DisableMfaError, DisableMfaResponse, DownloadFiscalDossierData, DownloadFiscalDossierError, DownloadFiscalDossierResponse, DownloadGdprExportData, DownloadGdprExportError, DownloadGdprExportResponse, DownloadPortalDocumentData, DownloadPortalDocumentError, DownloadPortalDocumentResponse, DownloadPortalGeneratedDocumentData, DownloadPortalGeneratedDocumentError, DownloadPortalGeneratedDocumentResponse, EndOtherSessionsData, EndOtherSessionsError, EndOtherSessionsResponse, EndSessionData, EndSessionError, EndSessionResponse, EnrollTotpData, EnrollTotpError, EnrollTotpResponse, ExportAuditLogData, ExportAuditLogError, ExportAuditLogResponse, ExportReportData, ExportReportError, GenerateFiscalDeclarationData, GenerateFiscalDeclarationError, GenerateFiscalDeclarationResponse, GeneratePortalLinkData, GeneratePortalLinkError, GeneratePortalLinkResponse, GetApiV1OwnersByIdData, GetApiV1OwnersByIdError, GetApiV1OwnersByIdResponse, GetApiV1OwnersData, GetApiV1OwnersError, GetApiV1OwnersResponse, GetApiV1PortfolioPropertiesData, GetApiV1PortfolioPropertiesError, GetApiV1PortfolioPropertiesResponse, GetApiV1PortfolioSummaryData, GetApiV1PortfolioSummaryError, GetApiV1PortfolioSummaryResponse, GetApiV1PropertiesByIdAssignableOwnersData, GetApiV1PropertiesByIdAssignableOwnersError, GetApiV1PropertiesByIdAssignableOwnersResponse, GetApiV1PropertiesByIdData, GetApiV1PropertiesByIdError, GetApiV1PropertiesByIdHandoverRecipientsData, GetApiV1PropertiesByIdHandoverRecipientsError, GetApiV1PropertiesByIdHandoverRecipientsResponse, GetApiV1PropertiesByIdHandoversData, GetApiV1PropertiesByIdHandoversError, GetApiV1PropertiesByIdHandoversResponse, GetApiV1PropertiesByIdOwnershipTransfersData, GetApiV1PropertiesByIdOwnershipTransfersError, GetApiV1PropertiesByIdOwnershipTransfersResponse, GetApiV1PropertiesByIdResponse, GetApiV1PropertiesByPropertyIdUnitsByUnitIdData, GetApiV1PropertiesByPropertyIdUnitsByUnitIdError, GetApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, GetApiV1PropertiesByPropertyIdUnitsData, GetApiV1PropertiesByPropertyIdUnitsError, GetApiV1PropertiesByPropertyIdUnitsResponse, GetApiV1PropertiesData, GetApiV1PropertiesError, GetApiV1PropertiesResponse, GetArrearsReportData, GetArrearsReportError, GetArrearsReportResponse, GetAuditLogByCorrelationData, GetAuditLogByCorrelationError, GetAuditLogByCorrelationResponse, GetCashLedgerData, GetCashLedgerError, GetCashLedgerResponse, GetContractAmendmentData, GetContractAmendmentError, GetContractAmendmentResponse, GetContractData, GetContractDepositData, GetContractDepositError, GetContractDepositResponse, GetContractDocumentData, GetContractDocumentError, GetContractDocumentResponse, GetContractError, GetContractResponse, GetCurrentUserData, GetCurrentUserError, GetCurrentUserResponse, GetDashboardData, GetDashboardError, GetDashboardResponse, GetDeclarationStatusReportData, GetDeclarationStatusReportError, GetDeclarationStatusReportResponse, GetDocumentData, GetDocumentError, GetDocumentResponse, GetDocumentVersionContentData, GetDocumentVersionContentError, GetDocumentVersionContentResponse, GetEquipmentData, GetEquipmentError, GetEquipmentResponse, GetExpenseCategoryReportData, GetExpenseCategoryReportError, GetExpenseCategoryReportResponse, GetExpenseData, GetExpenseError, GetExpenseResponse, GetFiscalCalendarData, GetFiscalCalendarError, GetFiscalCalendarResponse, GetFiscalDeclarationData, GetFiscalDeclarationError, GetFiscalDeclarationResponse, GetFiscalDossierData, GetFiscalDossierError, GetFiscalDossierResponse, GetFiscalObligationData, GetFiscalObligationError, GetFiscalObligationReportData, GetFiscalObligationReportError, GetFiscalObligationReportResponse, GetFiscalObligationResponse, GetFiscalProfileData, GetFiscalProfileError, GetFiscalProfileResponse, GetFiscalRuleContextData, GetFiscalRuleContextError, GetFiscalRuleContextResponse, GetGdprErasureData, GetGdprErasureError, GetGdprErasureResponse, GetGdprExportData, GetGdprExportError, GetGdprExportResponse, GetIncomeReportData, GetIncomeReportError, GetIncomeReportResponse, GetInsuranceData, GetInsuranceError, GetInsuranceResponse, GetInvestmentYieldReportData, GetInvestmentYieldReportError, GetInvestmentYieldReportResponse, GetInvitationPreviewData, GetInvitationPreviewError, GetInvitationPreviewResponse, GetInvoiceData, GetInvoiceError, GetInvoiceResponse, GetMyNotificationPreferencesData, GetMyNotificationPreferencesError, GetMyNotificationPreferencesResponse, GetOccupancyReportData, GetOccupancyReportError, GetOccupancyReportResponse, GetOwnerTenancyData, GetOwnerTenancyError, GetOwnerTenancyResponse, GetOwnerTenancySummaryData, GetOwnerTenancySummaryError, GetOwnerTenancySummaryResponse, GetPaymentData, GetPaymentError, GetPaymentResponse, GetPlatformAccountData, GetPlatformAccountError, GetPlatformAccountResponse, GetPlatformEmailStatusData, GetPlatformEmailStatusError, GetPlatformEmailStatusResponse, GetPortalContractScheduleData, GetPortalContractScheduleError, GetPortalContractScheduleResponse, GetPortalIncidentData, GetPortalIncidentError, GetPortalIncidentResponse, GetPortalLinkContextData, GetPortalLinkContextError, GetPortalLinkContextResponse, GetPortalUtilityMonthData, GetPortalUtilityMonthError, GetPortalUtilityMonthResponse, GetPortfolioCashFlowData, GetPortfolioCashFlowError, GetPortfolioCashFlowResponse, GetPortfolioEconomicPnlData, GetPortfolioEconomicPnlError, GetPortfolioEconomicPnlResponse, GetPortfolioHealthScoresData, GetPortfolioHealthScoresError, GetPortfolioHealthScoresResponse, GetPropertyCashFlowData, GetPropertyCashFlowError, GetPropertyCashFlowResponse, GetPropertyEconomicPnlData, GetPropertyEconomicPnlError, GetPropertyEconomicPnlResponse, GetPropertyHealthScoreData, GetPropertyHealthScoreError, GetPropertyHealthScoreResponse, GetRecurringExpenseData, GetRecurringExpenseError, GetRecurringExpenseResponse, GetRepairTicketData, GetRepairTicketError, GetRepairTicketResponse, GetReportCatalogData, GetReportCatalogError, GetReportCatalogResponse, GetRetentionPolicyData, GetRetentionPolicyError, GetRetentionPolicyResponse, GetSupplierData, GetSupplierError, GetSupplierResponse, GetTenantContactsData, GetTenantContactsError, GetTenantContactsResponse, GetTenantData, GetTenantError, GetTenantResponse, GetUnreadNotificationCountData, GetUnreadNotificationCountError, GetUnreadNotificationCountResponse, GetUtilityConsumptionData, GetUtilityConsumptionError, GetUtilityConsumptionResponse, GetUtilityServiceData, GetUtilityServiceError, GetUtilityServiceResponse, InviteOrganizationMemberData, InviteOrganizationMemberError, InviteOrganizationMemberResponse, InvitePortalUserData, InvitePortalUserError, InvitePortalUserResponse, IssuePortalAccountPasswordData, IssuePortalAccountPasswordError, IssuePortalAccountPasswordResponse, ListActiveSessionsData, ListActiveSessionsError, ListActiveSessionsResponse, ListAuditLogData, ListAuditLogError, ListAuditLogResponse, ListBankStatementImportsData, ListBankStatementImportsError, ListBankStatementImportsResponse, ListContractAmendmentsData, ListContractAmendmentsError, ListContractAmendmentsResponse, ListContractRentSchedulesData, ListContractRentSchedulesError, ListContractRentSchedulesResponse, ListContractsData, ListContractsError, ListContractsResponse, ListDocumentsData, ListDocumentsError, ListDocumentsResponse, ListEquipmentData, ListEquipmentError, ListEquipmentResponse, ListEquipmentTypeNamesData, ListEquipmentTypeNamesError, ListEquipmentTypeNamesResponse, ListExpenseCategoriesData, ListExpenseCategoriesError, ListExpenseCategoriesResponse, ListExpensesData, ListExpensesError, ListExpensesResponse, ListFiscalDeclarationsData, ListFiscalDeclarationsError, ListFiscalDeclarationsResponse, ListFiscalDossiersData, ListFiscalDossiersError, ListFiscalDossiersResponse, ListFiscalObligationsData, ListFiscalObligationsError, ListFiscalObligationsResponse, ListGdprErasuresData, ListGdprErasuresError, ListGdprErasuresResponse, ListGdprExportsData, ListGdprExportsError, ListGdprExportsResponse, ListInsurancesData, ListInsurancesError, ListInsurancesResponse, ListInvoicesData, ListInvoicesError, ListInvoicesResponse, ListMeterReadingsData, ListMeterReadingsError, ListMeterReadingsResponse, ListMyDocumentsData, ListMyDocumentsError, ListMyDocumentsResponse, ListNotificationRulesData, ListNotificationRulesError, ListNotificationRulesResponse, ListNotificationsData, ListNotificationsError, ListNotificationsResponse, ListOrganizationInvitationsData, ListOrganizationInvitationsError, ListOrganizationInvitationsResponse, ListOrganizationMembersData, ListOrganizationMembersError, ListOrganizationMembersResponse, ListOwnerTenanciesData, ListOwnerTenanciesError, ListOwnerTenanciesResponse, ListOwnerTenancyExpensesData, ListOwnerTenancyExpensesError, ListOwnerTenancyExpensesResponse, ListOwnerTenancyRecurringExpensesData, ListOwnerTenancyRecurringExpensesError, ListOwnerTenancyRecurringExpensesResponse, ListOwnStaffData, ListOwnStaffError, ListOwnStaffResponse, ListPaymentDeclarationsData, ListPaymentDeclarationsError, ListPaymentDeclarationsResponse, ListPaymentsData, ListPaymentsError, ListPaymentsResponse, ListPlatformAccountsData, ListPlatformAccountsError, ListPlatformAccountsResponse, ListPlatformAdminActionsData, ListPlatformAdminActionsError, ListPlatformAdminActionsResponse, ListPlatformAuditData, ListPlatformAuditError, ListPlatformAuditResponse, ListPlatformOutboundEmailsData, ListPlatformOutboundEmailsError, ListPlatformOutboundEmailsResponse, ListPortalContractDocumentsData, ListPortalContractDocumentsError, ListPortalContractDocumentsResponse, ListPortalContractMetersData, ListPortalContractMetersError, ListPortalContractMetersResponse, ListPortalContractsData, ListPortalContractsError, ListPortalContractsResponse, ListPortalIncidentsData, ListPortalIncidentsError, ListPortalIncidentsResponse, ListPortalMeterReadingsData, ListPortalMeterReadingsError, ListPortalMeterReadingsResponse, ListPortalNotificationsData, ListPortalNotificationsError, ListPortalNotificationsResponse, ListPortalPaymentDeclarationsData, ListPortalPaymentDeclarationsError, ListPortalPaymentDeclarationsResponse, ListPropertyExpensesData, ListPropertyExpensesError, ListPropertyExpensesResponse, ListPropertyRentSchedulesData, ListPropertyRentSchedulesError, ListPropertyRentSchedulesResponse, ListPropertyRepairTicketsData, ListPropertyRepairTicketsError, ListPropertyRepairTicketsResponse, ListRecurringExpensesData, ListRecurringExpensesError, ListRecurringExpensesResponse, ListRentSchedulesData, ListRentSchedulesError, ListRentSchedulesResponse, ListRepairTicketsData, ListRepairTicketsError, ListRepairTicketsResponse, ListSuppliersData, ListSuppliersError, ListSuppliersResponse, ListTaskItemsData, ListTaskItemsError, ListTaskItemsResponse, ListTenantContractsData, ListTenantContractsError, ListTenantContractsResponse, ListTenantsData, ListTenantsError, ListTenantsResponse, ListUtilityBillsData, ListUtilityBillsError, ListUtilityBillsResponse, ListUtilityServicesData, ListUtilityServicesError, ListUtilityServicesResponse, LoginData, LoginError, LoginResponse, LogoutData, LogoutError, LogoutResponse, MarkAllNotificationsReadData, MarkAllNotificationsReadError, MarkAllNotificationsReadResponse, MarkAllPortalNotificationsReadData, MarkAllPortalNotificationsReadError, MarkAllPortalNotificationsReadResponse, MarkNotificationReadData, MarkNotificationReadError, MarkNotificationReadResponse, MarkPortalNotificationReadData, MarkPortalNotificationReadError, MarkPortalNotificationReadResponse, OpenJobsDashboardSessionData, OpenJobsDashboardSessionError, OpenJobsDashboardSessionResponse, PostApiV1OwnersData, PostApiV1OwnersError, PostApiV1OwnershipTransfersByIdAcceptData, PostApiV1OwnershipTransfersByIdAcceptError, PostApiV1OwnershipTransfersByIdAcceptResponse, PostApiV1OwnershipTransfersByIdDeclineData, PostApiV1OwnershipTransfersByIdDeclineError, PostApiV1OwnershipTransfersByIdDeclineResponse, PostApiV1OwnersResponse, PostApiV1PropertiesByIdCoOwnerInvitationsData, PostApiV1PropertiesByIdCoOwnerInvitationsError, PostApiV1PropertiesByIdCoOwnerInvitationsResponse, PostApiV1PropertiesByIdHandoversByHandoverIdRevokeData, PostApiV1PropertiesByIdHandoversByHandoverIdRevokeError, PostApiV1PropertiesByIdHandoversByHandoverIdRevokeResponse, PostApiV1PropertiesByIdHandoversData, PostApiV1PropertiesByIdHandoversError, PostApiV1PropertiesByIdHandoversResponse, PostApiV1PropertiesByIdOwnershipTransfersData, PostApiV1PropertiesByIdOwnershipTransfersError, PostApiV1PropertiesByIdOwnershipTransfersResponse, PostApiV1PropertiesByPropertyIdUnitsData, PostApiV1PropertiesByPropertyIdUnitsError, PostApiV1PropertiesByPropertyIdUnitsResponse, PostApiV1PropertiesData, PostApiV1PropertiesError, PostApiV1PropertiesResponse, PostApiV1PropertyHandoversAcceptData, PostApiV1PropertyHandoversAcceptError, PostApiV1PropertyHandoversAcceptResponse, PreviewPaymentAllocationData, PreviewPaymentAllocationError, PreviewPaymentAllocationResponse, PreviewRecurringExpenseData, PreviewRecurringExpenseError, PreviewRecurringExpenseResponse, PutApiV1OwnersByIdData, PutApiV1OwnersByIdError, PutApiV1OwnersByIdResponse, PutApiV1PropertiesByIdAdministratorData, PutApiV1PropertiesByIdAdministratorError, PutApiV1PropertiesByIdAdministratorResponse, PutApiV1PropertiesByIdData, PutApiV1PropertiesByIdError, PutApiV1PropertiesByIdOwnershipSharesData, PutApiV1PropertiesByIdOwnershipSharesError, PutApiV1PropertiesByIdOwnershipSharesResponse, PutApiV1PropertiesByIdResponse, PutApiV1PropertiesByPropertyIdUnitsByUnitIdData, PutApiV1PropertiesByPropertyIdUnitsByUnitIdError, PutApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, ReactivatePlatformAccountData, ReactivatePlatformAccountError, ReactivatePlatformAccountResponse, ReallocatePaymentData, ReallocatePaymentError, ReallocatePaymentResponse, RecordEquipmentRevisionData, RecordEquipmentRevisionError, RecordEquipmentRevisionResponse, RecordFiscalDeclarationOutcomeData, RecordFiscalDeclarationOutcomeError, RecordFiscalDeclarationOutcomeResponse, RecordFiscalDeclarationSubmissionData, RecordFiscalDeclarationSubmissionError, RecordFiscalDeclarationSubmissionResponse, RecordRepairTicketQuoteData, RecordRepairTicketQuoteError, RecordRepairTicketQuoteResponse, RecordUtilityBillData, RecordUtilityBillError, RecordUtilityBillResponse, RefreshSessionData, RefreshSessionError, RefreshSessionResponse, RegenerateRecoveryCodesData, RegenerateRecoveryCodesError, RegenerateRecoveryCodesResponse, RegisterContractDepositData, RegisterContractDepositError, RegisterContractDepositResponse, RegisterData, RegisterError, RegisterPaymentData, RegisterPaymentError, RegisterPaymentResponse, RegisterResponse, RejectPaymentDeclarationData, RejectPaymentDeclarationError, RejectPaymentDeclarationResponse, RejectUtilityBillData, RejectUtilityBillError, RejectUtilityBillResponse, ReportPortalIncidentData, ReportPortalIncidentError, ReportPortalIncidentResponse, ReportPortalLinkIncidentData, ReportPortalLinkIncidentError, ReportPortalLinkIncidentResponse, RequestFiscalDossierData, RequestFiscalDossierError, RequestFiscalDossierResponse, RequestGdprErasureData, RequestGdprErasureError, RequestGdprErasureResponse, RequestGdprExportData, RequestGdprExportError, RequestGdprExportResponse, RequestPasswordResetData, RequestPasswordResetError, ResendEmailVerificationData, ResendEmailVerificationError, ResetPasswordData, ResetPasswordError, ResetPasswordResponse, RetainContractDepositData, RetainContractDepositError, RetainContractDepositResponse, ReturnContractDepositData, ReturnContractDepositError, ReturnContractDepositResponse, RevertPlatformAuditCreationData, RevertPlatformAuditCreationError, RevertPlatformAuditCreationResponse, RevokeOrganizationInvitationData, RevokeOrganizationInvitationError, RevokeOrganizationInvitationResponse, RevokeOwnStaffData, RevokeOwnStaffError, RevokeOwnStaffResponse, RevokePortalLinksData, RevokePortalLinksError, RevokePortalLinksResponse, RunInvoiceOcrData, RunInvoiceOcrError, RunInvoiceOcrResponse, SendMfaEmailCodeData, SendMfaEmailCodeError, SendMfaEmailCodeResponse, SendPlatformTestEmailData, SendPlatformTestEmailError, SendPlatformTestEmailResponse, SetMyTaxpayerTypeData, SetMyTaxpayerTypeError, SetMyTaxpayerTypeResponse, SetTenantContactsData, SetTenantContactsError, SetTenantContactsResponse, SubmitMeterReadingData, SubmitMeterReadingError, SubmitMeterReadingResponse, SubmitPortalLinkMeterReadingData, SubmitPortalLinkMeterReadingError, SubmitPortalLinkMeterReadingResponse, SubmitPortalMeterReadingData, SubmitPortalMeterReadingError, SubmitPortalMeterReadingResponse, SummarizeTaskItemsData, SummarizeTaskItemsError, SummarizeTaskItemsResponse, SwitchClientData, SwitchClientError, SwitchClientResponse, SwitchOrganizationData, SwitchOrganizationError, SwitchOrganizationResponse, TerminateContractData, TerminateContractError, TerminateContractResponse, UpdateDraftContractData, UpdateDraftContractError, UpdateDraftContractResponse, UpdateEquipmentData, UpdateEquipmentError, UpdateEquipmentResponse, UpdateExpenseCategoryData, UpdateExpenseCategoryError, UpdateExpenseCategoryResponse, UpdateExpenseData, UpdateExpenseError, UpdateExpenseResponse, UpdateInsuranceData, UpdateInsuranceError, UpdateInsuranceResponse, UpdateInvoiceData, UpdateInvoiceError, UpdateInvoiceResponse, UpdateMyNotificationPreferencesData, UpdateMyNotificationPreferencesError, UpdateMyNotificationPreferencesResponse, UpdateNotificationRulesData, UpdateNotificationRulesError, UpdateNotificationRulesResponse, UpdateOwnerTenancyData, UpdateOwnerTenancyError, UpdateOwnerTenancyResponse, UpdatePlatformAccountData, UpdatePlatformAccountError, UpdatePlatformAccountResponse, UpdateProfileData, UpdateProfileError, UpdateProfileResponse, UpdateRecurringExpenseData, UpdateRecurringExpenseError, UpdateRecurringExpenseResponse, UpdateRepairTicketData, UpdateRepairTicketError, UpdateRepairTicketResponse, UpdateRetentionPolicyData, UpdateRetentionPolicyError, UpdateRetentionPolicyResponse, UpdateSupplierData, UpdateSupplierError, UpdateSupplierResponse, UpdateTenantData, UpdateTenantError, UpdateTenantResponse, UpdateUtilityServiceData, UpdateUtilityServiceError, UpdateUtilityServiceResponse, UploadBankStatementData, UploadBankStatementError, UploadBankStatementResponse, UploadDocumentData, UploadDocumentError, UploadDocumentResponse, UploadFiscalDeclarationRecipisaData, UploadFiscalDeclarationRecipisaError, UploadFiscalDeclarationRecipisaResponse, UploadPortalLinkPhotoData, UploadPortalLinkPhotoError, UploadPortalLinkPhotoResponse, UploadPortalPhotoData, UploadPortalPhotoError, UploadPortalPhotoResponse, VerifyEmailData, VerifyEmailError, VerifyEmailResponse, VerifyMfaData, VerifyMfaError, VerifyMfaResponse, VoidPaymentData, VoidPaymentError, VoidPaymentResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const listAuditLogQueryKey = (options?: Options<ListAuditLogData>) => createQueryKey('listAuditLog', options);

/**
 * Jurnalul de audit, filtrabil și paginat, cel mai nou primul.
 *
 * Jurnalul de audit al organizației, cel mai nou primul. Filtrele se combină: tip entitate, ID entitate, utilizator, acțiune, correlation ID și un interval de timp [from, to) exprimat în UTC. Ordinea este fixă și nu se poate schimba din query string — jurnalul este o cronologie, iar cei patru indecși ai tabelei sunt toți descrescători după timp. Fiecare rând poartă actorul, momentul, acțiunea, entitatea, correlation ID-ul și diferența vechi→nou ca date structurate, nu ca text.
 */
export const listAuditLogOptions = (options?: Options<ListAuditLogData>) => queryOptions<ListAuditLogResponse, ListAuditLogError, ListAuditLogResponse, ReturnType<typeof listAuditLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAuditLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listAuditLogInfiniteQueryKey = (options?: Options<ListAuditLogData>): QueryKey<Options<ListAuditLogData>> => createQueryKey('listAuditLog', options, true);

/**
 * Jurnalul de audit, filtrabil și paginat, cel mai nou primul.
 *
 * Jurnalul de audit al organizației, cel mai nou primul. Filtrele se combină: tip entitate, ID entitate, utilizator, acțiune, correlation ID și un interval de timp [from, to) exprimat în UTC. Ordinea este fixă și nu se poate schimba din query string — jurnalul este o cronologie, iar cei patru indecși ai tabelei sunt toți descrescători după timp. Fiecare rând poartă actorul, momentul, acțiunea, entitatea, correlation ID-ul și diferența vechi→nou ca date structurate, nu ca text.
 */
export const listAuditLogInfiniteOptions = (options?: Options<ListAuditLogData>) => {
    const opts = infiniteQueryOptions<ListAuditLogResponse, ListAuditLogError, InfiniteData<ListAuditLogResponse>, QueryKey<Options<ListAuditLogData>>, number | Pick<QueryKey<Options<ListAuditLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAuditLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAuditLog({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAuditLogInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const exportAuditLogQueryKey = (options?: Options<ExportAuditLogData>) => createQueryKey('exportAuditLog', options);

/**
 * Exportă vederea filtrată în CSV.
 *
 * Aceeași vedere filtrată, în format CSV, transmisă pe măsură ce rândurile sunt citite. Contractul de filtrare este identic cu al listei; paginarea nu se aplică, exportul conține tot ce se potrivește filtrului. Fișierul este separat prin punct și virgulă și poartă un BOM UTF-8, ca să se deschidă direct în Excel românesc.
 */
export const exportAuditLogOptions = (options?: Options<ExportAuditLogData>) => queryOptions<ExportAuditLogResponse, ExportAuditLogError, ExportAuditLogResponse, ReturnType<typeof exportAuditLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportAuditLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportAuditLogQueryKey(options)
});

export const getAuditLogByCorrelationQueryKey = (options: Options<GetAuditLogByCorrelationData>) => createQueryKey('getAuditLogByCorrelation', options);

/**
 * Toate rândurile unei singure cereri.
 *
 * Toate rândurile unei singure cereri sau ale unui singur job, în ordinea în care s-au produs. Un correlation ID necunoscut întoarce o listă goală, nu 404: identificatorul nu este o resursă, ci o valoare pe care o poartă rândurile.
 */
export const getAuditLogByCorrelationOptions = (options: Options<GetAuditLogByCorrelationData>) => queryOptions<GetAuditLogByCorrelationResponse, GetAuditLogByCorrelationError, GetAuditLogByCorrelationResponse, ReturnType<typeof getAuditLogByCorrelationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuditLogByCorrelation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuditLogByCorrelationQueryKey(options)
});

/**
 * Creează organizația proprie a contului autentificat și îl face proprietar.
 */
export const becomeOwnerMutation = (options?: Partial<Options<BecomeOwnerData>>): UseMutationOptions<BecomeOwnerResponse, BecomeOwnerError, Options<BecomeOwnerData>> => {
    const mutationOptions: UseMutationOptions<BecomeOwnerResponse, BecomeOwnerError, Options<BecomeOwnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await becomeOwner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retrimite linkul de confirmare a adresei, dacă un cont o așteaptă.
 */
export const resendEmailVerificationMutation = (options?: Partial<Options<ResendEmailVerificationData>>): UseMutationOptions<unknown, ResendEmailVerificationError, Options<ResendEmailVerificationData>> => {
    const mutationOptions: UseMutationOptions<unknown, ResendEmailVerificationError, Options<ResendEmailVerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendEmailVerification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmă adresa de e-mail a unui cont pe baza linkului de confirmare.
 */
export const verifyEmailMutation = (options?: Partial<Options<VerifyEmailData>>): UseMutationOptions<VerifyEmailResponse, VerifyEmailError, Options<VerifyEmailData>> => {
    const mutationOptions: UseMutationOptions<VerifyEmailResponse, VerifyEmailError, Options<VerifyEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Autentifică prin email sau nume de utilizator și parolă; răspunde cu sesiunea sau cu provocarea MFA.
 */
export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<LoginResponse, LoginError, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<LoginResponse, LoginError, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Închide sesiunea curentă și șterge cookie-ul de refresh.
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, LogoutError, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, LogoutError, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dezactivează al doilea factor pe contul curent.
 */
export const disableMfaMutation = (options?: Partial<Options<DisableMfaData>>): UseMutationOptions<DisableMfaResponse, DisableMfaError, Options<DisableMfaData>> => {
    const mutationOptions: UseMutationOptions<DisableMfaResponse, DisableMfaError, Options<DisableMfaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disableMfa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trimite prin email un cod pentru provocarea MFA în curs.
 */
export const sendMfaEmailCodeMutation = (options?: Partial<Options<SendMfaEmailCodeData>>): UseMutationOptions<SendMfaEmailCodeResponse, SendMfaEmailCodeError, Options<SendMfaEmailCodeData>> => {
    const mutationOptions: UseMutationOptions<SendMfaEmailCodeResponse, SendMfaEmailCodeError, Options<SendMfaEmailCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendMfaEmailCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Regenerează codurile de recuperare; cele anterioare devin invalide.
 */
export const regenerateRecoveryCodesMutation = (options?: Partial<Options<RegenerateRecoveryCodesData>>): UseMutationOptions<RegenerateRecoveryCodesResponse, RegenerateRecoveryCodesError, Options<RegenerateRecoveryCodesData>> => {
    const mutationOptions: UseMutationOptions<RegenerateRecoveryCodesResponse, RegenerateRecoveryCodesError, Options<RegenerateRecoveryCodesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await regenerateRecoveryCodes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmă înrolarea TOTP și întoarce codurile de recuperare.
 */
export const confirmTotpMutation = (options?: Partial<Options<ConfirmTotpData>>): UseMutationOptions<ConfirmTotpResponse, ConfirmTotpError, Options<ConfirmTotpData>> => {
    const mutationOptions: UseMutationOptions<ConfirmTotpResponse, ConfirmTotpError, Options<ConfirmTotpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmTotp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Începe înrolarea TOTP și întoarce secretul de configurat în aplicație.
 */
export const enrollTotpMutation = (options?: Partial<Options<EnrollTotpData>>): UseMutationOptions<EnrollTotpResponse, EnrollTotpError, Options<EnrollTotpData>> => {
    const mutationOptions: UseMutationOptions<EnrollTotpResponse, EnrollTotpError, Options<EnrollTotpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enrollTotp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verifică al doilea factor și finalizează autentificarea.
 */
export const verifyMfaMutation = (options?: Partial<Options<VerifyMfaData>>): UseMutationOptions<VerifyMfaResponse, VerifyMfaError, Options<VerifyMfaData>> => {
    const mutationOptions: UseMutationOptions<VerifyMfaResponse, VerifyMfaError, Options<VerifyMfaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyMfa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trimite linkul de resetare a parolei, dacă adresa există.
 */
export const requestPasswordResetMutation = (options?: Partial<Options<RequestPasswordResetData>>): UseMutationOptions<unknown, RequestPasswordResetError, Options<RequestPasswordResetData>> => {
    const mutationOptions: UseMutationOptions<unknown, RequestPasswordResetError, Options<RequestPasswordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestPasswordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stabilește o parolă nouă pe baza tokenului din linkul de resetare.
 */
export const resetPasswordMutation = (options?: Partial<Options<ResetPasswordData>>): UseMutationOptions<ResetPasswordResponse, ResetPasswordError, Options<ResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<ResetPasswordResponse, ResetPasswordError, Options<ResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rotește tokenul de refresh din cookie și emite un access token nou.
 */
export const refreshSessionMutation = (options?: Partial<Options<RefreshSessionData>>): UseMutationOptions<RefreshSessionResponse, RefreshSessionError, Options<RefreshSessionData>> => {
    const mutationOptions: UseMutationOptions<RefreshSessionResponse, RefreshSessionError, Options<RefreshSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Creează un cont și trimite linkul de confirmare a adresei; contul intră după confirmare.
 */
export const registerMutation = (options?: Partial<Options<RegisterData>>): UseMutationOptions<RegisterResponse, RegisterError, Options<RegisterData>> => {
    const mutationOptions: UseMutationOptions<RegisterResponse, RegisterError, Options<RegisterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await register({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Comută sesiunea pe alt client al utilizatorului delegat.
 */
export const switchClientMutation = (options?: Partial<Options<SwitchClientData>>): UseMutationOptions<SwitchClientResponse, SwitchClientError, Options<SwitchClientData>> => {
    const mutationOptions: UseMutationOptions<SwitchClientResponse, SwitchClientError, Options<SwitchClientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await switchClient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Comută sesiunea pe altă organizație a utilizatorului.
 */
export const switchOrganizationMutation = (options?: Partial<Options<SwitchOrganizationData>>): UseMutationOptions<SwitchOrganizationResponse, SwitchOrganizationError, Options<SwitchOrganizationData>> => {
    const mutationOptions: UseMutationOptions<SwitchOrganizationResponse, SwitchOrganizationError, Options<SwitchOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await switchOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBankStatementImportsQueryKey = (options?: Options<ListBankStatementImportsData>) => createQueryKey('listBankStatementImports', options);

/**
 * Istoricul extraselor încărcate de organizație, paginat.
 */
export const listBankStatementImportsOptions = (options?: Options<ListBankStatementImportsData>) => queryOptions<ListBankStatementImportsResponse, ListBankStatementImportsError, ListBankStatementImportsResponse, ReturnType<typeof listBankStatementImportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBankStatementImports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBankStatementImportsQueryKey(options)
});

export const listBankStatementImportsInfiniteQueryKey = (options?: Options<ListBankStatementImportsData>): QueryKey<Options<ListBankStatementImportsData>> => createQueryKey('listBankStatementImports', options, true);

/**
 * Istoricul extraselor încărcate de organizație, paginat.
 */
export const listBankStatementImportsInfiniteOptions = (options?: Options<ListBankStatementImportsData>) => {
    const opts = infiniteQueryOptions<ListBankStatementImportsResponse, ListBankStatementImportsError, InfiniteData<ListBankStatementImportsResponse>, QueryKey<Options<ListBankStatementImportsData>>, number | Pick<QueryKey<Options<ListBankStatementImportsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListBankStatementImportsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listBankStatementImports({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBankStatementImportsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Încarcă un extras de cont (PDF sau CSV, maximum 25 MB). Fișierul este stocat, nu este citit.
 *
 * Fișierul se trimite ca multipart/form-data, în câmpul „file”. Extensia trebuie să fie .pdf sau .csv, iar conținutul trebuie să corespundă extensiei — altfel 422 „file-content-mismatch”. Dacă organizația a încărcat deja exact aceiași octeți, răspunsul este 200 cu „alreadyUploaded”: true și importul existent; nu se creează un rând nou și nu se scrie niciun fișier.
 */
export const uploadBankStatementMutation = (options?: Partial<Options<UploadBankStatementData>>): UseMutationOptions<UploadBankStatementResponse, UploadBankStatementError, Options<UploadBankStatementData>> => {
    const mutationOptions: UseMutationOptions<UploadBankStatementResponse, UploadBankStatementError, Options<UploadBankStatementData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadBankStatement({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listContractsQueryKey = (options?: Options<ListContractsData>) => createQueryKey('listContracts', options);

/**
 * Contractele organizației, paginate; filtre după stare, proprietate, chiriaș și alerta „expiră în ≤60 zile”.
 */
export const listContractsOptions = (options?: Options<ListContractsData>) => queryOptions<ListContractsResponse, ListContractsError, ListContractsResponse, ReturnType<typeof listContractsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContracts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContractsQueryKey(options)
});

export const listContractsInfiniteQueryKey = (options?: Options<ListContractsData>): QueryKey<Options<ListContractsData>> => createQueryKey('listContracts', options, true);

/**
 * Contractele organizației, paginate; filtre după stare, proprietate, chiriaș și alerta „expiră în ≤60 zile”.
 */
export const listContractsInfiniteOptions = (options?: Options<ListContractsData>) => {
    const opts = infiniteQueryOptions<ListContractsResponse, ListContractsError, InfiniteData<ListContractsResponse>, QueryKey<Options<ListContractsData>>, number | Pick<QueryKey<Options<ListContractsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListContractsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listContracts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listContractsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Creează un contract în stare DRAFT din datele asistentului: părți, proprietate sau unitate, perioadă, chirie, clauze.
 *
 * Contractul se naște ciornă și nu produce nimic până la activare. Numărul poate fi al proprietarului sau alocat de server (CTR-AAAA-NNNN). Regulile încălcate răspund 422 cu codul regulii.
 */
export const createContractMutation = (options?: Partial<Options<CreateContractData>>): UseMutationOptions<CreateContractResponse, CreateContractError, Options<CreateContractData>> => {
    const mutationOptions: UseMutationOptions<CreateContractResponse, CreateContractError, Options<CreateContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getContractDepositQueryKey = (options: Options<GetContractDepositData>) => createQueryKey('getContractDeposit', options);

/**
 * Garanția contractului: suma deținută, cât s-a reținut, cât mai rămâne și dacă mai poate fi mișcată.
 */
export const getContractDepositOptions = (options: Options<GetContractDepositData>) => queryOptions<GetContractDepositResponse, GetContractDepositError, GetContractDepositResponse, ReturnType<typeof getContractDepositQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContractDeposit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContractDepositQueryKey(options)
});

/**
 * Înregistrează garanția primită (HELD); luni, sumă și monedă se preiau din contract dacă lipsesc. Refuzată cât timp există o garanție deschisă (422 deposit-already-registered).
 */
export const registerContractDepositMutation = (options?: Partial<Options<RegisterContractDepositData>>): UseMutationOptions<RegisterContractDepositResponse, RegisterContractDepositError, Options<RegisterContractDepositData>> => {
    const mutationOptions: UseMutationOptions<RegisterContractDepositResponse, RegisterContractDepositError, Options<RegisterContractDepositData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerContractDeposit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reține o parte sau tot din garanție, cu sumă și motiv; peste suma deținută este refuzat (422 deposit-retention-exceeds-held). Fiecare reținere este un potențial venit [VERIFY-FISCAL] pe care motorul fiscal îl primește ca semnal, nu ca verdict.
 */
export const retainContractDepositMutation = (options?: Partial<Options<RetainContractDepositData>>): UseMutationOptions<RetainContractDepositResponse, RetainContractDepositError, Options<RetainContractDepositData>> => {
    const mutationOptions: UseMutationOptions<RetainContractDepositResponse, RetainContractDepositError, Options<RetainContractDepositData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retainContractDeposit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Returnează chiriașului ce mai este deținut; o garanție reținută parțial rămâne PARTIALLY_RETAINED și primește data returnării. Refuzată când nu mai este nimic deținut (422 deposit-not-held).
 */
export const returnContractDepositMutation = (options?: Partial<Options<ReturnContractDepositData>>): UseMutationOptions<ReturnContractDepositResponse, ReturnContractDepositError, Options<ReturnContractDepositData>> => {
    const mutationOptions: UseMutationOptions<ReturnContractDepositResponse, ReturnContractDepositError, Options<ReturnContractDepositData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await returnContractDeposit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listContractRentSchedulesQueryKey = (options: Options<ListContractRentSchedulesData>) => createQueryKey('listContractRentSchedules', options);

/**
 * Scadențele unui contract, paginate, cu totalurile întregului set pe fiecare monedă; 404 dacă contractul nu există.
 */
export const listContractRentSchedulesOptions = (options: Options<ListContractRentSchedulesData>) => queryOptions<ListContractRentSchedulesResponse, ListContractRentSchedulesError, ListContractRentSchedulesResponse, ReturnType<typeof listContractRentSchedulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContractRentSchedules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContractRentSchedulesQueryKey(options)
});

export const listContractRentSchedulesInfiniteQueryKey = (options: Options<ListContractRentSchedulesData>): QueryKey<Options<ListContractRentSchedulesData>> => createQueryKey('listContractRentSchedules', options, true);

/**
 * Scadențele unui contract, paginate, cu totalurile întregului set pe fiecare monedă; 404 dacă contractul nu există.
 */
export const listContractRentSchedulesInfiniteOptions = (options: Options<ListContractRentSchedulesData>) => {
    const opts = infiniteQueryOptions<ListContractRentSchedulesResponse, ListContractRentSchedulesError, InfiniteData<ListContractRentSchedulesResponse>, QueryKey<Options<ListContractRentSchedulesData>>, number | Pick<QueryKey<Options<ListContractRentSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListContractRentSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listContractRentSchedules({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listContractRentSchedulesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Ștergere logică; permisă doar pentru o ciornă sau un contract anulat (422 contract-not-deletable altfel).
 */
export const deleteContractMutation = (options?: Partial<Options<DeleteContractData>>): UseMutationOptions<DeleteContractResponse, DeleteContractError, Options<DeleteContractData>> => {
    const mutationOptions: UseMutationOptions<DeleteContractResponse, DeleteContractError, Options<DeleteContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getContractQueryKey = (options: Options<GetContractData>) => createQueryKey('getContract', options);

/**
 * Un contract în întregime, cu părțile, numărul de acte adiționale și tranzițiile permise acum.
 */
export const getContractOptions = (options: Options<GetContractData>) => queryOptions<GetContractResponse, GetContractError, GetContractResponse, ReturnType<typeof getContractQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContract({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContractQueryKey(options)
});

/**
 * Modifică termenii unei ciorne, orice subset; pe un contract activ răspunde 422 contract-requires-amendment și trimite la actul adițional.
 */
export const updateDraftContractMutation = (options?: Partial<Options<UpdateDraftContractData>>): UseMutationOptions<UpdateDraftContractResponse, UpdateDraftContractError, Options<UpdateDraftContractData>> => {
    const mutationOptions: UseMutationOptions<UpdateDraftContractResponse, UpdateDraftContractError, Options<UpdateDraftContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDraftContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * DRAFT → ACTIVE. Refuză suprapunerea cu alt contract activ pe aceeași proprietate sau unitate (422 contract-overlaps-period).
 *
 * Activarea declanșează generarea scadențelor (RENT-001) și evenimentul C168 INITIAL pentru M4. O a doua activare răspunde 422 contract-status-transition-invalid și nu produce nimic; antetul Idempotency-Key nu este necesar aici.
 */
export const activateContractMutation = (options?: Partial<Options<ActivateContractData>>): UseMutationOptions<ActivateContractResponse, ActivateContractError, Options<ActivateContractData>> => {
    const mutationOptions: UseMutationOptions<ActivateContractResponse, ActivateContractError, Options<ActivateContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listContractAmendmentsQueryKey = (options: Options<ListContractAmendmentsData>) => createQueryKey('listContractAmendments', options);

/**
 * Actele adiționale ale contractului, în ordinea numerelor — cronologia imuabilă.
 */
export const listContractAmendmentsOptions = (options: Options<ListContractAmendmentsData>) => queryOptions<ListContractAmendmentsResponse, ListContractAmendmentsError, ListContractAmendmentsResponse, ReturnType<typeof listContractAmendmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContractAmendments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContractAmendmentsQueryKey(options)
});

/**
 * Adaugă un act adițional unui contract activ și aplică noile valori de la data intrării în vigoare.
 *
 * Actul adițional este singurul mecanism de modificare după activare (BR-RENT-05). Este tipizat — fiecare tip poate modifica un set închis de câmpuri — are dată de intrare în vigoare și este imuabil: nu există PUT, PATCH sau DELETE pentru un act adițional. Declanșează regenerarea scadențelor viitoare (RENT-001) și, din M4, evenimentul C168 MODIFICATION.
 */
export const createContractAmendmentMutation = (options?: Partial<Options<CreateContractAmendmentData>>): UseMutationOptions<CreateContractAmendmentResponse, CreateContractAmendmentError, Options<CreateContractAmendmentData>> => {
    const mutationOptions: UseMutationOptions<CreateContractAmendmentResponse, CreateContractAmendmentError, Options<CreateContractAmendmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContractAmendment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getContractAmendmentQueryKey = (options: Options<GetContractAmendmentData>) => createQueryKey('getContractAmendment', options);

/**
 * Un act adițional, așa cum a fost înregistrat.
 */
export const getContractAmendmentOptions = (options: Options<GetContractAmendmentData>) => queryOptions<GetContractAmendmentResponse, GetContractAmendmentError, GetContractAmendmentResponse, ReturnType<typeof getContractAmendmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContractAmendment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContractAmendmentQueryKey(options)
});

/**
 * DRAFT → CANCELLED; un contract activ nu se anulează, se încetează.
 */
export const cancelContractMutation = (options?: Partial<Options<CancelContractData>>): UseMutationOptions<CancelContractResponse, CancelContractError, Options<CancelContractData>> => {
    const mutationOptions: UseMutationOptions<CancelContractResponse, CancelContractError, Options<CancelContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getContractDocumentQueryKey = (options: Options<GetContractDocumentData>) => createQueryKey('getContractDocument', options);

/**
 * Descarcă unul dintre cele patru documente generate ale contractului, ca PDF.
 *
 * Documentul se generează la fiecare apel din datele contractului (părți, chirie, garanție, indexare, penalități) și nu este stocat până la M3; descărcarea este înregistrată în jurnalul de audit. Contractul de închiriere este marcat „proiect — nesemnat”. Procesul-verbal, inventarul și fișa de contoare se tipăresc cu tabelele goale, de completat la predare. Răspunsul poartă Content-Disposition: attachment cu un nume de fișier în limba română.
 */
export const getContractDocumentOptions = (options: Options<GetContractDocumentData>) => queryOptions<GetContractDocumentResponse, GetContractDocumentError, GetContractDocumentResponse, ReturnType<typeof getContractDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContractDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContractDocumentQueryKey(options)
});

/**
 * Generează un link fără cont pentru un contract: index sau incident.
 *
 * Linkul este un token sigilat, valabil pentru o singură acțiune, un singur contract și un singur chiriaș. Nu se stochează nicăieri: se întoarce o singură dată, în acest răspuns, și se trimite pe email dacă ceri asta. Cine îl are îl poate folosi până expiră sau până îl retragi.
 */
export const generatePortalLinkMutation = (options?: Partial<Options<GeneratePortalLinkData>>): UseMutationOptions<GeneratePortalLinkResponse, GeneratePortalLinkError, Options<GeneratePortalLinkData>> => {
    const mutationOptions: UseMutationOptions<GeneratePortalLinkResponse, GeneratePortalLinkError, Options<GeneratePortalLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatePortalLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retrage toate linkurile de acest tip emise pentru contract.
 *
 * Retragerea nu vizează un link anume — un token sigilat nu are rând de șters — ci momentul: tot ce a fost emis până acum pentru acest contract și această acțiune încetează să funcționeze. Emiterea unui link nou după retragere funcționează imediat.
 */
export const revokePortalLinksMutation = (options?: Partial<Options<RevokePortalLinksData>>): UseMutationOptions<RevokePortalLinksResponse, RevokePortalLinksError, Options<RevokePortalLinksData>> => {
    const mutationOptions: UseMutationOptions<RevokePortalLinksResponse, RevokePortalLinksError, Options<RevokePortalLinksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokePortalLinks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * ACTIVE → TERMINATED, cu data încetării și motivul; ambele obligatorii (422 contract-termination-incomplete).
 */
export const terminateContractMutation = (options?: Partial<Options<TerminateContractData>>): UseMutationOptions<TerminateContractResponse, TerminateContractError, Options<TerminateContractData>> => {
    const mutationOptions: UseMutationOptions<TerminateContractResponse, TerminateContractError, Options<TerminateContractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await terminateContract({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDocumentsQueryKey = (options?: Options<ListDocumentsData>) => createQueryKey('listDocuments', options);

/**
 * Arhiva de documente, filtrabilă și paginată.
 *
 * Filtre: „kind”, „linkedEntityType” + „linkedEntityId”, intervalul de emitere „issuedFrom”/„issuedTo” și „expiringWithinDays”. Ultimul întoarce documentele care expiră în intervalul cerut împreună cu cele deja expirate.
 */
export const listDocumentsOptions = (options?: Options<ListDocumentsData>) => queryOptions<ListDocumentsResponse, ListDocumentsError, ListDocumentsResponse, ReturnType<typeof listDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDocumentsQueryKey(options)
});

export const listDocumentsInfiniteQueryKey = (options?: Options<ListDocumentsData>): QueryKey<Options<ListDocumentsData>> => createQueryKey('listDocuments', options, true);

/**
 * Arhiva de documente, filtrabilă și paginată.
 *
 * Filtre: „kind”, „linkedEntityType” + „linkedEntityId”, intervalul de emitere „issuedFrom”/„issuedTo” și „expiringWithinDays”. Ultimul întoarce documentele care expiră în intervalul cerut împreună cu cele deja expirate.
 */
export const listDocumentsInfiniteOptions = (options?: Options<ListDocumentsData>) => {
    const opts = infiniteQueryOptions<ListDocumentsResponse, ListDocumentsError, InfiniteData<ListDocumentsResponse>, QueryKey<Options<ListDocumentsData>>, number | Pick<QueryKey<Options<ListDocumentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDocumentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDocuments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDocumentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Încarcă un document în arhivă (maximum 25 MB) și creează versiunea 1.
 *
 * Fișierul se trimite ca multipart/form-data, în câmpul „file”; metadatele se trimit ca câmpuri de formular în aceeași cerere. Extensiile acceptate sunt pdf, docx, jpg, jpeg, png, xlsx, csv și xml, iar conținutul trebuie să corespundă extensiei — altfel 422 „file-content-mismatch”. Documentele de tip ID_DOCUMENT, DECLARATION_PDF, DECLARATION_XML și RECIPISA se stochează criptat. Dacă organizația are deja exact aceiași octeți, răspunsul conține „alreadyInVault”: true — este o informație, nu un refuz.
 */
export const uploadDocumentMutation = (options?: Partial<Options<UploadDocumentData>>): UseMutationOptions<UploadDocumentResponse, UploadDocumentError, Options<UploadDocumentData>> => {
    const mutationOptions: UseMutationOptions<UploadDocumentResponse, UploadDocumentError, Options<UploadDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMyDocumentsQueryKey = (options?: Options<ListMyDocumentsData>) => createQueryKey('listMyDocuments', options);

/**
 * Documentele mele: tot ce privește apartamentele proprietarului și pe el personal.
 *
 * Întoarce, fără paginare, fiecare document care privește persoana autentificată ca proprietar: cele de pe apartamentele în care are o cotă curentă — atașate unui contract, unei polițe, unui incident, unei citiri de contor, unei cheltuieli sau facturi, dovezile de plată și de utilități trimise de chiriași — PDF-urile generate din contracte, declarațiile și dosarele fiscale proprii. Fiecare rând spune pe ce apartament stă, în ce categorie și de ce se află acolo. Documentele organizației care nu țin de un apartament nu apar. Cu „propertyId” lista se restrânge la un apartament; unul în care persoana nu are cotă răspunde 404.
 */
export const listMyDocumentsOptions = (options?: Options<ListMyDocumentsData>) => queryOptions<ListMyDocumentsResponse, ListMyDocumentsError, ListMyDocumentsResponse, ReturnType<typeof listMyDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMyDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMyDocumentsQueryKey(options)
});

/**
 * Scoate un document din arhivă (ștergere logică).
 *
 * Ștergerea este logică: rândul dispare din toate citirile, iar versiunile și fișierele rămân pe loc, pentru că 03 §12.3 interzice ștergerea unei versiuni. Un document la care trimite altă înregistrare — o factură, o declarație, un act adițional, o plată anunțată, o poliță, o revizie, un index sau o poză de intervenție — răspunde 422 document-referenced și nu se șterge.
 */
export const deleteDocumentMutation = (options?: Partial<Options<DeleteDocumentData>>): UseMutationOptions<DeleteDocumentResponse, DeleteDocumentError, Options<DeleteDocumentData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentResponse, DeleteDocumentError, Options<DeleteDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentQueryKey = (options: Options<GetDocumentData>) => createQueryKey('getDocument', options);

/**
 * Un document cu tot istoricul de versiuni, cel mai nou primul.
 */
export const getDocumentOptions = (options: Options<GetDocumentData>) => queryOptions<GetDocumentResponse, GetDocumentError, GetDocumentResponse, ReturnType<typeof getDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentQueryKey(options)
});

/**
 * Citește factura din document și întoarce câmpurile extrase, spre confirmare.
 *
 * Rulează conducta de extragere (02 §10) peste ultima versiune a documentului. Un document are cel mult o factură: prima citire creează factura în starea OCR_DONE sau OCR_FAILED, cu extragerea brută pe ea (201); o nouă citire a unui document a cărui factură nu a fost încă confirmată actualizează aceeași factură — același invoiceId, extragerea și starea înlocuite, câmpurile completate de mână păstrate (200). Dacă factura documentului a fost deja confirmată, citirea este refuzată cu 422 invoice-document-already-confirmed. Nu se creează niciun furnizor și nicio cheltuială — acestea apar abia la POST /api/v1/invoices/{id}/confirm. Dacă extragerea nu reușește, răspunsul este tot un succes, cu OCR_FAILED și codurile de avertizare: introducerea manuală rămâne disponibilă în orice caz. Cere Expenses.Write, pentru că scrie o factură.
 */
export const runInvoiceOcrMutation = (options?: Partial<Options<RunInvoiceOcrData>>): UseMutationOptions<RunInvoiceOcrResponse, RunInvoiceOcrError, Options<RunInvoiceOcrData>> => {
    const mutationOptions: UseMutationOptions<RunInvoiceOcrResponse, RunInvoiceOcrError, Options<RunInvoiceOcrData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runInvoiceOcr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Adaugă o versiune nouă a documentului; versiunile anterioare rămân neatinse.
 *
 * Numărul versiunii este stabilit de server (ultima + 1) și nu poate fi cerut. Versiunile sunt imutabile: v1 rămâne exact cum a fost încărcată, iar tabelul de versiuni nu acceptă UPDATE sau DELETE.
 */
export const addDocumentVersionMutation = (options?: Partial<Options<AddDocumentVersionData>>): UseMutationOptions<AddDocumentVersionResponse, AddDocumentVersionError, Options<AddDocumentVersionData>> => {
    const mutationOptions: UseMutationOptions<AddDocumentVersionResponse, AddDocumentVersionError, Options<AddDocumentVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addDocumentVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentVersionContentQueryKey = (options: Options<GetDocumentVersionContentData>) => createQueryKey('getDocumentVersionContent', options);

/**
 * Descarcă fișierul unei versiuni, prin flux autentificat și verificat RBAC.
 *
 * Singura cale prin care un fișier iese din volum: volumul nu este servit web și nu există nicio rută statică spre el. Documentele criptate se decriptează abia aici, după verificarea drepturilor.
 */
export const getDocumentVersionContentOptions = (options: Options<GetDocumentVersionContentData>) => queryOptions<GetDocumentVersionContentResponse, GetDocumentVersionContentError, GetDocumentVersionContentResponse, ReturnType<typeof getDocumentVersionContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocumentVersionContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentVersionContentQueryKey(options)
});

export const listEquipmentQueryKey = (options?: Options<ListEquipmentData>) => createQueryKey('listEquipment', options);

/**
 * Echipamentele organizației, paginate; filtrare după proprietate, tip, stare și scadență.
 */
export const listEquipmentOptions = (options?: Options<ListEquipmentData>) => queryOptions<ListEquipmentResponse, ListEquipmentError, ListEquipmentResponse, ReturnType<typeof listEquipmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEquipment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEquipmentQueryKey(options)
});

export const listEquipmentInfiniteQueryKey = (options?: Options<ListEquipmentData>): QueryKey<Options<ListEquipmentData>> => createQueryKey('listEquipment', options, true);

/**
 * Echipamentele organizației, paginate; filtrare după proprietate, tip, stare și scadență.
 */
export const listEquipmentInfiniteOptions = (options?: Options<ListEquipmentData>) => {
    const opts = infiniteQueryOptions<ListEquipmentResponse, ListEquipmentError, InfiniteData<ListEquipmentResponse>, QueryKey<Options<ListEquipmentData>>, number | Pick<QueryKey<Options<ListEquipmentData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListEquipmentData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listEquipment({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEquipmentInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă un echipament.
 *
 * Scadența (nextRevisionDate) nu se trimite: se calculează din ultima revizie plus periodicitate (03 §11.7) și se recalculează la fiecare salvare. Fără periodicitate echipamentul nu are scadență și nu intră în scara de alerte 60/30/14/7.
 */
export const createEquipmentMutation = (options?: Partial<Options<CreateEquipmentData>>): UseMutationOptions<CreateEquipmentResponse, CreateEquipmentError, Options<CreateEquipmentData>> => {
    const mutationOptions: UseMutationOptions<CreateEquipmentResponse, CreateEquipmentError, Options<CreateEquipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEquipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEquipmentTypeNamesQueryKey = (options?: Options<ListEquipmentTypeNamesData>) => createQueryKey('listEquipmentTypeNames', options);

/**
 * Denumirile date deja echipamentelor de tip OTHER, fiecare o singură dată.
 *
 * Lista din care formularul oferă din nou un tip adăugat de proprietar (ex. „Hotă”), ca să nu fie scris a doua oară. Nu este paginată: sunt denumiri, nu echipamente.
 */
export const listEquipmentTypeNamesOptions = (options?: Options<ListEquipmentTypeNamesData>) => queryOptions<ListEquipmentTypeNamesResponse, ListEquipmentTypeNamesError, ListEquipmentTypeNamesResponse, ReturnType<typeof listEquipmentTypeNamesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEquipmentTypeNames({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEquipmentTypeNamesQueryKey(options)
});

/**
 * Ștergere logică; istoricul de revizii rămâne.
 */
export const deleteEquipmentMutation = (options?: Partial<Options<DeleteEquipmentData>>): UseMutationOptions<DeleteEquipmentResponse, DeleteEquipmentError, Options<DeleteEquipmentData>> => {
    const mutationOptions: UseMutationOptions<DeleteEquipmentResponse, DeleteEquipmentError, Options<DeleteEquipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEquipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEquipmentQueryKey = (options: Options<GetEquipmentData>) => createQueryKey('getEquipment', options);

/**
 * Un echipament, cu scadența reviziei și câte sarcini are deschise.
 */
export const getEquipmentOptions = (options: Options<GetEquipmentData>) => queryOptions<GetEquipmentResponse, GetEquipmentError, GetEquipmentResponse, ReturnType<typeof getEquipmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEquipment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEquipmentQueryKey(options)
});

/**
 * Înlocuiește datele echipamentului și recalculează scadența.
 *
 * Scadența (nextRevisionDate) nu se trimite: se calculează din ultima revizie plus periodicitate (03 §11.7) și se recalculează la fiecare salvare. Fără periodicitate echipamentul nu are scadență și nu intră în scara de alerte 60/30/14/7.
 */
export const updateEquipmentMutation = (options?: Partial<Options<UpdateEquipmentData>>): UseMutationOptions<UpdateEquipmentResponse, UpdateEquipmentError, Options<UpdateEquipmentData>> => {
    const mutationOptions: UseMutationOptions<UpdateEquipmentResponse, UpdateEquipmentError, Options<UpdateEquipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEquipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Înregistrează o revizie efectuată.
 *
 * Închide sarcinile deschise pentru echipament, mută scadența cu o periodicitate și, dacă s-a trimis un cost, creează cheltuiala MAINTENANCE_SERVICE pe proprietate, legată de sarcinile închise. Necesită Idempotency-Key.
 */
export const recordEquipmentRevisionMutation = (options?: Partial<Options<RecordEquipmentRevisionData>>): UseMutationOptions<RecordEquipmentRevisionResponse, RecordEquipmentRevisionError, Options<RecordEquipmentRevisionData>> => {
    const mutationOptions: UseMutationOptions<RecordEquipmentRevisionResponse, RecordEquipmentRevisionError, Options<RecordEquipmentRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordEquipmentRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listExpenseCategoriesQueryKey = (options?: Options<ListExpenseCategoriesData>) => createQueryKey('listExpenseCategories', options);

/**
 * Catalogul de categorii: cele 30 globale plus cele proprii organizației, în ordinea de afișare.
 *
 * Categoria descrie economia unei cheltuieli, niciodată fiscalitatea: cashFlowOnly spune că suma iese din cont fără să fie cost în P&L, iar isCapexDefault dă valoarea implicită a indicatorului CapEx pe cheltuielile din categorie. Deductibilitatea nu este o proprietate a categoriei — se rezolvă pe (categorie, regim, an fiscal) și se înscrie pe rândul cheltuielii.
 */
export const listExpenseCategoriesOptions = (options?: Options<ListExpenseCategoriesData>) => queryOptions<ListExpenseCategoriesResponse, ListExpenseCategoriesError, ListExpenseCategoriesResponse, ReturnType<typeof listExpenseCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExpenseCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExpenseCategoriesQueryKey(options)
});

/**
 * Adaugă o categorie proprie organizației.
 *
 * Se pot crea și modifica doar categoriile proprii organizației. Cele 30 de coduri globale (03 §17.2) sunt comune tuturor și nu pot fi nici modificate (422 expense-category-global-read-only), nici redefinite sub același cod (422 expense-category-code-reserved). O categorie nu se șterge niciodată — cheltuielile înregistrate pe ea continuă să o numească — ci se dezactivează. Cele două indicatoare descriu economia categoriei și nu au nicio legătură cu deductibilitatea, care se stabilește pe rândul cheltuielii de motorul fiscal în M4.
 */
export const createExpenseCategoryMutation = (options?: Partial<Options<CreateExpenseCategoryData>>): UseMutationOptions<CreateExpenseCategoryResponse, CreateExpenseCategoryError, Options<CreateExpenseCategoryData>> => {
    const mutationOptions: UseMutationOptions<CreateExpenseCategoryResponse, CreateExpenseCategoryError, Options<CreateExpenseCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExpenseCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Înlocuiește o categorie proprie. O categorie globală este refuzată.
 *
 * Se pot crea și modifica doar categoriile proprii organizației. Cele 30 de coduri globale (03 §17.2) sunt comune tuturor și nu pot fi nici modificate (422 expense-category-global-read-only), nici redefinite sub același cod (422 expense-category-code-reserved). O categorie nu se șterge niciodată — cheltuielile înregistrate pe ea continuă să o numească — ci se dezactivează. Cele două indicatoare descriu economia categoriei și nu au nicio legătură cu deductibilitatea, care se stabilește pe rândul cheltuielii de motorul fiscal în M4.
 */
export const updateExpenseCategoryMutation = (options?: Partial<Options<UpdateExpenseCategoryData>>): UseMutationOptions<UpdateExpenseCategoryResponse, UpdateExpenseCategoryError, Options<UpdateExpenseCategoryData>> => {
    const mutationOptions: UseMutationOptions<UpdateExpenseCategoryResponse, UpdateExpenseCategoryError, Options<UpdateExpenseCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateExpenseCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Scoate din uz o categorie proprie. Cheltuielile existente o păstrează; nu se mai pot înregistra altele noi pe ea.
 */
export const deactivateExpenseCategoryMutation = (options?: Partial<Options<DeactivateExpenseCategoryData>>): UseMutationOptions<DeactivateExpenseCategoryResponse, DeactivateExpenseCategoryError, Options<DeactivateExpenseCategoryData>> => {
    const mutationOptions: UseMutationOptions<DeactivateExpenseCategoryResponse, DeactivateExpenseCategoryError, Options<DeactivateExpenseCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivateExpenseCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listExpensesQueryKey = (options?: Options<ListExpensesData>) => createQueryKey('listExpenses', options);

/**
 * Registrul de cheltuieli al organizației, paginat; filtre după proprietate, categorie, stare, perioadă, CapEx și origine (generată de o regulă recurentă sau introdusă punctual); totalurile întregului set filtrat pe fiecare monedă.
 */
export const listExpensesOptions = (options?: Options<ListExpensesData>) => queryOptions<ListExpensesResponse, ListExpensesError, ListExpensesResponse, ReturnType<typeof listExpensesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExpenses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExpensesQueryKey(options)
});

export const listExpensesInfiniteQueryKey = (options?: Options<ListExpensesData>): QueryKey<Options<ListExpensesData>> => createQueryKey('listExpenses', options, true);

/**
 * Registrul de cheltuieli al organizației, paginat; filtre după proprietate, categorie, stare, perioadă, CapEx și origine (generată de o regulă recurentă sau introdusă punctual); totalurile întregului set filtrat pe fiecare monedă.
 */
export const listExpensesInfiniteOptions = (options?: Options<ListExpensesData>) => {
    const opts = infiniteQueryOptions<ListExpensesResponse, ListExpensesError, InfiniteData<ListExpensesResponse>, QueryKey<Options<ListExpensesData>>, number | Pick<QueryKey<Options<ListExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listExpenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listExpensesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă o cheltuială pe o proprietate.
 *
 * Economicul și fiscalul sunt separate structural (03 §9): cheltuiala intră în rapoartele economice din momentul în care există, indiferent de statusul fiscal. deductibilityStatus nu se trimite niciodată de client — îl stabilește motorul fiscal în M4 (FISC-006) și până atunci este „necunoscut”. includeInPnl se deduce din categoria aleasă (cash_flow_only) și nu se trimite; isCapex preia implicit valoarea categoriei, dar poate fi setat explicit pe fiecare cheltuială.
 */
export const createExpenseMutation = (options?: Partial<Options<CreateExpenseData>>): UseMutationOptions<CreateExpenseResponse, CreateExpenseError, Options<CreateExpenseData>> => {
    const mutationOptions: UseMutationOptions<CreateExpenseResponse, CreateExpenseError, Options<CreateExpenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExpense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ștergere logică.
 */
export const deleteExpenseMutation = (options?: Partial<Options<DeleteExpenseData>>): UseMutationOptions<DeleteExpenseResponse, DeleteExpenseError, Options<DeleteExpenseData>> => {
    const mutationOptions: UseMutationOptions<DeleteExpenseResponse, DeleteExpenseError, Options<DeleteExpenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteExpense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExpenseQueryKey = (options: Options<GetExpenseData>) => createQueryKey('getExpense', options);

/**
 * O cheltuială, cu numele proprietății și ale categoriei.
 */
export const getExpenseOptions = (options: Options<GetExpenseData>) => queryOptions<GetExpenseResponse, GetExpenseError, GetExpenseResponse, ReturnType<typeof getExpenseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExpense({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExpenseQueryKey(options)
});

/**
 * Înlocuiește o cheltuială. Editarea unei cheltuieli din trecut este permisă și este auditată.
 *
 * Economicul și fiscalul sunt separate structural (03 §9): cheltuiala intră în rapoartele economice din momentul în care există, indiferent de statusul fiscal. deductibilityStatus nu se trimite niciodată de client — îl stabilește motorul fiscal în M4 (FISC-006) și până atunci este „necunoscut”. includeInPnl se deduce din categoria aleasă (cash_flow_only) și nu se trimite; isCapex preia implicit valoarea categoriei, dar poate fi setat explicit pe fiecare cheltuială.
 */
export const updateExpenseMutation = (options?: Partial<Options<UpdateExpenseData>>): UseMutationOptions<UpdateExpenseResponse, UpdateExpenseError, Options<UpdateExpenseData>> => {
    const mutationOptions: UseMutationOptions<UpdateExpenseResponse, UpdateExpenseError, Options<UpdateExpenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateExpense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmă celelalte venituri din coșul CASS pentru un proprietar și un an fiscal, apoi reevaluează obligațiile.
 *
 * Confirmarea coșului de venituri este declarația proprietarului, nu o consultanță fiscală. Coșul art. 155 alin. (1) lit. b)–h) cuprinde, pe lângă chirii, venituri pe care aplicația nu le cunoaște — dividende, dobânzi, câștiguri din investiții, alte surse — motiv pentru care CASS nu poate fi decisă din datele de chirie. Suma declarată se stochează în instantaneul evaluării, împreună cu momentul declarării, iar verdictul CASS este recalculat imediat. O declarație nouă creează o versiune nouă de evaluare; versiunile anterioare rămân neatinse și continuă să afișeze cifrele cu care au fost emise.
 */
export const confirmFiscalBasketMutation = (options?: Partial<Options<ConfirmFiscalBasketData>>): UseMutationOptions<ConfirmFiscalBasketResponse, ConfirmFiscalBasketError, Options<ConfirmFiscalBasketData>> => {
    const mutationOptions: UseMutationOptions<ConfirmFiscalBasketResponse, ConfirmFiscalBasketError, Options<ConfirmFiscalBasketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmFiscalBasket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFiscalCalendarQueryKey = (options?: Options<GetFiscalCalendarData>) => createQueryKey('getFiscalCalendar', options);

/**
 * Calendarul fiscal pentru o fereastră de timp, filtrabil după proprietate, formular, categorie și status.
 *
 * Calendarul fiscal adună într-o singură listă termenele care decurg din obligațiile evaluate de motorul de decizie și din regulile de referință versionate: declarația unică (D212) pe capitole, înregistrarea contractelor (C168) cu termenul de 30 de zile de la eveniment, fereastra de bonificație de 3% pentru veniturile 2025, ratele impozitului local pe clădiri (31 martie / 30 septembrie, sumele fiind introduse de utilizator) și, informativ, obligațiile chiriașului persoană juridică — D100 lunar și D205 anual. Datele afișate sunt cele efective: un termen care cade sâmbăta sau duminica este decalat, iar data legală rămâne disponibilă separat. Termenele pentru care regula seminală este marcată [VERIFY-FISCAL] sunt semnalate ca atare. Toate acestea sunt calcul automat pe baza regulilor fiscale versionate; nu constituie consultanță fiscală.
 */
export const getFiscalCalendarOptions = (options?: Options<GetFiscalCalendarData>) => queryOptions<GetFiscalCalendarResponse, GetFiscalCalendarError, GetFiscalCalendarResponse, ReturnType<typeof getFiscalCalendarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiscalCalendar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiscalCalendarQueryKey(options)
});

export const listFiscalDeclarationsQueryKey = (options?: Options<ListFiscalDeclarationsData>) => createQueryKey('listFiscalDeclarations', options);

/**
 * Registrul declarațiilor pregătite și starea lor de depunere, opțional filtrat.
 *
 * Aplicația pregătește și arhivează, dar nu depune: nu există un serviciu oficial care să primească D212 sau C168 prin API, iar această versiune nu efectuează niciun apel către ANAF. Fișierele generate se descarcă și se folosesc pentru completarea formularului oficial — declarația unică se depune din Spațiul Privat Virtual sau prin e-guvernare, iar C168 se încarcă în SPV, secțiunea „Depunere declarații”. Toate cifrele sunt calcul automat pe baza regulilor fiscale versionate; nu constituie consultanță fiscală.
 */
export const listFiscalDeclarationsOptions = (options?: Options<ListFiscalDeclarationsData>) => queryOptions<ListFiscalDeclarationsResponse, ListFiscalDeclarationsError, ListFiscalDeclarationsResponse, ReturnType<typeof listFiscalDeclarationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFiscalDeclarations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFiscalDeclarationsQueryKey(options)
});

/**
 * Pregătește sau regenerează declarația care răspunde unei obligații fiscale.
 *
 * Aplicația pregătește și arhivează, dar nu depune: nu există un serviciu oficial care să primească D212 sau C168 prin API, iar această versiune nu efectuează niciun apel către ANAF. Fișierele generate se descarcă și se folosesc pentru completarea formularului oficial — declarația unică se depune din Spațiul Privat Virtual sau prin e-guvernare, iar C168 se încarcă în SPV, secțiunea „Depunere declarații”. Toate cifrele sunt calcul automat pe baza regulilor fiscale versionate; nu constituie consultanță fiscală. Regenerarea creează o versiune nouă a declarației și o versiune nouă a fiecărui artefact; versiunile anterioare rămân neatinse, cu amprenta lor SHA-256. Fișierul XML se validează împotriva schemei ciclului de depunere înainte de a fi oferit; dacă schema oficială a ciclului nu este arhivată, documentul este marcat „schema în curs de publicare”.
 */
export const generateFiscalDeclarationMutation = (options?: Partial<Options<GenerateFiscalDeclarationData>>): UseMutationOptions<GenerateFiscalDeclarationResponse, GenerateFiscalDeclarationError, Options<GenerateFiscalDeclarationData>> => {
    const mutationOptions: UseMutationOptions<GenerateFiscalDeclarationResponse, GenerateFiscalDeclarationError, Options<GenerateFiscalDeclarationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateFiscalDeclaration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFiscalDeclarationQueryKey = (options: Options<GetFiscalDeclarationData>) => createQueryKey('getFiscalDeclaration', options);

/**
 * O declarație: valorile pe capitole cu explicații, artefactele stocate și istoricul versiunilor.
 *
 * Aplicația pregătește și arhivează, dar nu depune: nu există un serviciu oficial care să primească D212 sau C168 prin API, iar această versiune nu efectuează niciun apel către ANAF. Fișierele generate se descarcă și se folosesc pentru completarea formularului oficial — declarația unică se depune din Spațiul Privat Virtual sau prin e-guvernare, iar C168 se încarcă în SPV, secțiunea „Depunere declarații”. Toate cifrele sunt calcul automat pe baza regulilor fiscale versionate; nu constituie consultanță fiscală.
 */
export const getFiscalDeclarationOptions = (options: Options<GetFiscalDeclarationData>) => queryOptions<GetFiscalDeclarationResponse, GetFiscalDeclarationError, GetFiscalDeclarationResponse, ReturnType<typeof getFiscalDeclarationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiscalDeclaration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiscalDeclarationQueryKey(options)
});

/**
 * Confirmarea explicită a declarației înainte de depunere (necesită al doilea factor).
 *
 * Confirmarea este o acțiune a utilizatorului și nu poate fi făcută de un job. O declarație a cărei previzualizare are date lipsă blocante nu poate fi confirmată: regenerează previzualizarea după completarea datelor. Aplicația pregătește și arhivează, dar nu depune: nu există un serviciu oficial care să primească D212 sau C168 prin API, iar această versiune nu efectuează niciun apel către ANAF. Fișierele generate se descarcă și se folosesc pentru completarea formularului oficial — declarația unică se depune din Spațiul Privat Virtual sau prin e-guvernare, iar C168 se încarcă în SPV, secțiunea „Depunere declarații”. Toate cifrele sunt calcul automat pe baza regulilor fiscale versionate; nu constituie consultanță fiscală.
 */
export const confirmFiscalDeclarationMutation = (options?: Partial<Options<ConfirmFiscalDeclarationData>>): UseMutationOptions<ConfirmFiscalDeclarationResponse, ConfirmFiscalDeclarationError, Options<ConfirmFiscalDeclarationData>> => {
    const mutationOptions: UseMutationOptions<ConfirmFiscalDeclarationResponse, ConfirmFiscalDeclarationError, Options<ConfirmFiscalDeclarationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmFiscalDeclaration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deschide o declarație rectificativă pentru o declarație respinsă.
 *
 * Declarația respinsă rămâne în registru cu motivul respingerii; rectificativa este o versiune nouă care o referă. Pregătirea ei se face separat, după corectarea datelor. Jurnalul de depuneri manuale este singura sursă a stărilor „depusă”, „în procesare”, „acceptată” și „respinsă” în această versiune: utilizatorul înregistrează canalul, data și indexul de încărcare și încarcă recipisa. Indexul de încărcare este dovada primirii fișierului, nu a acceptării declarației — numai recipisa spune dacă declarația a fost validată. Tranzițiile ilegale se resping cu 422, iar fiecare tranziție se jurnalizează în trasabilitatea de audit.
 */
export const createFiscalDeclarationCorrectionMutation = (options?: Partial<Options<CreateFiscalDeclarationCorrectionData>>): UseMutationOptions<CreateFiscalDeclarationCorrectionResponse, CreateFiscalDeclarationCorrectionError, Options<CreateFiscalDeclarationCorrectionData>> => {
    const mutationOptions: UseMutationOptions<CreateFiscalDeclarationCorrectionResponse, CreateFiscalDeclarationCorrectionError, Options<CreateFiscalDeclarationCorrectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFiscalDeclarationCorrection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Înregistrează răspunsul din recipisă: în procesare, acceptată sau respinsă.
 *
 * Jurnalul de depuneri manuale este singura sursă a stărilor „depusă”, „în procesare”, „acceptată” și „respinsă” în această versiune: utilizatorul înregistrează canalul, data și indexul de încărcare și încarcă recipisa. Indexul de încărcare este dovada primirii fișierului, nu a acceptării declarației — numai recipisa spune dacă declarația a fost validată. Tranzițiile ilegale se resping cu 422, iar fiecare tranziție se jurnalizează în trasabilitatea de audit.
 */
export const recordFiscalDeclarationOutcomeMutation = (options?: Partial<Options<RecordFiscalDeclarationOutcomeData>>): UseMutationOptions<RecordFiscalDeclarationOutcomeResponse, RecordFiscalDeclarationOutcomeError, Options<RecordFiscalDeclarationOutcomeData>> => {
    const mutationOptions: UseMutationOptions<RecordFiscalDeclarationOutcomeResponse, RecordFiscalDeclarationOutcomeError, Options<RecordFiscalDeclarationOutcomeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordFiscalDeclarationOutcome({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Atașează recipisa descărcată din SPV, stocată ca document de tip RECIPISA.
 *
 * Fișierul se trimite ca multipart/form-data, în câmpul „file”, și se stochează criptat. Atașarea recipisei nu schimbă starea declarației: ce spune recipisa se înregistrează separat, pentru că aplicația nu citește documentul în locul dumneavoastră. Jurnalul de depuneri manuale este singura sursă a stărilor „depusă”, „în procesare”, „acceptată” și „respinsă” în această versiune: utilizatorul înregistrează canalul, data și indexul de încărcare și încarcă recipisa. Indexul de încărcare este dovada primirii fișierului, nu a acceptării declarației — numai recipisa spune dacă declarația a fost validată. Tranzițiile ilegale se resping cu 422, iar fiecare tranziție se jurnalizează în trasabilitatea de audit.
 */
export const uploadFiscalDeclarationRecipisaMutation = (options?: Partial<Options<UploadFiscalDeclarationRecipisaData>>): UseMutationOptions<UploadFiscalDeclarationRecipisaResponse, UploadFiscalDeclarationRecipisaError, Options<UploadFiscalDeclarationRecipisaData>> => {
    const mutationOptions: UseMutationOptions<UploadFiscalDeclarationRecipisaResponse, UploadFiscalDeclarationRecipisaError, Options<UploadFiscalDeclarationRecipisaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadFiscalDeclarationRecipisa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Înregistrează depunerea: canalul, data și indexul de încărcare.
 *
 * Jurnalul de depuneri manuale este singura sursă a stărilor „depusă”, „în procesare”, „acceptată” și „respinsă” în această versiune: utilizatorul înregistrează canalul, data și indexul de încărcare și încarcă recipisa. Indexul de încărcare este dovada primirii fișierului, nu a acceptării declarației — numai recipisa spune dacă declarația a fost validată. Tranzițiile ilegale se resping cu 422, iar fiecare tranziție se jurnalizează în trasabilitatea de audit.
 */
export const recordFiscalDeclarationSubmissionMutation = (options?: Partial<Options<RecordFiscalDeclarationSubmissionData>>): UseMutationOptions<RecordFiscalDeclarationSubmissionResponse, RecordFiscalDeclarationSubmissionError, Options<RecordFiscalDeclarationSubmissionData>> => {
    const mutationOptions: UseMutationOptions<RecordFiscalDeclarationSubmissionResponse, RecordFiscalDeclarationSubmissionError, Options<RecordFiscalDeclarationSubmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordFiscalDeclarationSubmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFiscalObligationsQueryKey = (options?: Options<ListFiscalObligationsData>) => createQueryKey('listFiscalObligations', options);

/**
 * Obligațiile fiscale evaluate de motorul de decizie, opțional filtrate după proprietar și an fiscal. Include verdictele NOT_REQUIRED.
 *
 * Motorul de decizie evaluează, pentru fiecare proprietar × an fiscal × formular, intrările spec §16 și emite un verdict: REQUIRED, NEEDS_VERIFICATION sau NOT_REQUIRED. Verdictele NOT_REQUIRED se returnează ca oricare altele — absența obligației este un răspuns, nu o lipsă, și are aceeași explicație stocată. Motorul nu presupune niciodată o obligație doar pentru că există chirie: CASS rămâne NEEDS_VERIFICATION până când proprietarul confirmă întregul coș de venituri, iar un proprietar cu chiriași exclusiv persoane juridice (reținere la sursă finală) primește NOT_REQUIRED pe capitolul impozit pe venit, cu motivele citate. Toate cifrele sunt calcul automat pe baza regulilor fiscale versionate; nu constituie consultanță fiscală.
 */
export const listFiscalObligationsOptions = (options?: Options<ListFiscalObligationsData>) => queryOptions<ListFiscalObligationsResponse, ListFiscalObligationsError, ListFiscalObligationsResponse, ReturnType<typeof listFiscalObligationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFiscalObligations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFiscalObligationsQueryKey(options)
});

export const getFiscalObligationQueryKey = (options: Options<GetFiscalObligationData>) => createQueryKey('getFiscalObligation', options);

/**
 * O obligație și explicația ei stocată: raționamentul în română, valorile folosite, regulile citate cu versiunea lor și evaluarea care o susține.
 *
 * Motorul de decizie evaluează, pentru fiecare proprietar × an fiscal × formular, intrările spec §16 și emite un verdict: REQUIRED, NEEDS_VERIFICATION sau NOT_REQUIRED. Verdictele NOT_REQUIRED se returnează ca oricare altele — absența obligației este un răspuns, nu o lipsă, și are aceeași explicație stocată. Motorul nu presupune niciodată o obligație doar pentru că există chirie: CASS rămâne NEEDS_VERIFICATION până când proprietarul confirmă întregul coș de venituri, iar un proprietar cu chiriași exclusiv persoane juridice (reținere la sursă finală) primește NOT_REQUIRED pe capitolul impozit pe venit, cu motivele citate. Toate cifrele sunt calcul automat pe baza regulilor fiscale versionate; nu constituie consultanță fiscală.
 */
export const getFiscalObligationOptions = (options: Options<GetFiscalObligationData>) => queryOptions<GetFiscalObligationResponse, GetFiscalObligationError, GetFiscalObligationResponse, ReturnType<typeof getFiscalObligationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiscalObligation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiscalObligationQueryKey(options)
});

export const getFiscalProfileQueryKey = (options?: Options<GetFiscalProfileData>) => createQueryKey('getFiscalProfile', options);

/**
 * Profilul fiscal al proprietarilor organizației: tipul de contribuabil, regimul anului și cotele de coproprietate.
 *
 * Profilul fiscal al fiecărui proprietar: tipul de contribuabil pe care se sprijină întregul motor, regimul în care regulile anului îl așază — într-o frază compusă pe server, nu în interfață — și cotele de coproprietate curente, cu proprietarul desemnat pentru înregistrarea contractului. Ecranul este numai de citire: tipul de contribuabil se modifică pe /api/v1/owners/{id}, iar cotele pe /api/v1/properties/{id}/ownership-shares. Pentru un proprietar persoană juridică nu se citează nicio regulă: regimul societății — microîntreprindere sau impozit pe profit — nu se stabilește din datele acestei aplicații.
 */
export const getFiscalProfileOptions = (options?: Options<GetFiscalProfileData>) => queryOptions<GetFiscalProfileResponse, GetFiscalProfileError, GetFiscalProfileResponse, ReturnType<typeof getFiscalProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiscalProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiscalProfileQueryKey(options)
});

export const getFiscalRuleContextQueryKey = (options?: Options<GetFiscalRuleContextData>) => createQueryKey('getFiscalRuleContext', options);

/**
 * Sursele oficiale ale regulilor fiscale ale anului, cu data ultimei validări, și fereastra de bonificație dacă este deschisă.
 *
 * Proveniența regulilor fiscale ale anului: actul oficial pe care fiecare regulă îl citează și data la care a fost ultima oară verificat de un om față de sursa lui. Este ceea ce afișează componenta de disclaimer pe fiecare ecran fiscal (spec §38): calculul este automat, pe baza unor reguli versionate, și nu constituie consultanță fiscală. Răspunsul nu conține nicio cotă, niciun prag și nicio deducere — nimic din ce ar permite un calcul fiscal în interfață. Fereastra de bonificație apare doar cât timp este deschisă, iar «deschisă» se decide pe server, după calendarul românesc.
 */
export const getFiscalRuleContextOptions = (options?: Options<GetFiscalRuleContextData>) => queryOptions<GetFiscalRuleContextResponse, GetFiscalRuleContextError, GetFiscalRuleContextResponse, ReturnType<typeof getFiscalRuleContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiscalRuleContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiscalRuleContextQueryKey(options)
});

export const getPortfolioHealthScoresQueryKey = (options?: Options<GetPortfolioHealthScoresData>) => createQueryKey('getPortfolioHealthScores', options);

/**
 * Sănătatea portofoliului: media scorurilor, câte proprietăți sunt verzi, chihlimbar și roșii, și câte un rând pentru fiecare proprietate cu scorul, banda și variația față de măsurătoarea anterioară.
 *
 * Scorul de sănătate al unei proprietăți: 0–100, recalculat în fiecare noapte și după evenimentele majore (încasare, schimbare de contract). Este suma a cinci componente cu ponderi fixe — Financiar 35, Contract 20, Mentenanță și revizii 15, Documente și asigurări 10, Conformitate fiscală 20 — fiecare pornind de la ponderea ei și pierzând puncte din catalogul de penalizări. Benzi: 80–100 verde, 50–79 chihlimbar, 0–49 roșu. Fiecare punct pierdut este explicat: penalizarea are cod, puncte, mesaj și o referință către rândul care a produs-o. Cheltuielile cu domeniul PERSONAL („Chiriaș la rândul meu”) nu intră în nicio componentă. Scorurile sunt istoric, nu cache: există un singur rând pe proprietate pe zi, zilele trecute nu se rescriu, iar tendința se citește din rânduri și nu se recalculează. Media este media aritmetică neponderată a proprietăților care au un scor; proprietățile încă nescorate apar în listă, dar nu intră în medie.
 */
export const getPortfolioHealthScoresOptions = (options?: Options<GetPortfolioHealthScoresData>) => queryOptions<GetPortfolioHealthScoresResponse, GetPortfolioHealthScoresError, GetPortfolioHealthScoresResponse, ReturnType<typeof getPortfolioHealthScoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolioHealthScores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioHealthScoresQueryKey(options)
});

export const getPropertyHealthScoreQueryKey = (options: Options<GetPropertyHealthScoreData>) => createQueryKey('getPropertyHealthScore', options);

/**
 * Scorul unei proprietăți cu descompunerea completă pe cele cinci componente și penalizările fiecăreia, plus tendința din ultimele zile; 404 dacă proprietatea nu există.
 *
 * Scorul de sănătate al unei proprietăți: 0–100, recalculat în fiecare noapte și după evenimentele majore (încasare, schimbare de contract). Este suma a cinci componente cu ponderi fixe — Financiar 35, Contract 20, Mentenanță și revizii 15, Documente și asigurări 10, Conformitate fiscală 20 — fiecare pornind de la ponderea ei și pierzând puncte din catalogul de penalizări. Benzi: 80–100 verde, 50–79 chihlimbar, 0–49 roșu. Fiecare punct pierdut este explicat: penalizarea are cod, puncte, mesaj și o referință către rândul care a produs-o. Cheltuielile cu domeniul PERSONAL („Chiriaș la rândul meu”) nu intră în nicio componentă. Scorurile sunt istoric, nu cache: există un singur rând pe proprietate pe zi, zilele trecute nu se rescriu, iar tendința se citește din rânduri și nu se recalculează. Descompunerea este redată exact așa cum a fost stocată în momentul calculului, niciodată recalculată la citire — un scor istoric păstrează ponderile și penalizările cu care a fost calculat. trendDays: câte zile în urmă citește graficul (implicit 90, maximum 365).
 */
export const getPropertyHealthScoreOptions = (options: Options<GetPropertyHealthScoreData>) => queryOptions<GetPropertyHealthScoreResponse, GetPropertyHealthScoreError, GetPropertyHealthScoreResponse, ReturnType<typeof getPropertyHealthScoreQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPropertyHealthScore({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPropertyHealthScoreQueryKey(options)
});

export const listInsurancesQueryKey = (options?: Options<ListInsurancesData>) => createQueryKey('listInsurances', options);

/**
 * Polițele organizației, paginate, cele care expiră primele.
 */
export const listInsurancesOptions = (options?: Options<ListInsurancesData>) => queryOptions<ListInsurancesResponse, ListInsurancesError, ListInsurancesResponse, ReturnType<typeof listInsurancesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInsurances({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInsurancesQueryKey(options)
});

export const listInsurancesInfiniteQueryKey = (options?: Options<ListInsurancesData>): QueryKey<Options<ListInsurancesData>> => createQueryKey('listInsurances', options, true);

/**
 * Polițele organizației, paginate, cele care expiră primele.
 */
export const listInsurancesInfiniteOptions = (options?: Options<ListInsurancesData>) => {
    const opts = infiniteQueryOptions<ListInsurancesResponse, ListInsurancesError, InfiniteData<ListInsurancesResponse>, QueryKey<Options<ListInsurancesData>>, number | Pick<QueryKey<Options<ListInsurancesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListInsurancesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listInsurances({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInsurancesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă o poliță sau reînnoiește una existentă cu o perioadă nouă.
 *
 * O reînnoire este o poliță nouă, nu o editare: perioada care expiră rămâne în istoric (05 MAINT-005). recordPremiumExpense se aplică doar la creare — o poliță deja legată de o cheltuială nu creează a doua.
 */
export const createInsuranceMutation = (options?: Partial<Options<CreateInsuranceData>>): UseMutationOptions<CreateInsuranceResponse, CreateInsuranceError, Options<CreateInsuranceData>> => {
    const mutationOptions: UseMutationOptions<CreateInsuranceResponse, CreateInsuranceError, Options<CreateInsuranceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createInsurance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ștergere logică; cheltuiala cu prima rămâne în registru.
 */
export const deleteInsuranceMutation = (options?: Partial<Options<DeleteInsuranceData>>): UseMutationOptions<DeleteInsuranceResponse, DeleteInsuranceError, Options<DeleteInsuranceData>> => {
    const mutationOptions: UseMutationOptions<DeleteInsuranceResponse, DeleteInsuranceError, Options<DeleteInsuranceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInsurance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInsuranceQueryKey = (options: Options<GetInsuranceData>) => createQueryKey('getInsurance', options);

/**
 * O poliță, cu numărul de zile rămase până la expirare.
 */
export const getInsuranceOptions = (options: Options<GetInsuranceData>) => queryOptions<GetInsuranceResponse, GetInsuranceError, GetInsuranceResponse, ReturnType<typeof getInsuranceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInsurance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInsuranceQueryKey(options)
});

/**
 * Corectează datele unei polițe.
 *
 * O reînnoire este o poliță nouă, nu o editare: perioada care expiră rămâne în istoric (05 MAINT-005). recordPremiumExpense se aplică doar la creare — o poliță deja legată de o cheltuială nu creează a doua.
 */
export const updateInsuranceMutation = (options?: Partial<Options<UpdateInsuranceData>>): UseMutationOptions<UpdateInsuranceResponse, UpdateInsuranceError, Options<UpdateInsuranceData>> => {
    const mutationOptions: UseMutationOptions<UpdateInsuranceResponse, UpdateInsuranceError, Options<UpdateInsuranceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateInsurance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Acceptă o invitație și creează calitatea de membru în organizația care a trimis-o.
 */
export const acceptInvitationMutation = (options?: Partial<Options<AcceptInvitationData>>): UseMutationOptions<AcceptInvitationResponse, AcceptInvitationError, Options<AcceptInvitationData>> => {
    const mutationOptions: UseMutationOptions<AcceptInvitationResponse, AcceptInvitationError, Options<AcceptInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInvitationPreviewQueryKey = (options: Options<GetInvitationPreviewData>) => createQueryKey('getInvitationPreview', options);

/**
 * Adresa către care a fost trimisă invitația, pentru formularele de intrare.
 *
 * Rută publică: tokenul este singura autorizație. Răspunde doar pentru o invitație încă valabilă; una expirată, folosită sau anulată primește 404. `email` este null pentru un link deschis, care nu numește pe nimeni.
 */
export const getInvitationPreviewOptions = (options: Options<GetInvitationPreviewData>) => queryOptions<GetInvitationPreviewResponse, GetInvitationPreviewError, GetInvitationPreviewResponse, ReturnType<typeof getInvitationPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvitationPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvitationPreviewQueryKey(options)
});

export const listInvoicesQueryKey = (options?: Options<ListInvoicesData>) => createQueryKey('listInvoices', options);

/**
 * Facturile primite, paginate; filtre după furnizor, stare și perioadă, căutare după număr sau serie.
 */
export const listInvoicesOptions = (options?: Options<ListInvoicesData>) => queryOptions<ListInvoicesResponse, ListInvoicesError, ListInvoicesResponse, ReturnType<typeof listInvoicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInvoices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvoicesQueryKey(options)
});

export const listInvoicesInfiniteQueryKey = (options?: Options<ListInvoicesData>): QueryKey<Options<ListInvoicesData>> => createQueryKey('listInvoices', options, true);

/**
 * Facturile primite, paginate; filtre după furnizor, stare și perioadă, căutare după număr sau serie.
 */
export const listInvoicesInfiniteOptions = (options?: Options<ListInvoicesData>) => {
    const opts = infiniteQueryOptions<ListInvoicesResponse, ListInvoicesError, InfiniteData<ListInvoicesResponse>, QueryKey<Options<ListInvoicesData>>, number | Pick<QueryKey<Options<ListInvoicesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListInvoicesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listInvoices({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInvoicesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă o factură introdusă manual, cu sau fără furnizor din registru.
 *
 * Introducere manuală: factura se tastează, nu se încarcă. Documentul scanat (documentId) apare odată cu arhiva de documente (M3), iar completarea automată prin OCR odată cu DOC-002 — până atunci câmpul rămâne gol și factura se salvează fără el. Starea nu se trimite: o factură introdusă manual este CONFIRMED, confirmată de persoana care a tastat-o. Legătura cu cheltuielile se face din partea cheltuielii (invoiceId pe /api/v1/expenses), pentru că o factură poate acoperi mai multe cheltuieli.
 */
export const createInvoiceMutation = (options?: Partial<Options<CreateInvoiceData>>): UseMutationOptions<CreateInvoiceResponse, CreateInvoiceError, Options<CreateInvoiceData>> => {
    const mutationOptions: UseMutationOptions<CreateInvoiceResponse, CreateInvoiceError, Options<CreateInvoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createInvoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ștergere logică; cheltuielile legate rămân, fără factură.
 */
export const deleteInvoiceMutation = (options?: Partial<Options<DeleteInvoiceData>>): UseMutationOptions<DeleteInvoiceResponse, DeleteInvoiceError, Options<DeleteInvoiceData>> => {
    const mutationOptions: UseMutationOptions<DeleteInvoiceResponse, DeleteInvoiceError, Options<DeleteInvoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInvoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInvoiceQueryKey = (options: Options<GetInvoiceData>) => createQueryKey('getInvoice', options);

/**
 * O factură, cu numele furnizorului și numărul de cheltuieli legate de ea.
 */
export const getInvoiceOptions = (options: Options<GetInvoiceData>) => queryOptions<GetInvoiceResponse, GetInvoiceError, GetInvoiceResponse, ReturnType<typeof getInvoiceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvoice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvoiceQueryKey(options)
});

/**
 * Înlocuiește datele facturii; numărul este refuzat (422 invoice-number-taken) dacă furnizorul are deja o factură cu el.
 *
 * Introducere manuală: factura se tastează, nu se încarcă. Documentul scanat (documentId) apare odată cu arhiva de documente (M3), iar completarea automată prin OCR odată cu DOC-002 — până atunci câmpul rămâne gol și factura se salvează fără el. Starea nu se trimite: o factură introdusă manual este CONFIRMED, confirmată de persoana care a tastat-o. Legătura cu cheltuielile se face din partea cheltuielii (invoiceId pe /api/v1/expenses), pentru că o factură poate acoperi mai multe cheltuieli.
 */
export const updateInvoiceMutation = (options?: Partial<Options<UpdateInvoiceData>>): UseMutationOptions<UpdateInvoiceResponse, UpdateInvoiceError, Options<UpdateInvoiceData>> => {
    const mutationOptions: UseMutationOptions<UpdateInvoiceResponse, UpdateInvoiceError, Options<UpdateInvoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateInvoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmă datele citite prin OCR și creează furnizorul, factura și cheltuiala.
 *
 * Se trimite după POST /api/v1/documents/{id}/ocr, cu valorile așa cum le-a lăsat utilizatorul pe ecranul de confirmare. Ce se întâmplă: furnizorul se caută după CUI și se creează dacă lipsește, factura trece în CONFIRMED păstrându-și neatinsă extragerea brută (ocrPayload), iar cheltuiala se creează pe proprietatea și categoria confirmate. O factură care nu se află într-o stare OCR este refuzată cu 422 invoice-not-awaiting-confirmation. Necesită Idempotency-Key: o retrimitere cu aceeași cheie întoarce primul răspuns și nu creează nimic a doua oară.
 */
export const confirmInvoiceMutation = (options?: Partial<Options<ConfirmInvoiceData>>): UseMutationOptions<ConfirmInvoiceResponse, ConfirmInvoiceError, Options<ConfirmInvoiceData>> => {
    const mutationOptions: UseMutationOptions<ConfirmInvoiceResponse, ConfirmInvoiceError, Options<ConfirmInvoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmInvoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPortalLinkContextQueryKey = (options: Options<GetPortalLinkContextData>) => createQueryKey('getPortalLinkContext', options);

/**
 * Ce deschide acest link: acțiunea, adresa proprietății și, la index, contoarele.
 *
 * Rută publică: nu are nevoie de autentificare. Tokenul din cale este singura autorizație — un token modificat sau expirat primește 401, iar unul emis pentru altă acțiune primește 403. Datele afișate sunt minime: adresa proprietății și atât.
 */
export const getPortalLinkContextOptions = (options: Options<GetPortalLinkContextData>) => queryOptions<GetPortalLinkContextResponse, GetPortalLinkContextError, GetPortalLinkContextResponse, ReturnType<typeof getPortalLinkContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortalLinkContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortalLinkContextQueryKey(options)
});

/**
 * Raportează un incident, prin link, fără cont.
 *
 * Proprietatea și chiriașul sunt ale tokenului, nu ale corpului cererii, iar sursa tichetului este întotdeauna „prin link”. Un link de index primește 403 portal-link-wrong-purpose.
 */
export const reportPortalLinkIncidentMutation = (options?: Partial<Options<ReportPortalLinkIncidentData>>): UseMutationOptions<ReportPortalLinkIncidentResponse, ReportPortalLinkIncidentError, Options<ReportPortalLinkIncidentData>> => {
    const mutationOptions: UseMutationOptions<ReportPortalLinkIncidentResponse, ReportPortalLinkIncidentError, Options<ReportPortalLinkIncidentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reportPortalLinkIncident({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trimite indexul unui contor, prin link, fără cont.
 *
 * Citirea este marcată „prin link, fără cont”: sursa este PUBLIC_LINK și nu se trimite de client. Trimiterea în afara ferestrei lunare a organizației este refuzată cu 422 portal-meter-window-closed, iar un link de incident primește 403 portal-link-wrong-purpose.
 */
export const submitPortalLinkMeterReadingMutation = (options?: Partial<Options<SubmitPortalLinkMeterReadingData>>): UseMutationOptions<SubmitPortalLinkMeterReadingResponse, SubmitPortalLinkMeterReadingError, Options<SubmitPortalLinkMeterReadingData>> => {
    const mutationOptions: UseMutationOptions<SubmitPortalLinkMeterReadingResponse, SubmitPortalLinkMeterReadingError, Options<SubmitPortalLinkMeterReadingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitPortalLinkMeterReading({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Încarcă o fotografie și primește id-ul ei, pentru index sau incident.
 *
 * Fișierul se trimite ca multipart/form-data în câmpul „file”. Tipul documentului nu se trimite: îl decide scopul linkului. Se aplică limitele arhivei — maximum 25 MB, extensii permise, conținut care corespunde extensiei.
 */
export const uploadPortalLinkPhotoMutation = (options?: Partial<Options<UploadPortalLinkPhotoData>>): UseMutationOptions<UploadPortalLinkPhotoResponse, UploadPortalLinkPhotoError, Options<UploadPortalLinkPhotoData>> => {
    const mutationOptions: UseMutationOptions<UploadPortalLinkPhotoResponse, UploadPortalLinkPhotoError, Options<UploadPortalLinkPhotoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadPortalLinkPhoto({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyNotificationPreferencesQueryKey = (options?: Options<GetMyNotificationPreferencesData>) => createQueryKey('getMyNotificationPreferences', options);

/**
 * Preferințele proprii de notificare, câte una pe familie de reguli.
 *
 * Canalele pe care acest utilizator vrea să primească fiecare familie de reguli. isOverride=false înseamnă că nu a ales nimic și moștenește canalele organizației. IN_APP nu poate fi oprit (01 BR-NOTIF-05). Notificările INFORMATIV nu se trimit pe e-mail decât dacă utilizatorul a cerut explicit EMAIL pentru familia respectivă. PUSH, SMS și WHATSAPP există în enum și nu se trimit niciodată în V1.
 */
export const getMyNotificationPreferencesOptions = (options?: Options<GetMyNotificationPreferencesData>) => queryOptions<GetMyNotificationPreferencesResponse, GetMyNotificationPreferencesError, GetMyNotificationPreferencesResponse, ReturnType<typeof getMyNotificationPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyNotificationPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyNotificationPreferencesQueryKey(options)
});

/**
 * Schimbă preferințele proprii; channels=null pentru o familie revine la canalele organizației.
 *
 * Canalele pe care acest utilizator vrea să primească fiecare familie de reguli. isOverride=false înseamnă că nu a ales nimic și moștenește canalele organizației. IN_APP nu poate fi oprit (01 BR-NOTIF-05). Notificările INFORMATIV nu se trimit pe e-mail decât dacă utilizatorul a cerut explicit EMAIL pentru familia respectivă. PUSH, SMS și WHATSAPP există în enum și nu se trimit niciodată în V1.
 */
export const updateMyNotificationPreferencesMutation = (options?: Partial<Options<UpdateMyNotificationPreferencesData>>): UseMutationOptions<UpdateMyNotificationPreferencesResponse, UpdateMyNotificationPreferencesError, Options<UpdateMyNotificationPreferencesData>> => {
    const mutationOptions: UseMutationOptions<UpdateMyNotificationPreferencesResponse, UpdateMyNotificationPreferencesError, Options<UpdateMyNotificationPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMyNotificationPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listNotificationRulesQueryKey = (options?: Options<ListNotificationRulesData>) => createQueryKey('listNotificationRules', options);

/**
 * Regulile de notificare ale organizației.
 *
 * Cele opt familii de reguli ale organizației. alertOffsetsDays este scara, în zile: se citește ÎNAINTE de termen pentru expirări și DUPĂ scadență pentru restanțe, iar la fiecare rulare se aprinde doar treapta atinsă — treptele trecute nu se retrimit. channels acceptă doar IN_APP și EMAIL; IN_APP rămâne întotdeauna, pentru că livrarea în aplicație a unei notificări CRITIC nu poate fi oprită (01 BR-NOTIF-05). emailQuietHours („21:00-08:00”) amână doar e-mailul, niciodată fluxul din aplicație. Regulile nu se creează și nu se șterg: sunt scrise la înregistrarea organizației.
 */
export const listNotificationRulesOptions = (options?: Options<ListNotificationRulesData>) => queryOptions<ListNotificationRulesResponse, ListNotificationRulesError, ListNotificationRulesResponse, ReturnType<typeof listNotificationRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listNotificationRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNotificationRulesQueryKey(options)
});

/**
 * Schimbă una sau mai multe reguli; familiile nenumite rămân neatinse.
 *
 * Cele opt familii de reguli ale organizației. alertOffsetsDays este scara, în zile: se citește ÎNAINTE de termen pentru expirări și DUPĂ scadență pentru restanțe, iar la fiecare rulare se aprinde doar treapta atinsă — treptele trecute nu se retrimit. channels acceptă doar IN_APP și EMAIL; IN_APP rămâne întotdeauna, pentru că livrarea în aplicație a unei notificări CRITIC nu poate fi oprită (01 BR-NOTIF-05). emailQuietHours („21:00-08:00”) amână doar e-mailul, niciodată fluxul din aplicație. Regulile nu se creează și nu se șterg: sunt scrise la înregistrarea organizației.
 */
export const updateNotificationRulesMutation = (options?: Partial<Options<UpdateNotificationRulesData>>): UseMutationOptions<UpdateNotificationRulesResponse, UpdateNotificationRulesError, Options<UpdateNotificationRulesData>> => {
    const mutationOptions: UseMutationOptions<UpdateNotificationRulesResponse, UpdateNotificationRulesError, Options<UpdateNotificationRulesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateNotificationRules({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listNotificationsQueryKey = (options?: Options<ListNotificationsData>) => createQueryKey('listNotifications', options);

/**
 * Notificările organizației, paginate: necitite întâi, grupate pe prioritate, cele mai noi primele.
 *
 * Inbox-ul organizației. Ordinea este fixă și nu se poate schimba din query string: necitite înaintea citite, apoi CRITIC înaintea IMPORTANT înaintea INFORMATIV, apoi cele mai noi primele. Este exact ordinea pe care o afișează SCR-NOTIF-001 și previzualizarea de 10 rânduri din clopoțelul din antet. Notificările sunt ale organizației, nu ale unui utilizator: „citit” este starea inboxului organizației. Fiecare rând poartă deep link-ul către sursa lui.
 */
export const listNotificationsOptions = (options?: Options<ListNotificationsData>) => queryOptions<ListNotificationsResponse, ListNotificationsError, ListNotificationsResponse, ReturnType<typeof listNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNotificationsQueryKey(options)
});

export const listNotificationsInfiniteQueryKey = (options?: Options<ListNotificationsData>): QueryKey<Options<ListNotificationsData>> => createQueryKey('listNotifications', options, true);

/**
 * Notificările organizației, paginate: necitite întâi, grupate pe prioritate, cele mai noi primele.
 *
 * Inbox-ul organizației. Ordinea este fixă și nu se poate schimba din query string: necitite înaintea citite, apoi CRITIC înaintea IMPORTANT înaintea INFORMATIV, apoi cele mai noi primele. Este exact ordinea pe care o afișează SCR-NOTIF-001 și previzualizarea de 10 rânduri din clopoțelul din antet. Notificările sunt ale organizației, nu ale unui utilizator: „citit” este starea inboxului organizației. Fiecare rând poartă deep link-ul către sursa lui.
 */
export const listNotificationsInfiniteOptions = (options?: Options<ListNotificationsData>) => {
    const opts = infiniteQueryOptions<ListNotificationsResponse, ListNotificationsError, InfiniteData<ListNotificationsResponse>, QueryKey<Options<ListNotificationsData>>, number | Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listNotifications({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listNotificationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Marchează toate notificările necitite drept citite.
 */
export const markAllNotificationsReadMutation = (options?: Partial<Options<MarkAllNotificationsReadData>>): UseMutationOptions<MarkAllNotificationsReadResponse, MarkAllNotificationsReadError, Options<MarkAllNotificationsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAllNotificationsReadResponse, MarkAllNotificationsReadError, Options<MarkAllNotificationsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAllNotificationsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUnreadNotificationCountQueryKey = (options?: Options<GetUnreadNotificationCountData>) => createQueryKey('getUnreadNotificationCount', options);

/**
 * Câte notificări sunt necitite — badge-ul clopoțelului.
 */
export const getUnreadNotificationCountOptions = (options?: Options<GetUnreadNotificationCountData>) => queryOptions<GetUnreadNotificationCountResponse, GetUnreadNotificationCountError, GetUnreadNotificationCountResponse, ReturnType<typeof getUnreadNotificationCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUnreadNotificationCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUnreadNotificationCountQueryKey(options)
});

/**
 * Marchează o notificare drept citită.
 */
export const markNotificationReadMutation = (options?: Partial<Options<MarkNotificationReadData>>): UseMutationOptions<MarkNotificationReadResponse, MarkNotificationReadError, Options<MarkNotificationReadData>> => {
    const mutationOptions: UseMutationOptions<MarkNotificationReadResponse, MarkNotificationReadError, Options<MarkNotificationReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markNotificationRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGdprErasuresQueryKey = (options: Options<ListGdprErasuresData>) => createQueryKey('listGdprErasures', options);

/**
 * Cererile de ștergere ale organizației, cea mai nouă prima.
 *
 * Ștergerea datelor unei persoane se face în doi pași. Primul pas înregistrează cererea și deschide o perioadă în care cererea poate fi retrasă; al doilea pas, confirmarea, este posibil abia după încheierea acestei perioade și este ireversibil. Fiecare cerere poartă lista a ceea ce se șterge și a ceea ce se păstrează — arhiva fiscală (evaluări, declarații, recipise) și jurnalul de audit se păstrează pe durata termenului legal și nu pot fi șterse la cerere.
 */
export const listGdprErasuresOptions = (options: Options<ListGdprErasuresData>) => queryOptions<ListGdprErasuresResponse, ListGdprErasuresError, ListGdprErasuresResponse, ReturnType<typeof listGdprErasuresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listGdprErasures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listGdprErasuresQueryKey(options)
});

export const listGdprErasuresInfiniteQueryKey = (options: Options<ListGdprErasuresData>): QueryKey<Options<ListGdprErasuresData>> => createQueryKey('listGdprErasures', options, true);

/**
 * Cererile de ștergere ale organizației, cea mai nouă prima.
 *
 * Ștergerea datelor unei persoane se face în doi pași. Primul pas înregistrează cererea și deschide o perioadă în care cererea poate fi retrasă; al doilea pas, confirmarea, este posibil abia după încheierea acestei perioade și este ireversibil. Fiecare cerere poartă lista a ceea ce se șterge și a ceea ce se păstrează — arhiva fiscală (evaluări, declarații, recipise) și jurnalul de audit se păstrează pe durata termenului legal și nu pot fi șterse la cerere.
 */
export const listGdprErasuresInfiniteOptions = (options: Options<ListGdprErasuresData>) => {
    const opts = infiniteQueryOptions<ListGdprErasuresResponse, ListGdprErasuresError, InfiniteData<ListGdprErasuresResponse>, QueryKey<Options<ListGdprErasuresData>>, number | Pick<QueryKey<Options<ListGdprErasuresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListGdprErasuresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listGdprErasures({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGdprErasuresInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Pasul 1: înregistrează cererea de ștergere și deschide perioada de retragere.
 *
 * Ștergerea datelor unei persoane se face în doi pași. Primul pas înregistrează cererea și deschide o perioadă în care cererea poate fi retrasă; al doilea pas, confirmarea, este posibil abia după încheierea acestei perioade și este ireversibil. Fiecare cerere poartă lista a ceea ce se șterge și a ceea ce se păstrează — arhiva fiscală (evaluări, declarații, recipise) și jurnalul de audit se păstrează pe durata termenului legal și nu pot fi șterse la cerere.
 */
export const requestGdprErasureMutation = (options?: Partial<Options<RequestGdprErasureData>>): UseMutationOptions<RequestGdprErasureResponse, RequestGdprErasureError, Options<RequestGdprErasureData>> => {
    const mutationOptions: UseMutationOptions<RequestGdprErasureResponse, RequestGdprErasureError, Options<RequestGdprErasureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestGdprErasure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retrage o cerere aflată în perioada de retragere.
 *
 * Ștergerea datelor unei persoane se face în doi pași. Primul pas înregistrează cererea și deschide o perioadă în care cererea poate fi retrasă; al doilea pas, confirmarea, este posibil abia după încheierea acestei perioade și este ireversibil. Fiecare cerere poartă lista a ceea ce se șterge și a ceea ce se păstrează — arhiva fiscală (evaluări, declarații, recipise) și jurnalul de audit se păstrează pe durata termenului legal și nu pot fi șterse la cerere.
 */
export const cancelGdprErasureMutation = (options?: Partial<Options<CancelGdprErasureData>>): UseMutationOptions<CancelGdprErasureResponse, CancelGdprErasureError, Options<CancelGdprErasureData>> => {
    const mutationOptions: UseMutationOptions<CancelGdprErasureResponse, CancelGdprErasureError, Options<CancelGdprErasureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelGdprErasure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGdprErasureQueryKey = (options: Options<GetGdprErasureData>) => createQueryKey('getGdprErasure', options);

/**
 * O cerere, cu lista a ceea ce se șterge și a ceea ce se păstrează.
 *
 * Ștergerea datelor unei persoane se face în doi pași. Primul pas înregistrează cererea și deschide o perioadă în care cererea poate fi retrasă; al doilea pas, confirmarea, este posibil abia după încheierea acestei perioade și este ireversibil. Fiecare cerere poartă lista a ceea ce se șterge și a ceea ce se păstrează — arhiva fiscală (evaluări, declarații, recipise) și jurnalul de audit se păstrează pe durata termenului legal și nu pot fi șterse la cerere.
 */
export const getGdprErasureOptions = (options: Options<GetGdprErasureData>) => queryOptions<GetGdprErasureResponse, GetGdprErasureError, GetGdprErasureResponse, ReturnType<typeof getGdprErasureQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGdprErasure({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGdprErasureQueryKey(options)
});

/**
 * Pasul 2: execută ștergerea. Ireversibil (necesită al doilea factor).
 *
 * Ștergerea datelor unei persoane se face în doi pași. Primul pas înregistrează cererea și deschide o perioadă în care cererea poate fi retrasă; al doilea pas, confirmarea, este posibil abia după încheierea acestei perioade și este ireversibil. Fiecare cerere poartă lista a ceea ce se șterge și a ceea ce se păstrează — arhiva fiscală (evaluări, declarații, recipise) și jurnalul de audit se păstrează pe durata termenului legal și nu pot fi șterse la cerere.
 */
export const confirmGdprErasureMutation = (options?: Partial<Options<ConfirmGdprErasureData>>): UseMutationOptions<ConfirmGdprErasureResponse, ConfirmGdprErasureError, Options<ConfirmGdprErasureData>> => {
    const mutationOptions: UseMutationOptions<ConfirmGdprErasureResponse, ConfirmGdprErasureError, Options<ConfirmGdprErasureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmGdprErasure({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGdprExportsQueryKey = (options: Options<ListGdprExportsData>) => createQueryKey('listGdprExports', options);

/**
 * Exporturile cerute de organizație, cel mai nou primul.
 *
 * Exportul organizației, conform art. 20 GDPR: toate familiile de date pe care le păstrăm pentru organizație, ca fișiere JSON, plus toate documentele încărcate, într-o singură arhivă ZIP. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. Parolele, codurile de recuperare, jetoanele și CNP-urile criptate nu ajung în arhivă: în locul lor apare marcajul „[redactat]”. Linkul de descărcare expiră; după expirare se cere un export nou.
 */
export const listGdprExportsOptions = (options: Options<ListGdprExportsData>) => queryOptions<ListGdprExportsResponse, ListGdprExportsError, ListGdprExportsResponse, ReturnType<typeof listGdprExportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listGdprExports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listGdprExportsQueryKey(options)
});

export const listGdprExportsInfiniteQueryKey = (options: Options<ListGdprExportsData>): QueryKey<Options<ListGdprExportsData>> => createQueryKey('listGdprExports', options, true);

/**
 * Exporturile cerute de organizație, cel mai nou primul.
 *
 * Exportul organizației, conform art. 20 GDPR: toate familiile de date pe care le păstrăm pentru organizație, ca fișiere JSON, plus toate documentele încărcate, într-o singură arhivă ZIP. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. Parolele, codurile de recuperare, jetoanele și CNP-urile criptate nu ajung în arhivă: în locul lor apare marcajul „[redactat]”. Linkul de descărcare expiră; după expirare se cere un export nou.
 */
export const listGdprExportsInfiniteOptions = (options: Options<ListGdprExportsData>) => {
    const opts = infiniteQueryOptions<ListGdprExportsResponse, ListGdprExportsError, InfiniteData<ListGdprExportsResponse>, QueryKey<Options<ListGdprExportsData>>, number | Pick<QueryKey<Options<ListGdprExportsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListGdprExportsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listGdprExports({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGdprExportsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Cere exportul complet al datelor organizației (necesită al doilea factor).
 *
 * Exportul organizației, conform art. 20 GDPR: toate familiile de date pe care le păstrăm pentru organizație, ca fișiere JSON, plus toate documentele încărcate, într-o singură arhivă ZIP. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. Parolele, codurile de recuperare, jetoanele și CNP-urile criptate nu ajung în arhivă: în locul lor apare marcajul „[redactat]”. Linkul de descărcare expiră; după expirare se cere un export nou.
 */
export const requestGdprExportMutation = (options?: Partial<Options<RequestGdprExportData>>): UseMutationOptions<RequestGdprExportResponse, RequestGdprExportError, Options<RequestGdprExportData>> => {
    const mutationOptions: UseMutationOptions<RequestGdprExportResponse, RequestGdprExportError, Options<RequestGdprExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestGdprExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGdprExportQueryKey = (options: Options<GetGdprExportData>) => createQueryKey('getGdprExport', options);

/**
 * Starea unui export, pentru ecranul care așteaptă construirea arhivei.
 *
 * Exportul organizației, conform art. 20 GDPR: toate familiile de date pe care le păstrăm pentru organizație, ca fișiere JSON, plus toate documentele încărcate, într-o singură arhivă ZIP. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. Parolele, codurile de recuperare, jetoanele și CNP-urile criptate nu ajung în arhivă: în locul lor apare marcajul „[redactat]”. Linkul de descărcare expiră; după expirare se cere un export nou.
 */
export const getGdprExportOptions = (options: Options<GetGdprExportData>) => queryOptions<GetGdprExportResponse, GetGdprExportError, GetGdprExportResponse, ReturnType<typeof getGdprExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGdprExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGdprExportQueryKey(options)
});

export const downloadGdprExportQueryKey = (options: Options<DownloadGdprExportData>) => createQueryKey('downloadGdprExport', options);

/**
 * Descarcă arhiva. Descărcarea se jurnalizează în trasabilitatea de audit.
 *
 * Exportul organizației, conform art. 20 GDPR: toate familiile de date pe care le păstrăm pentru organizație, ca fișiere JSON, plus toate documentele încărcate, într-o singură arhivă ZIP. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. Parolele, codurile de recuperare, jetoanele și CNP-urile criptate nu ajung în arhivă: în locul lor apare marcajul „[redactat]”. Linkul de descărcare expiră; după expirare se cere un export nou.
 */
export const downloadGdprExportOptions = (options: Options<DownloadGdprExportData>) => queryOptions<DownloadGdprExportResponse, DownloadGdprExportError, DownloadGdprExportResponse, ReturnType<typeof downloadGdprExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadGdprExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadGdprExportQueryKey(options)
});

export const getRetentionPolicyQueryKey = (options: Options<GetRetentionPolicyData>) => createQueryKey('getRetentionPolicy', options);

/**
 * Termenele de păstrare configurate pentru organizație.
 *
 * Termenele de păstrare a datelor organizației. Termenul arhivei fiscale este un minim legal: poate fi mărit, niciodată micșorat.
 */
export const getRetentionPolicyOptions = (options: Options<GetRetentionPolicyData>) => queryOptions<GetRetentionPolicyResponse, GetRetentionPolicyError, GetRetentionPolicyResponse, ReturnType<typeof getRetentionPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRetentionPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRetentionPolicyQueryKey(options)
});

/**
 * Schimbă termenele de păstrare.
 *
 * Termenele de păstrare a datelor organizației. Termenul arhivei fiscale este un minim legal: poate fi mărit, niciodată micșorat.
 */
export const updateRetentionPolicyMutation = (options?: Partial<Options<UpdateRetentionPolicyData>>): UseMutationOptions<UpdateRetentionPolicyResponse, UpdateRetentionPolicyError, Options<UpdateRetentionPolicyData>> => {
    const mutationOptions: UseMutationOptions<UpdateRetentionPolicyResponse, UpdateRetentionPolicyError, Options<UpdateRetentionPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRetentionPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationInvitationsQueryKey = (options: Options<ListOrganizationInvitationsData>) => createQueryKey('listOrganizationInvitations', options);

/**
 * Invitațiile organizației, în toate stările.
 */
export const listOrganizationInvitationsOptions = (options: Options<ListOrganizationInvitationsData>) => queryOptions<ListOrganizationInvitationsResponse, ListOrganizationInvitationsError, ListOrganizationInvitationsResponse, ReturnType<typeof listOrganizationInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationInvitationsQueryKey(options)
});

/**
 * Invită o persoană prin email, cu rol de administrator, contabil sau proprietar.
 */
export const inviteOrganizationMemberMutation = (options?: Partial<Options<InviteOrganizationMemberData>>): UseMutationOptions<InviteOrganizationMemberResponse, InviteOrganizationMemberError, Options<InviteOrganizationMemberData>> => {
    const mutationOptions: UseMutationOptions<InviteOrganizationMemberResponse, InviteOrganizationMemberError, Options<InviteOrganizationMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await inviteOrganizationMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Anulează o invitație în așteptare, astfel încât linkul să nu mai poată fi folosit.
 */
export const revokeOrganizationInvitationMutation = (options?: Partial<Options<RevokeOrganizationInvitationData>>): UseMutationOptions<RevokeOrganizationInvitationResponse, RevokeOrganizationInvitationError, Options<RevokeOrganizationInvitationData>> => {
    const mutationOptions: UseMutationOptions<RevokeOrganizationInvitationResponse, RevokeOrganizationInvitationError, Options<RevokeOrganizationInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeOrganizationInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationMembersQueryKey = (options: Options<ListOrganizationMembersData>) => createQueryKey('listOrganizationMembers', options);

/**
 * Membrii organizației, cu rolul și starea fiecăruia.
 */
export const listOrganizationMembersOptions = (options: Options<ListOrganizationMembersData>) => queryOptions<ListOrganizationMembersResponse, ListOrganizationMembersError, ListOrganizationMembersResponse, ReturnType<typeof listOrganizationMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationMembersQueryKey(options)
});

/**
 * Schimbă rolul unui membru; modificarea este auditată cu valoarea veche și cea nouă.
 */
export const changeOrganizationMemberRoleMutation = (options?: Partial<Options<ChangeOrganizationMemberRoleData>>): UseMutationOptions<ChangeOrganizationMemberRoleResponse, ChangeOrganizationMemberRoleError, Options<ChangeOrganizationMemberRoleData>> => {
    const mutationOptions: UseMutationOptions<ChangeOrganizationMemberRoleResponse, ChangeOrganizationMemberRoleError, Options<ChangeOrganizationMemberRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeOrganizationMemberRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dezactivează un membru; accesul încetează la reîmprospătarea permisiunilor.
 */
export const deactivateOrganizationMemberMutation = (options?: Partial<Options<DeactivateOrganizationMemberData>>): UseMutationOptions<DeactivateOrganizationMemberResponse, DeactivateOrganizationMemberError, Options<DeactivateOrganizationMemberData>> => {
    const mutationOptions: UseMutationOptions<DeactivateOrganizationMemberResponse, DeactivateOrganizationMemberError, Options<DeactivateOrganizationMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivateOrganizationMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOwnStaffQueryKey = (options: Options<ListOwnStaffData>) => createQueryKey('listOwnStaff', options);

/**
 * Contabilul și administratorul care lucrează pentru utilizatorul curent.
 */
export const listOwnStaffOptions = (options: Options<ListOwnStaffData>) => queryOptions<ListOwnStaffResponse, ListOwnStaffError, ListOwnStaffResponse, ReturnType<typeof listOwnStaffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOwnStaff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOwnStaffQueryKey(options)
});

/**
 * Retrage accesul unui contabil sau administrator la portofoliul propriu.
 */
export const revokeOwnStaffMutation = (options?: Partial<Options<RevokeOwnStaffData>>): UseMutationOptions<RevokeOwnStaffResponse, RevokeOwnStaffError, Options<RevokeOwnStaffData>> => {
    const mutationOptions: UseMutationOptions<RevokeOwnStaffResponse, RevokeOwnStaffError, Options<RevokeOwnStaffData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeOwnStaff({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOwnerTenanciesQueryKey = (options?: Options<ListOwnerTenanciesData>) => createQueryKey('listOwnerTenancies', options);

/**
 * Închirierile în care proprietarul este el însuși chiriaș, cele active întâi; includeInactive le aduce și pe cele oprite.
 *
 * „Chiriaș la rândul meu” este relația în care proprietarul este el însuși chiriaș. NU este o proprietate și NU este un contract: nu produce scadențe, nu are motor de restanțe și nu generează penalități. Cheltuielile personale legate de ea (scope = PERSONAL) sunt excluse din toate rapoartele economice ale portofoliului, din cash-flow, din scorurile de sănătate și din întreaga evaluare fiscală.
 */
export const listOwnerTenanciesOptions = (options?: Options<ListOwnerTenanciesData>) => queryOptions<ListOwnerTenanciesResponse, ListOwnerTenanciesError, ListOwnerTenanciesResponse, ReturnType<typeof listOwnerTenanciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOwnerTenancies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOwnerTenanciesQueryKey(options)
});

/**
 * Ștergere logică. Refuzată cât timp există cheltuieli personale pe închiriere — acelea se păstrează, iar închirierea se dezactivează.
 */
export const deleteOwnerTenancyMutation = (options?: Partial<Options<DeleteOwnerTenancyData>>): UseMutationOptions<DeleteOwnerTenancyResponse, DeleteOwnerTenancyError, Options<DeleteOwnerTenancyData>> => {
    const mutationOptions: UseMutationOptions<DeleteOwnerTenancyResponse, DeleteOwnerTenancyError, Options<DeleteOwnerTenancyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOwnerTenancy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOwnerTenancyQueryKey = (options: Options<GetOwnerTenancyData>) => createQueryKey('getOwnerTenancy', options);

/**
 * O închiriere, cu proprietarul, chiria, ziua scadenței, garanția și câte cheltuieli personale sunt înregistrate pe ea.
 */
export const getOwnerTenancyOptions = (options: Options<GetOwnerTenancyData>) => queryOptions<GetOwnerTenancyResponse, GetOwnerTenancyError, GetOwnerTenancyResponse, ReturnType<typeof getOwnerTenancyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOwnerTenancy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOwnerTenancyQueryKey(options)
});

/**
 * Înlocuiește datele închirierii. Nu o oprește: pentru asta există dezactivarea.
 */
export const updateOwnerTenancyMutation = (options?: Partial<Options<UpdateOwnerTenancyData>>): UseMutationOptions<UpdateOwnerTenancyResponse, UpdateOwnerTenancyError, Options<UpdateOwnerTenancyData>> => {
    const mutationOptions: UseMutationOptions<UpdateOwnerTenancyResponse, UpdateOwnerTenancyError, Options<UpdateOwnerTenancyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOwnerTenancy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Oprește mementourile „de plătit chiria”. Cheltuielile personale rămân, iar rezumatul lunilor trecute răspunde mai departe.
 */
export const deactivateOwnerTenancyMutation = (options?: Partial<Options<DeactivateOwnerTenancyData>>): UseMutationOptions<DeactivateOwnerTenancyResponse, DeactivateOwnerTenancyError, Options<DeactivateOwnerTenancyData>> => {
    const mutationOptions: UseMutationOptions<DeactivateOwnerTenancyResponse, DeactivateOwnerTenancyError, Options<DeactivateOwnerTenancyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivateOwnerTenancy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOwnerTenancySummaryQueryKey = (options: Options<GetOwnerTenancySummaryData>) => createQueryKey('getOwnerTenancySummary', options);

/**
 * Rezumatul unei luni: chiria contractată și cheltuielile personale pe categorii. Fără an și lună, luna curentă din România.
 *
 * Chiria și totalurile cheltuielilor NU se adună: chiria este cifra de pe închiriere, iar totalurile sunt suma rândurilor din app.expenses. Pot fi și în monede diferite, iar monedele nu se adună niciodată între ele.
 */
export const getOwnerTenancySummaryOptions = (options: Options<GetOwnerTenancySummaryData>) => queryOptions<GetOwnerTenancySummaryResponse, GetOwnerTenancySummaryError, GetOwnerTenancySummaryResponse, ReturnType<typeof getOwnerTenancySummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOwnerTenancySummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOwnerTenancySummaryQueryKey(options)
});

export const listOwnerTenancyExpensesQueryKey = (options: Options<ListOwnerTenancyExpensesData>) => createQueryKey('listOwnerTenancyExpenses', options);

/**
 * Registrul de cheltuieli personale al unei închirieri („Chiriaș la rândul meu”), paginat; 404 dacă închirierea nu există.
 *
 * Cheltuielile personale („Chiriaș la rândul meu”) NU apar în P&L-ul portofoliului, în cash-flow, în scorurile proprietăților sau în evaluarea fiscală. Acesta este singurul registru care le vede, iar totalurile economice ale subsolului sunt zero pentru ele: regulile E1 și E2 din 03 §16.3 nu se aplică unui cost personal.
 */
export const listOwnerTenancyExpensesOptions = (options: Options<ListOwnerTenancyExpensesData>) => queryOptions<ListOwnerTenancyExpensesResponse, ListOwnerTenancyExpensesError, ListOwnerTenancyExpensesResponse, ReturnType<typeof listOwnerTenancyExpensesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOwnerTenancyExpenses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOwnerTenancyExpensesQueryKey(options)
});

export const listOwnerTenancyExpensesInfiniteQueryKey = (options: Options<ListOwnerTenancyExpensesData>): QueryKey<Options<ListOwnerTenancyExpensesData>> => createQueryKey('listOwnerTenancyExpenses', options, true);

/**
 * Registrul de cheltuieli personale al unei închirieri („Chiriaș la rândul meu”), paginat; 404 dacă închirierea nu există.
 *
 * Cheltuielile personale („Chiriaș la rândul meu”) NU apar în P&L-ul portofoliului, în cash-flow, în scorurile proprietăților sau în evaluarea fiscală. Acesta este singurul registru care le vede, iar totalurile economice ale subsolului sunt zero pentru ele: regulile E1 și E2 din 03 §16.3 nu se aplică unui cost personal.
 */
export const listOwnerTenancyExpensesInfiniteOptions = (options: Options<ListOwnerTenancyExpensesData>) => {
    const opts = infiniteQueryOptions<ListOwnerTenancyExpensesResponse, ListOwnerTenancyExpensesError, InfiniteData<ListOwnerTenancyExpensesResponse>, QueryKey<Options<ListOwnerTenancyExpensesData>>, number | Pick<QueryKey<Options<ListOwnerTenancyExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListOwnerTenancyExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listOwnerTenancyExpenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listOwnerTenancyExpensesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listOwnerTenancyRecurringExpensesQueryKey = (options: Options<ListOwnerTenancyRecurringExpensesData>) => createQueryKey('listOwnerTenancyRecurringExpenses', options);

/**
 * Regulile de cheltuieli recurente ale unei închirieri („Chiriaș la rândul meu”), paginate; 404 dacă închirierea nu există.
 *
 * Regulile personale generează cheltuieli cu scope = PERSONAL, care nu intră în niciun raport economic al portofoliului, în cash-flow, în scorurile de sănătate sau în evaluarea fiscală (01 §23 BR-OAT-03). Ele nu apar în registrul de reguli al portofoliului, iar regulile portofoliului nu apar aici.
 */
export const listOwnerTenancyRecurringExpensesOptions = (options: Options<ListOwnerTenancyRecurringExpensesData>) => queryOptions<ListOwnerTenancyRecurringExpensesResponse, ListOwnerTenancyRecurringExpensesError, ListOwnerTenancyRecurringExpensesResponse, ReturnType<typeof listOwnerTenancyRecurringExpensesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOwnerTenancyRecurringExpenses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOwnerTenancyRecurringExpensesQueryKey(options)
});

export const listOwnerTenancyRecurringExpensesInfiniteQueryKey = (options: Options<ListOwnerTenancyRecurringExpensesData>): QueryKey<Options<ListOwnerTenancyRecurringExpensesData>> => createQueryKey('listOwnerTenancyRecurringExpenses', options, true);

/**
 * Regulile de cheltuieli recurente ale unei închirieri („Chiriaș la rândul meu”), paginate; 404 dacă închirierea nu există.
 *
 * Regulile personale generează cheltuieli cu scope = PERSONAL, care nu intră în niciun raport economic al portofoliului, în cash-flow, în scorurile de sănătate sau în evaluarea fiscală (01 §23 BR-OAT-03). Ele nu apar în registrul de reguli al portofoliului, iar regulile portofoliului nu apar aici.
 */
export const listOwnerTenancyRecurringExpensesInfiniteOptions = (options: Options<ListOwnerTenancyRecurringExpensesData>) => {
    const opts = infiniteQueryOptions<ListOwnerTenancyRecurringExpensesResponse, ListOwnerTenancyRecurringExpensesError, InfiniteData<ListOwnerTenancyRecurringExpensesResponse>, QueryKey<Options<ListOwnerTenancyRecurringExpensesData>>, number | Pick<QueryKey<Options<ListOwnerTenancyRecurringExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListOwnerTenancyRecurringExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listOwnerTenancyRecurringExpenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listOwnerTenancyRecurringExpensesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiV1OwnersQueryKey = (options?: Options<GetApiV1OwnersData>) => createQueryKey('getApiV1Owners', options);

export const getApiV1OwnersOptions = (options?: Options<GetApiV1OwnersData>) => queryOptions<GetApiV1OwnersResponse, GetApiV1OwnersError, GetApiV1OwnersResponse, ReturnType<typeof getApiV1OwnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1Owners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OwnersQueryKey(options)
});

export const getApiV1OwnersInfiniteQueryKey = (options?: Options<GetApiV1OwnersData>): QueryKey<Options<GetApiV1OwnersData>> => createQueryKey('getApiV1Owners', options, true);

export const getApiV1OwnersInfiniteOptions = (options?: Options<GetApiV1OwnersData>) => {
    const opts = infiniteQueryOptions<GetApiV1OwnersResponse, GetApiV1OwnersError, InfiniteData<GetApiV1OwnersResponse>, QueryKey<Options<GetApiV1OwnersData>>, number | Pick<QueryKey<Options<GetApiV1OwnersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiV1OwnersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiV1Owners({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiV1OwnersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postApiV1OwnersMutation = (options?: Partial<Options<PostApiV1OwnersData>>): UseMutationOptions<PostApiV1OwnersResponse, PostApiV1OwnersError, Options<PostApiV1OwnersData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1OwnersResponse, PostApiV1OwnersError, Options<PostApiV1OwnersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1Owners({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Tipul de contribuabil al utilizatorului conectat, în toate organizațiile în care este proprietar.
 *
 * Persoana conectată declară o singură dată dacă închiriază ca persoană fizică sau prin firmă, iar valoarea se scrie pe rândul ei de proprietar din fiecare organizație în care este proprietar — într-o singură tranzacție. Este singura scriere a ecranului „Profil fiscal” (SCR-FISC-006): tipul de contribuabil este coloana pe care se sprijină întregul motor fiscal, iar un proprietar care are firmă într-o organizație și este persoană fizică în alta nu este o stare pe care acest produs să o poată explica. Nu atinge niciun coproprietar: rândurile sunt găsite după contul conectat. Un utilizator care nu este proprietar nicăieri primește 404 — un contabil invitat în portofoliul altcuiva nu are un tip de contribuabil al lui de declarat.
 */
export const setMyTaxpayerTypeMutation = (options?: Partial<Options<SetMyTaxpayerTypeData>>): UseMutationOptions<SetMyTaxpayerTypeResponse, SetMyTaxpayerTypeError, Options<SetMyTaxpayerTypeData>> => {
    const mutationOptions: UseMutationOptions<SetMyTaxpayerTypeResponse, SetMyTaxpayerTypeError, Options<SetMyTaxpayerTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setMyTaxpayerType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1OwnersByIdQueryKey = (options: Options<GetApiV1OwnersByIdData>) => createQueryKey('getApiV1OwnersById', options);

export const getApiV1OwnersByIdOptions = (options: Options<GetApiV1OwnersByIdData>) => queryOptions<GetApiV1OwnersByIdResponse, GetApiV1OwnersByIdError, GetApiV1OwnersByIdResponse, ReturnType<typeof getApiV1OwnersByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1OwnersById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1OwnersByIdQueryKey(options)
});

export const putApiV1OwnersByIdMutation = (options?: Partial<Options<PutApiV1OwnersByIdData>>): UseMutationOptions<PutApiV1OwnersByIdResponse, PutApiV1OwnersByIdError, Options<PutApiV1OwnersByIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1OwnersByIdResponse, PutApiV1OwnersByIdError, Options<PutApiV1OwnersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1OwnersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1OwnershipTransfersByIdAcceptMutation = (options?: Partial<Options<PostApiV1OwnershipTransfersByIdAcceptData>>): UseMutationOptions<PostApiV1OwnershipTransfersByIdAcceptResponse, PostApiV1OwnershipTransfersByIdAcceptError, Options<PostApiV1OwnershipTransfersByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1OwnershipTransfersByIdAcceptResponse, PostApiV1OwnershipTransfersByIdAcceptError, Options<PostApiV1OwnershipTransfersByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1OwnershipTransfersByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1OwnershipTransfersByIdDeclineMutation = (options?: Partial<Options<PostApiV1OwnershipTransfersByIdDeclineData>>): UseMutationOptions<PostApiV1OwnershipTransfersByIdDeclineResponse, PostApiV1OwnershipTransfersByIdDeclineError, Options<PostApiV1OwnershipTransfersByIdDeclineData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1OwnershipTransfersByIdDeclineResponse, PostApiV1OwnershipTransfersByIdDeclineError, Options<PostApiV1OwnershipTransfersByIdDeclineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1OwnershipTransfersByIdDecline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPaymentsQueryKey = (options?: Options<ListPaymentsData>) => createQueryKey('listPayments', options);

/**
 * Încasările organizației, paginate; filtre după contract, proprietate, interval de dată, metodă și credit nerepartizat.
 */
export const listPaymentsOptions = (options?: Options<ListPaymentsData>) => queryOptions<ListPaymentsResponse, ListPaymentsError, ListPaymentsResponse, ReturnType<typeof listPaymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPayments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPaymentsQueryKey(options)
});

export const listPaymentsInfiniteQueryKey = (options?: Options<ListPaymentsData>): QueryKey<Options<ListPaymentsData>> => createQueryKey('listPayments', options, true);

/**
 * Încasările organizației, paginate; filtre după contract, proprietate, interval de dată, metodă și credit nerepartizat.
 */
export const listPaymentsInfiniteOptions = (options?: Options<ListPaymentsData>) => {
    const opts = infiniteQueryOptions<ListPaymentsResponse, ListPaymentsError, InfiniteData<ListPaymentsResponse>, QueryKey<Options<ListPaymentsData>>, number | Pick<QueryKey<Options<ListPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPayments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPaymentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Înregistrează o încasare și o repartizează pe scadențe: implicit „cea mai veche scadență întâi”, sau după repartizarea trimisă. Restul rămâne credit al chiriașului. Necesită Idempotency-Key.
 */
export const registerPaymentMutation = (options?: Partial<Options<RegisterPaymentData>>): UseMutationOptions<RegisterPaymentResponse, RegisterPaymentError, Options<RegisterPaymentData>> => {
    const mutationOptions: UseMutationOptions<RegisterPaymentResponse, RegisterPaymentError, Options<RegisterPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Simulează repartizarea unei sume pe scadențele unui contract, fără a scrie nimic: propunerea, creditul rămas și dacă înregistrarea ar fi refuzată pentru plată parțială.
 */
export const previewPaymentAllocationMutation = (options?: Partial<Options<PreviewPaymentAllocationData>>): UseMutationOptions<PreviewPaymentAllocationResponse, PreviewPaymentAllocationError, Options<PreviewPaymentAllocationData>> => {
    const mutationOptions: UseMutationOptions<PreviewPaymentAllocationResponse, PreviewPaymentAllocationError, Options<PreviewPaymentAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewPaymentAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPaymentDeclarationsQueryKey = (options?: Options<ListPaymentDeclarationsData>) => createQueryKey('listPaymentDeclarations', options);

/**
 * Plățile declarate de chiriași din portal, cele fără răspuns primele.
 *
 * O declarație nu este o încasare: până la confirmare scadența rămâne neschimbată și continuă să acumuleze întârziere. Confirmarea înregistrează încasarea prin fluxul obișnuit, pe numele proprietarului.
 */
export const listPaymentDeclarationsOptions = (options?: Options<ListPaymentDeclarationsData>) => queryOptions<ListPaymentDeclarationsResponse, ListPaymentDeclarationsError, ListPaymentDeclarationsResponse, ReturnType<typeof listPaymentDeclarationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPaymentDeclarations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPaymentDeclarationsQueryKey(options)
});

export const listPaymentDeclarationsInfiniteQueryKey = (options?: Options<ListPaymentDeclarationsData>): QueryKey<Options<ListPaymentDeclarationsData>> => createQueryKey('listPaymentDeclarations', options, true);

/**
 * Plățile declarate de chiriași din portal, cele fără răspuns primele.
 *
 * O declarație nu este o încasare: până la confirmare scadența rămâne neschimbată și continuă să acumuleze întârziere. Confirmarea înregistrează încasarea prin fluxul obișnuit, pe numele proprietarului.
 */
export const listPaymentDeclarationsInfiniteOptions = (options?: Options<ListPaymentDeclarationsData>) => {
    const opts = infiniteQueryOptions<ListPaymentDeclarationsResponse, ListPaymentDeclarationsError, InfiniteData<ListPaymentDeclarationsResponse>, QueryKey<Options<ListPaymentDeclarationsData>>, number | Pick<QueryKey<Options<ListPaymentDeclarationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPaymentDeclarationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPaymentDeclarations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPaymentDeclarationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Confirmă o plată declarată de chiriaș: se înregistrează încasarea, alocată pe scadența declarată, iar restul rămâne credit. Necesită Idempotency-Key.
 *
 * Suma, data și metoda din corpul cererii înlocuiesc ce a declarat chiriașul; câmpurile lăsate null păstrează valorile declarate. Refuzurile fluxului de încasare se întorc nemodificate — inclusiv 422 payment-partial-not-accepted când contractul nu acceptă plăți parțiale; în acel caz declarația rămâne în așteptare.
 */
export const confirmPaymentDeclarationMutation = (options?: Partial<Options<ConfirmPaymentDeclarationData>>): UseMutationOptions<ConfirmPaymentDeclarationResponse, ConfirmPaymentDeclarationError, Options<ConfirmPaymentDeclarationData>> => {
    const mutationOptions: UseMutationOptions<ConfirmPaymentDeclarationResponse, ConfirmPaymentDeclarationError, Options<ConfirmPaymentDeclarationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmPaymentDeclaration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Respinge o plată declarată de chiriaș. Nu se scrie nicio încasare, scadența rămâne neschimbată, iar motivul este arătat chiriașului. Necesită Idempotency-Key.
 */
export const rejectPaymentDeclarationMutation = (options?: Partial<Options<RejectPaymentDeclarationData>>): UseMutationOptions<RejectPaymentDeclarationResponse, RejectPaymentDeclarationError, Options<RejectPaymentDeclarationData>> => {
    const mutationOptions: UseMutationOptions<RejectPaymentDeclarationResponse, RejectPaymentDeclarationError, Options<RejectPaymentDeclarationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectPaymentDeclaration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPaymentQueryKey = (options: Options<GetPaymentData>) => createQueryKey('getPayment', options);

/**
 * O încasare cu repartizarea ei pe scadențe și creditul rămas nerepartizat.
 */
export const getPaymentOptions = (options: Options<GetPaymentData>) => queryOptions<GetPaymentResponse, GetPaymentError, GetPaymentResponse, ReturnType<typeof getPaymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPayment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPaymentQueryKey(options)
});

/**
 * Înlocuiește repartizarea unei încasări: alocările vechi se desfac, cele noi se scriu, iar fiecare scadență atinsă se recalculează. Necesită Idempotency-Key.
 */
export const reallocatePaymentMutation = (options?: Partial<Options<ReallocatePaymentData>>): UseMutationOptions<ReallocatePaymentResponse, ReallocatePaymentError, Options<ReallocatePaymentData>> => {
    const mutationOptions: UseMutationOptions<ReallocatePaymentResponse, ReallocatePaymentError, Options<ReallocatePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reallocatePayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stornează o încasare: alocările se desfac, scadențele atinse se recalculează, iar operațiunea este auditată cu motivul ei. Necesită Idempotency-Key.
 */
export const voidPaymentMutation = (options?: Partial<Options<VoidPaymentData>>): UseMutationOptions<VoidPaymentResponse, VoidPaymentError, Options<VoidPaymentData>> => {
    const mutationOptions: UseMutationOptions<VoidPaymentResponse, VoidPaymentError, Options<VoidPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voidPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPlatformAccountsQueryKey = (options?: Options<ListPlatformAccountsData>) => createQueryKey('listPlatformAccounts', options);

/**
 * Toate conturile de pe platformă, paginate.
 *
 * Toate conturile de pe platformă, cel mai nou primul. Lista este a persoanelor, nu a organizațiilor: nu conține apartenențe și nici roluri. Fiecare rând arată adresa, numele, telefonul, limba, dacă are MFA activ, dacă este administrator de platformă și dacă a fost dezactivat sau anonimizat GDPR. Filtrele se combină și se aplică în baza de date, nu în pagină: „search” caută în adresă SAU în nume, iar „platformAdmin”, „mfaEnabled” și „deactivated” restrâng fiecare la da sau la nu. Paginarea este tot pe server — numărătoarea și pagina folosesc același filtru.
 */
export const listPlatformAccountsOptions = (options?: Options<ListPlatformAccountsData>) => queryOptions<ListPlatformAccountsResponse, ListPlatformAccountsError, ListPlatformAccountsResponse, ReturnType<typeof listPlatformAccountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlatformAccounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPlatformAccountsQueryKey(options)
});

export const listPlatformAccountsInfiniteQueryKey = (options?: Options<ListPlatformAccountsData>): QueryKey<Options<ListPlatformAccountsData>> => createQueryKey('listPlatformAccounts', options, true);

/**
 * Toate conturile de pe platformă, paginate.
 *
 * Toate conturile de pe platformă, cel mai nou primul. Lista este a persoanelor, nu a organizațiilor: nu conține apartenențe și nici roluri. Fiecare rând arată adresa, numele, telefonul, limba, dacă are MFA activ, dacă este administrator de platformă și dacă a fost dezactivat sau anonimizat GDPR. Filtrele se combină și se aplică în baza de date, nu în pagină: „search” caută în adresă SAU în nume, iar „platformAdmin”, „mfaEnabled” și „deactivated” restrâng fiecare la da sau la nu. Paginarea este tot pe server — numărătoarea și pagina folosesc același filtru.
 */
export const listPlatformAccountsInfiniteOptions = (options?: Options<ListPlatformAccountsData>) => {
    const opts = infiniteQueryOptions<ListPlatformAccountsResponse, ListPlatformAccountsError, InfiniteData<ListPlatformAccountsResponse>, QueryKey<Options<ListPlatformAccountsData>>, number | Pick<QueryKey<Options<ListPlatformAccountsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPlatformAccountsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPlatformAccounts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPlatformAccountsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Deschide un cont și trimite linkul de setare a parolei.
 *
 * Deschide un cont fără parolă și trimite persoanei linkul „Am uitat parola”, ca să și-o aleagă singură. Niciun administrator nu alege parola altcuiva. Contul se creează fără nicio apartenență la organizație.
 */
export const createPlatformAccountMutation = (options?: Partial<Options<CreatePlatformAccountData>>): UseMutationOptions<CreatePlatformAccountResponse, CreatePlatformAccountError, Options<CreatePlatformAccountData>> => {
    const mutationOptions: UseMutationOptions<CreatePlatformAccountResponse, CreatePlatformAccountError, Options<CreatePlatformAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPlatformAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPlatformAccountQueryKey = (options: Options<GetPlatformAccountData>) => createQueryKey('getPlatformAccount', options);

/**
 * Un singur cont.
 */
export const getPlatformAccountOptions = (options: Options<GetPlatformAccountData>) => queryOptions<GetPlatformAccountResponse, GetPlatformAccountError, GetPlatformAccountResponse, ReturnType<typeof getPlatformAccountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlatformAccount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlatformAccountQueryKey(options)
});

/**
 * Modifică datele de profil ale unui cont.
 */
export const updatePlatformAccountMutation = (options?: Partial<Options<UpdatePlatformAccountData>>): UseMutationOptions<UpdatePlatformAccountResponse, UpdatePlatformAccountError, Options<UpdatePlatformAccountData>> => {
    const mutationOptions: UseMutationOptions<UpdatePlatformAccountResponse, UpdatePlatformAccountError, Options<UpdatePlatformAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePlatformAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dezactivează un cont.
 *
 * Dezactivează contul: blocare fără termen plus rotirea ștampilei de securitate, ceea ce invalidează și sesiunile deja emise. Nu este ștergere — app.users este referențiat de șapte chei străine, dintre care patru RESTRICT, iar ștergerea definitivă rămâne calea de anonimizare GDPR.
 */
export const deactivatePlatformAccountMutation = (options?: Partial<Options<DeactivatePlatformAccountData>>): UseMutationOptions<DeactivatePlatformAccountResponse, DeactivatePlatformAccountError, Options<DeactivatePlatformAccountData>> => {
    const mutationOptions: UseMutationOptions<DeactivatePlatformAccountResponse, DeactivatePlatformAccountError, Options<DeactivatePlatformAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivatePlatformAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reactivează un cont dezactivat.
 */
export const reactivatePlatformAccountMutation = (options?: Partial<Options<ReactivatePlatformAccountData>>): UseMutationOptions<ReactivatePlatformAccountResponse, ReactivatePlatformAccountError, Options<ReactivatePlatformAccountData>> => {
    const mutationOptions: UseMutationOptions<ReactivatePlatformAccountResponse, ReactivatePlatformAccountError, Options<ReactivatePlatformAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reactivatePlatformAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPlatformAdminActionsQueryKey = (options?: Options<ListPlatformAdminActionsData>) => createQueryKey('listPlatformAdminActions', options);

/**
 * Jurnalul acțiunilor administratorilor de platformă, filtrabil și paginat.
 *
 * Jurnalul administratorului de platformă („Audit admin”), cel mai nou primul: fiecare acțiune a unui administrator — cont deschis, modificat, dezactivat sau reactivat, creare anulată —, cine a făcut-o, când, de unde și ce s-a schimbat. „search” caută în acțiune, în tipul țintei, în adresa administratorului, în adresa contului atins SAU în numele organizației; „action” și „actorUserId” sunt potriviri exacte; intervalul [from, to) este în UTC, cu limita superioară exclusivă. Tabela este doar de adăugare: niciun rând nu se modifică sau se șterge.
 */
export const listPlatformAdminActionsOptions = (options?: Options<ListPlatformAdminActionsData>) => queryOptions<ListPlatformAdminActionsResponse, ListPlatformAdminActionsError, ListPlatformAdminActionsResponse, ReturnType<typeof listPlatformAdminActionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlatformAdminActions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPlatformAdminActionsQueryKey(options)
});

export const listPlatformAdminActionsInfiniteQueryKey = (options?: Options<ListPlatformAdminActionsData>): QueryKey<Options<ListPlatformAdminActionsData>> => createQueryKey('listPlatformAdminActions', options, true);

/**
 * Jurnalul acțiunilor administratorilor de platformă, filtrabil și paginat.
 *
 * Jurnalul administratorului de platformă („Audit admin”), cel mai nou primul: fiecare acțiune a unui administrator — cont deschis, modificat, dezactivat sau reactivat, creare anulată —, cine a făcut-o, când, de unde și ce s-a schimbat. „search” caută în acțiune, în tipul țintei, în adresa administratorului, în adresa contului atins SAU în numele organizației; „action” și „actorUserId” sunt potriviri exacte; intervalul [from, to) este în UTC, cu limita superioară exclusivă. Tabela este doar de adăugare: niciun rând nu se modifică sau se șterge.
 */
export const listPlatformAdminActionsInfiniteOptions = (options?: Options<ListPlatformAdminActionsData>) => {
    const opts = infiniteQueryOptions<ListPlatformAdminActionsResponse, ListPlatformAdminActionsError, InfiniteData<ListPlatformAdminActionsResponse>, QueryKey<Options<ListPlatformAdminActionsData>>, number | Pick<QueryKey<Options<ListPlatformAdminActionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPlatformAdminActionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPlatformAdminActions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPlatformAdminActionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listPlatformAuditQueryKey = (options?: Options<ListPlatformAuditData>) => createQueryKey('listPlatformAudit', options);

/**
 * Jurnalul de audit al întregii platforme, filtrabil și paginat.
 *
 * Jurnalul de audit al întregii platforme, cel mai nou primul, cu organizația ca o coloană vizibilă și ca filtru. Filtrele se combină și se aplică în baza de date: „search” caută în acțiune, în tipul entității, în adresa de email a actorului SAU în eticheta actorului; „organization” în numele sau slugul organizației; iar „entityType”, „entityId”, „userId”, „action” și „correlationId” sunt potriviri exacte. Intervalul [from, to) este în UTC, cu limita superioară exclusivă, ca două intervale alăturate să citească fiecare rând exact o dată. Ordinea este fixă și nu se poate schimba din query string. Paginarea este tot pe server — numărătoarea și pagina folosesc același filtru.
 */
export const listPlatformAuditOptions = (options?: Options<ListPlatformAuditData>) => queryOptions<ListPlatformAuditResponse, ListPlatformAuditError, ListPlatformAuditResponse, ReturnType<typeof listPlatformAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlatformAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPlatformAuditQueryKey(options)
});

export const listPlatformAuditInfiniteQueryKey = (options?: Options<ListPlatformAuditData>): QueryKey<Options<ListPlatformAuditData>> => createQueryKey('listPlatformAudit', options, true);

/**
 * Jurnalul de audit al întregii platforme, filtrabil și paginat.
 *
 * Jurnalul de audit al întregii platforme, cel mai nou primul, cu organizația ca o coloană vizibilă și ca filtru. Filtrele se combină și se aplică în baza de date: „search” caută în acțiune, în tipul entității, în adresa de email a actorului SAU în eticheta actorului; „organization” în numele sau slugul organizației; iar „entityType”, „entityId”, „userId”, „action” și „correlationId” sunt potriviri exacte. Intervalul [from, to) este în UTC, cu limita superioară exclusivă, ca două intervale alăturate să citească fiecare rând exact o dată. Ordinea este fixă și nu se poate schimba din query string. Paginarea este tot pe server — numărătoarea și pagina folosesc același filtru.
 */
export const listPlatformAuditInfiniteOptions = (options?: Options<ListPlatformAuditData>) => {
    const opts = infiniteQueryOptions<ListPlatformAuditResponse, ListPlatformAuditError, InfiniteData<ListPlatformAuditResponse>, QueryKey<Options<ListPlatformAuditData>>, number | Pick<QueryKey<Options<ListPlatformAuditData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPlatformAuditData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPlatformAudit({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPlatformAuditInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Anulează o creare făcută de un utilizator.
 *
 * Anulează o creare din jurnalul de audit: înregistrarea creată de utilizator este ștearsă exact cum ar șterge-o organizația ei — aceleași reguli, aceeași ștergere logică —, iar anularea apare în „Audit admin” cu motivul dat. Se pot anula doar creările de proprietăți, unități, chiriași, contracte, cheltuieli, documente, echipamente, polițe, facturi, furnizori, servicii de utilități și închirieri personale. O regulă care refuză ștergerea (de exemplu un contract activ pe proprietate) răspunde 422 cu codul ei; o creare deja anulată sau o înregistrare ștearsă între timp răspund 409. Răspunsul este rândul de audit așa cum arată acum.
 */
export const revertPlatformAuditCreationMutation = (options?: Partial<Options<RevertPlatformAuditCreationData>>): UseMutationOptions<RevertPlatformAuditCreationResponse, RevertPlatformAuditCreationError, Options<RevertPlatformAuditCreationData>> => {
    const mutationOptions: UseMutationOptions<RevertPlatformAuditCreationResponse, RevertPlatformAuditCreationError, Options<RevertPlatformAuditCreationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revertPlatformAuditCreation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPlatformEmailStatusQueryKey = (options?: Options<GetPlatformEmailStatusData>) => createQueryKey('getPlatformEmailStatus', options);

/**
 * Configurația trimiterii de e-mailuri.
 *
 * Cum trimite această instalare e-mailurile: serverul (relay-ul), portul, TLS, contul, adresa expeditorului și dacă trimiterea trece prin coada de ieșire. Parola nu apare niciodată; se spune doar dacă este configurată.
 */
export const getPlatformEmailStatusOptions = (options?: Options<GetPlatformEmailStatusData>) => queryOptions<GetPlatformEmailStatusResponse, GetPlatformEmailStatusError, GetPlatformEmailStatusResponse, ReturnType<typeof getPlatformEmailStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlatformEmailStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlatformEmailStatusQueryKey(options)
});

export const listPlatformOutboundEmailsQueryKey = (options?: Options<ListPlatformOutboundEmailsData>) => createQueryKey('listPlatformOutboundEmails', options);

/**
 * Jurnalul e-mailurilor trimise.
 *
 * Jurnalul e-mailurilor trimise, cel mai nou primul: ce a fost pus în coadă, trimis, inclus într-un rezumat, refuzat de limita destinatarului, respins de relay sau abandonat pentru că a așteptat prea mult. „search” caută în adresă sau în șablon; „status” restrânge la o singură stare. Rândurile se șterg după 30 de zile.
 */
export const listPlatformOutboundEmailsOptions = (options?: Options<ListPlatformOutboundEmailsData>) => queryOptions<ListPlatformOutboundEmailsResponse, ListPlatformOutboundEmailsError, ListPlatformOutboundEmailsResponse, ReturnType<typeof listPlatformOutboundEmailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlatformOutboundEmails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPlatformOutboundEmailsQueryKey(options)
});

/**
 * Trimite un mesaj de test prin relay și arată răspunsul lui.
 *
 * Trimite un mesaj de test direct prin relay, ocolind coada, și întoarce exact ce a răspuns serverul: trimis, suprimat (instalarea nu livrează e-mailuri) sau refuzat, cu motivul. Un 535 înseamnă cont sau parolă greșite, un 550 5.7.1 un expeditor pe care relay-ul nu îl acceptă, iar un timeout un port 587 blocat. Trimiterea apare în „Audit admin”.
 */
export const sendPlatformTestEmailMutation = (options?: Partial<Options<SendPlatformTestEmailData>>): UseMutationOptions<SendPlatformTestEmailResponse, SendPlatformTestEmailError, Options<SendPlatformTestEmailData>> => {
    const mutationOptions: UseMutationOptions<SendPlatformTestEmailResponse, SendPlatformTestEmailError, Options<SendPlatformTestEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendPlatformTestEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Emite cookie-ul de acces la dashboardul Hangfire pentru un admin.
 */
export const openJobsDashboardSessionMutation = (options?: Partial<Options<OpenJobsDashboardSessionData>>): UseMutationOptions<OpenJobsDashboardSessionResponse, OpenJobsDashboardSessionError, Options<OpenJobsDashboardSessionData>> => {
    const mutationOptions: UseMutationOptions<OpenJobsDashboardSessionResponse, OpenJobsDashboardSessionError, Options<OpenJobsDashboardSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await openJobsDashboardSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPortalContractsQueryKey = (options?: Options<ListPortalContractsData>) => createQueryKey('listPortalContracts', options);

/**
 * Contractele proprii, cu proprietatea, chiria și restanța fiecăruia.
 *
 * Portalul chiriașului arată exclusiv datele proprii: contractele în care chiriașul legat de acest cont este parte, în organizația din token. Orice alt identificator primește 404, nu 403 — existența unei resurse care nu este a ta nu se confirmă.
 */
export const listPortalContractsOptions = (options?: Options<ListPortalContractsData>) => queryOptions<ListPortalContractsResponse, ListPortalContractsError, ListPortalContractsResponse, ReturnType<typeof listPortalContractsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortalContracts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortalContractsQueryKey(options)
});

export const listPortalContractDocumentsQueryKey = (options: Options<ListPortalContractDocumentsData>) => createQueryKey('listPortalContractDocuments', options);

/**
 * Documentele unui contract propriu: ale proprietarului sau trimise de chiriaș.
 *
 * Portalul chiriașului arată exclusiv datele proprii: contractele în care chiriașul legat de acest cont este parte, în organizația din token. Orice alt identificator primește 404, nu 403 — existența unei resurse care nu este a ta nu se confirmă. Lista cuprinde documentele atașate contractului și pe cele atașate fișei de chiriaș a apelantului. Filtrul „source” alege partea arhivei: LANDLORD (implicit) — documentele depuse de proprietar, contractul semnat și actele adiționale primele; TENANT — fotografiile și dovezile trimise de chiriaș din portal sau printr-un link fără cont, cele mai noi primele. Lista este paginată (02 §7.4): fiecare fotografie de contor trimisă din portal se atașează contractului, așa că setul crește lună de lună.
 */
export const listPortalContractDocumentsOptions = (options: Options<ListPortalContractDocumentsData>) => queryOptions<ListPortalContractDocumentsResponse, ListPortalContractDocumentsError, ListPortalContractDocumentsResponse, ReturnType<typeof listPortalContractDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortalContractDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortalContractDocumentsQueryKey(options)
});

export const listPortalContractDocumentsInfiniteQueryKey = (options: Options<ListPortalContractDocumentsData>): QueryKey<Options<ListPortalContractDocumentsData>> => createQueryKey('listPortalContractDocuments', options, true);

/**
 * Documentele unui contract propriu: ale proprietarului sau trimise de chiriaș.
 *
 * Portalul chiriașului arată exclusiv datele proprii: contractele în care chiriașul legat de acest cont este parte, în organizația din token. Orice alt identificator primește 404, nu 403 — existența unei resurse care nu este a ta nu se confirmă. Lista cuprinde documentele atașate contractului și pe cele atașate fișei de chiriaș a apelantului. Filtrul „source” alege partea arhivei: LANDLORD (implicit) — documentele depuse de proprietar, contractul semnat și actele adiționale primele; TENANT — fotografiile și dovezile trimise de chiriaș din portal sau printr-un link fără cont, cele mai noi primele. Lista este paginată (02 §7.4): fiecare fotografie de contor trimisă din portal se atașează contractului, așa că setul crește lună de lună.
 */
export const listPortalContractDocumentsInfiniteOptions = (options: Options<ListPortalContractDocumentsData>) => {
    const opts = infiniteQueryOptions<ListPortalContractDocumentsResponse, ListPortalContractDocumentsError, InfiniteData<ListPortalContractDocumentsResponse>, QueryKey<Options<ListPortalContractDocumentsData>>, number | Pick<QueryKey<Options<ListPortalContractDocumentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPortalContractDocumentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPortalContractDocuments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPortalContractDocumentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const downloadPortalGeneratedDocumentQueryKey = (options: Options<DownloadPortalGeneratedDocumentData>) => createQueryKey('downloadPortalGeneratedDocument', options);

/**
 * Descarcă unul dintre cele patru documente generate ale unui contract propriu, ca PDF.
 *
 * Portalul chiriașului arată exclusiv datele proprii: contractele în care chiriașul legat de acest cont este parte, în organizația din token. Orice alt identificator primește 404, nu 403 — existența unei resurse care nu este a ta nu se confirmă. Documentul se generează la fiecare apel din datele contractului și nu este stocat; descărcarea este înregistrată în jurnalul de audit pe numele chiriașului. Contractul de închiriere este marcat „proiect — nesemnat”; copia semnată, dacă proprietarul a încărcat-o, este primul rând al listei de documente. Răspunsul poartă Content-Disposition: attachment cu un nume de fișier în limba română.
 */
export const downloadPortalGeneratedDocumentOptions = (options: Options<DownloadPortalGeneratedDocumentData>) => queryOptions<DownloadPortalGeneratedDocumentResponse, DownloadPortalGeneratedDocumentError, DownloadPortalGeneratedDocumentResponse, ReturnType<typeof downloadPortalGeneratedDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadPortalGeneratedDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadPortalGeneratedDocumentQueryKey(options)
});

/**
 * Raportează un incident pe proprietatea contractului, cu fotografii.
 *
 * Proprietatea și chiriașul sunt ale rutei, nu ale corpului cererii, iar sursa tichetului este întotdeauna „portalul chiriașului”.
 */
export const reportPortalIncidentMutation = (options?: Partial<Options<ReportPortalIncidentData>>): UseMutationOptions<ReportPortalIncidentResponse, ReportPortalIncidentError, Options<ReportPortalIncidentData>> => {
    const mutationOptions: UseMutationOptions<ReportPortalIncidentResponse, ReportPortalIncidentError, Options<ReportPortalIncidentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reportPortalIncident({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trimite indexul unui contor de pe proprietatea contractului.
 *
 * Indexul anterior este al serverului și nu se trimite. Trimiterea în afara ferestrei lunare a organizației este refuzată cu 422 portal-meter-window-closed. Citirea rămâne marcată „transmis de chiriaș” și, dacă organizația cere aprobare, în așteptarea proprietarului.
 */
export const submitPortalMeterReadingMutation = (options?: Partial<Options<SubmitPortalMeterReadingData>>): UseMutationOptions<SubmitPortalMeterReadingResponse, SubmitPortalMeterReadingError, Options<SubmitPortalMeterReadingData>> => {
    const mutationOptions: UseMutationOptions<SubmitPortalMeterReadingResponse, SubmitPortalMeterReadingError, Options<SubmitPortalMeterReadingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitPortalMeterReading({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPortalContractMetersQueryKey = (options: Options<ListPortalContractMetersData>) => createQueryKey('listPortalContractMeters', options);

/**
 * Contoarele pentru care ți se cere indexul, cu indexul anterior și starea ferestrei lunare.
 */
export const listPortalContractMetersOptions = (options: Options<ListPortalContractMetersData>) => queryOptions<ListPortalContractMetersResponse, ListPortalContractMetersError, ListPortalContractMetersResponse, ReturnType<typeof listPortalContractMetersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortalContractMeters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortalContractMetersQueryKey(options)
});

export const listPortalMeterReadingsQueryKey = (options: Options<ListPortalMeterReadingsData>) => createQueryKey('listPortalMeterReadings', options);

/**
 * Istoricul citirilor unui contor de pe un contract propriu, cele mai noi primele.
 *
 * Paginat (02 §7.4). Un contor care nu este pe proprietatea contractului — sau al cărui index îl citește proprietarul — este 404.
 */
export const listPortalMeterReadingsOptions = (options: Options<ListPortalMeterReadingsData>) => queryOptions<ListPortalMeterReadingsResponse, ListPortalMeterReadingsError, ListPortalMeterReadingsResponse, ReturnType<typeof listPortalMeterReadingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortalMeterReadings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortalMeterReadingsQueryKey(options)
});

export const listPortalMeterReadingsInfiniteQueryKey = (options: Options<ListPortalMeterReadingsData>): QueryKey<Options<ListPortalMeterReadingsData>> => createQueryKey('listPortalMeterReadings', options, true);

/**
 * Istoricul citirilor unui contor de pe un contract propriu, cele mai noi primele.
 *
 * Paginat (02 §7.4). Un contor care nu este pe proprietatea contractului — sau al cărui index îl citește proprietarul — este 404.
 */
export const listPortalMeterReadingsInfiniteOptions = (options: Options<ListPortalMeterReadingsData>) => {
    const opts = infiniteQueryOptions<ListPortalMeterReadingsResponse, ListPortalMeterReadingsError, InfiniteData<ListPortalMeterReadingsResponse>, QueryKey<Options<ListPortalMeterReadingsData>>, number | Pick<QueryKey<Options<ListPortalMeterReadingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPortalMeterReadingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPortalMeterReadings({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPortalMeterReadingsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listPortalPaymentDeclarationsQueryKey = (options: Options<ListPortalPaymentDeclarationsData>) => createQueryKey('listPortalPaymentDeclarations', options);

/**
 * Plățile pe care le-ai declarat pe un contract propriu și răspunsul proprietarului la fiecare.
 *
 * Portalul chiriașului arată exclusiv datele proprii: contractele în care chiriașul legat de acest cont este parte, în organizația din token. Orice alt identificator primește 404, nu 403 — existența unei resurse care nu este a ta nu se confirmă. Lista nu este paginată: un contract produce cel mult o declarație pe scadență, iar ecranul desenează câte un indicator pe fiecare scadență vizibilă din acest răspuns.
 */
export const listPortalPaymentDeclarationsOptions = (options: Options<ListPortalPaymentDeclarationsData>) => queryOptions<ListPortalPaymentDeclarationsResponse, ListPortalPaymentDeclarationsError, ListPortalPaymentDeclarationsResponse, ReturnType<typeof listPortalPaymentDeclarationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortalPaymentDeclarations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortalPaymentDeclarationsQueryKey(options)
});

/**
 * Declară că ai plătit o scadență, în numerar sau prin card/bancă, și trimite-o spre confirmare.
 *
 * Situația chiriei reflectă ce a înregistrat proprietarul. Chiria se plătește în afara aplicației — nu există plată online în V1 — dar plata făcută poate fi DECLARATĂ aici, iar scadența rămâne neschimbată până când proprietarul confirmă declarația. Metoda poate fi CASH sau CARD. Pentru CARD, dovada plății se încarcă întâi prin POST /portal/contracts/{id}/photos cu kind=RECEIPT, iar id-ul întors se trimite în proofDocumentId. O scadență poate avea o singură declarație în așteptare (422 payment-declaration-already-pending).
 */
export const declarePortalPaymentMutation = (options?: Partial<Options<DeclarePortalPaymentData>>): UseMutationOptions<DeclarePortalPaymentResponse, DeclarePortalPaymentError, Options<DeclarePortalPaymentData>> => {
    const mutationOptions: UseMutationOptions<DeclarePortalPaymentResponse, DeclarePortalPaymentError, Options<DeclarePortalPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await declarePortalPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Încarcă o fotografie pe un contract propriu și primește id-ul ei.
 *
 * Fișierul se trimite ca multipart/form-data în câmpul „file”; „kind” poate fi METER_PHOTO sau OTHER. Id-ul întors se trimite apoi în citirea de index sau în raportarea incidentului. Se aplică limitele arhivei: maximum 25 MB, extensii permise, conținut care corespunde extensiei.
 */
export const uploadPortalPhotoMutation = (options?: Partial<Options<UploadPortalPhotoData>>): UseMutationOptions<UploadPortalPhotoResponse, UploadPortalPhotoError, Options<UploadPortalPhotoData>> => {
    const mutationOptions: UseMutationOptions<UploadPortalPhotoResponse, UploadPortalPhotoError, Options<UploadPortalPhotoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadPortalPhoto({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPortalContractScheduleQueryKey = (options: Options<GetPortalContractScheduleData>) => createQueryKey('getPortalContractSchedule', options);

/**
 * Situația chiriei pentru un contract propriu: scadențe, încasat, restant.
 *
 * Situația chiriei reflectă ce a înregistrat proprietarul. Chiria se plătește în afara aplicației — nu există plată online în V1 — dar plata făcută poate fi DECLARATĂ aici, iar scadența rămâne neschimbată până când proprietarul confirmă declarația.
 */
export const getPortalContractScheduleOptions = (options: Options<GetPortalContractScheduleData>) => queryOptions<GetPortalContractScheduleResponse, GetPortalContractScheduleError, GetPortalContractScheduleResponse, ReturnType<typeof getPortalContractScheduleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortalContractSchedule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortalContractScheduleQueryKey(options)
});

export const getPortalUtilityMonthQueryKey = (options: Options<GetPortalUtilityMonthData>) => createQueryKey('getPortalUtilityMonth', options);

/**
 * Facturile de utilități ale unei luni pe un contract propriu: fiecare utilitate în sarcina ta, cu plata anunțată sau confirmată, dacă există.
 *
 * Portalul chiriașului arată exclusiv datele proprii: contractele în care chiriașul legat de acest cont este parte, în organizația din token. Orice alt identificator primește 404, nu 403 — existența unei resurse care nu este a ta nu se confirmă. Luna se cere prin „year” și „month”; lipsa lor înseamnă luna curentă (Europe/Bucharest). Răspunsul poartă limitele selectorului de lună: prima lună a contractului și ultima lună pentru care se poate anunța o plată. Facturile de utilități se plătesc furnizorului, în afara aplicației. Aici chiriașul ANUNȚĂ că a plătit factura unei luni, atașează dovada, iar proprietarul confirmă sau respinge. Nu se înregistrează nicio plată și nicio cheltuială — rândul spune doar că utilitatea lunii a fost achitată.
 */
export const getPortalUtilityMonthOptions = (options: Options<GetPortalUtilityMonthData>) => queryOptions<GetPortalUtilityMonthResponse, GetPortalUtilityMonthError, GetPortalUtilityMonthResponse, ReturnType<typeof getPortalUtilityMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortalUtilityMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortalUtilityMonthQueryKey(options)
});

/**
 * Anunță că ai plătit factura unei utilități pentru o lună și trimite-o proprietarului spre confirmare.
 *
 * Facturile de utilități se plătesc furnizorului, în afara aplicației. Aici chiriașul ANUNȚĂ că a plătit factura unei luni, atașează dovada, iar proprietarul confirmă sau respinge. Nu se înregistrează nicio plată și nicio cheltuială — rândul spune doar că utilitatea lunii a fost achitată. Dovada este obligatorie: se încarcă întâi prin POST /portal/contracts/{id}/photos cu kind=RECEIPT, iar id-ul întors se trimite în proofDocumentId (422 utility-bill-proof-required). Metoda poate fi CASH, CARD, BANK_TRANSFER sau DIRECT_DEBIT. O lună poate avea o singură plată anunțată sau confirmată (422 utility-bill-already-declared); o plată respinsă lasă luna deschisă. Luna nu poate fi în viitor și trebuie să fie în perioada contractului.
 */
export const declarePortalUtilityBillMutation = (options?: Partial<Options<DeclarePortalUtilityBillData>>): UseMutationOptions<DeclarePortalUtilityBillResponse, DeclarePortalUtilityBillError, Options<DeclarePortalUtilityBillData>> => {
    const mutationOptions: UseMutationOptions<DeclarePortalUtilityBillResponse, DeclarePortalUtilityBillError, Options<DeclarePortalUtilityBillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await declarePortalUtilityBill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadPortalDocumentQueryKey = (options: Options<DownloadPortalDocumentData>) => createQueryKey('downloadPortalDocument', options);

/**
 * Descarcă o versiune a unui document legat de un contract propriu.
 *
 * Filtrul de acces este cel al arhivei (02 §9.4): un chiriaș ajunge doar la documentele legate de contractele lui. Orice alt document este 404.
 */
export const downloadPortalDocumentOptions = (options: Options<DownloadPortalDocumentData>) => queryOptions<DownloadPortalDocumentResponse, DownloadPortalDocumentError, DownloadPortalDocumentResponse, ReturnType<typeof downloadPortalDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadPortalDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadPortalDocumentQueryKey(options)
});

export const listPortalIncidentsQueryKey = (options?: Options<ListPortalIncidentsData>) => createQueryKey('listPortalIncidents', options);

/**
 * Incidentele raportate de tine, cele active primele.
 *
 * Căutarea („q”), filtrul de stare („status”), filtrul de urgență („urgency”; NORMAL cuprinde și incidentele raportate înainte să existe urgența), scurtătura „doar active” („activeOnly”) și paginarea se aplică pe server, peste tot istoricul tău, nu peste pagina curentă. Incidentele încă în desfășurare apar primele pe fiecare pagină; în rest, cele mai noi primele.
 */
export const listPortalIncidentsOptions = (options?: Options<ListPortalIncidentsData>) => queryOptions<ListPortalIncidentsResponse, ListPortalIncidentsError, ListPortalIncidentsResponse, ReturnType<typeof listPortalIncidentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortalIncidents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortalIncidentsQueryKey(options)
});

export const listPortalIncidentsInfiniteQueryKey = (options?: Options<ListPortalIncidentsData>): QueryKey<Options<ListPortalIncidentsData>> => createQueryKey('listPortalIncidents', options, true);

/**
 * Incidentele raportate de tine, cele active primele.
 *
 * Căutarea („q”), filtrul de stare („status”), filtrul de urgență („urgency”; NORMAL cuprinde și incidentele raportate înainte să existe urgența), scurtătura „doar active” („activeOnly”) și paginarea se aplică pe server, peste tot istoricul tău, nu peste pagina curentă. Incidentele încă în desfășurare apar primele pe fiecare pagină; în rest, cele mai noi primele.
 */
export const listPortalIncidentsInfiniteOptions = (options?: Options<ListPortalIncidentsData>) => {
    const opts = infiniteQueryOptions<ListPortalIncidentsResponse, ListPortalIncidentsError, InfiniteData<ListPortalIncidentsResponse>, QueryKey<Options<ListPortalIncidentsData>>, number | Pick<QueryKey<Options<ListPortalIncidentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPortalIncidentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPortalIncidents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPortalIncidentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getPortalIncidentQueryKey = (options: Options<GetPortalIncidentData>) => createQueryKey('getPortalIncident', options);

/**
 * Un incident raportat de tine, cu fotografiile atașate.
 *
 * Portalul chiriașului arată exclusiv datele proprii: contractele în care chiriașul legat de acest cont este parte, în organizația din token. Orice alt identificator primește 404, nu 403 — existența unei resurse care nu este a ta nu se confirmă.
 */
export const getPortalIncidentOptions = (options: Options<GetPortalIncidentData>) => queryOptions<GetPortalIncidentResponse, GetPortalIncidentError, GetPortalIncidentResponse, ReturnType<typeof getPortalIncidentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortalIncident({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortalIncidentQueryKey(options)
});

export const listPortalNotificationsQueryKey = (options?: Options<ListPortalNotificationsData>) => createQueryKey('listPortalNotifications', options);

/**
 * Notificările adresate acestui cont, necitite întâi.
 *
 * Doar notificările adresate ție. Inboxul organizației este al proprietarului și nu apare aici.
 */
export const listPortalNotificationsOptions = (options?: Options<ListPortalNotificationsData>) => queryOptions<ListPortalNotificationsResponse, ListPortalNotificationsError, ListPortalNotificationsResponse, ReturnType<typeof listPortalNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortalNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortalNotificationsQueryKey(options)
});

export const listPortalNotificationsInfiniteQueryKey = (options?: Options<ListPortalNotificationsData>): QueryKey<Options<ListPortalNotificationsData>> => createQueryKey('listPortalNotifications', options, true);

/**
 * Notificările adresate acestui cont, necitite întâi.
 *
 * Doar notificările adresate ție. Inboxul organizației este al proprietarului și nu apare aici.
 */
export const listPortalNotificationsInfiniteOptions = (options?: Options<ListPortalNotificationsData>) => {
    const opts = infiniteQueryOptions<ListPortalNotificationsResponse, ListPortalNotificationsError, InfiniteData<ListPortalNotificationsResponse>, QueryKey<Options<ListPortalNotificationsData>>, number | Pick<QueryKey<Options<ListPortalNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPortalNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPortalNotifications({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPortalNotificationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Marchează drept citite toate notificările necitite adresate ție.
 */
export const markAllPortalNotificationsReadMutation = (options?: Partial<Options<MarkAllPortalNotificationsReadData>>): UseMutationOptions<MarkAllPortalNotificationsReadResponse, MarkAllPortalNotificationsReadError, Options<MarkAllPortalNotificationsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAllPortalNotificationsReadResponse, MarkAllPortalNotificationsReadError, Options<MarkAllPortalNotificationsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAllPortalNotificationsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Marchează drept citită o notificare adresată ție.
 *
 * O notificare adresată altcuiva, sau inboxul organizației, este 404.
 */
export const markPortalNotificationReadMutation = (options?: Partial<Options<MarkPortalNotificationReadData>>): UseMutationOptions<MarkPortalNotificationReadResponse, MarkPortalNotificationReadError, Options<MarkPortalNotificationReadData>> => {
    const mutationOptions: UseMutationOptions<MarkPortalNotificationReadResponse, MarkPortalNotificationReadError, Options<MarkPortalNotificationReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markPortalNotificationRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PortfolioPropertiesQueryKey = (options?: Options<GetApiV1PortfolioPropertiesData>) => createQueryKey('getApiV1PortfolioProperties', options);

export const getApiV1PortfolioPropertiesOptions = (options?: Options<GetApiV1PortfolioPropertiesData>) => queryOptions<GetApiV1PortfolioPropertiesResponse, GetApiV1PortfolioPropertiesError, GetApiV1PortfolioPropertiesResponse, ReturnType<typeof getApiV1PortfolioPropertiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PortfolioProperties({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PortfolioPropertiesQueryKey(options)
});

export const getApiV1PortfolioPropertiesInfiniteQueryKey = (options?: Options<GetApiV1PortfolioPropertiesData>): QueryKey<Options<GetApiV1PortfolioPropertiesData>> => createQueryKey('getApiV1PortfolioProperties', options, true);

export const getApiV1PortfolioPropertiesInfiniteOptions = (options?: Options<GetApiV1PortfolioPropertiesData>) => {
    const opts = infiniteQueryOptions<GetApiV1PortfolioPropertiesResponse, GetApiV1PortfolioPropertiesError, InfiniteData<GetApiV1PortfolioPropertiesResponse>, QueryKey<Options<GetApiV1PortfolioPropertiesData>>, number | Pick<QueryKey<Options<GetApiV1PortfolioPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiV1PortfolioPropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiV1PortfolioProperties({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiV1PortfolioPropertiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiV1PortfolioSummaryQueryKey = (options?: Options<GetApiV1PortfolioSummaryData>) => createQueryKey('getApiV1PortfolioSummary', options);

export const getApiV1PortfolioSummaryOptions = (options?: Options<GetApiV1PortfolioSummaryData>) => queryOptions<GetApiV1PortfolioSummaryResponse, GetApiV1PortfolioSummaryError, GetApiV1PortfolioSummaryResponse, ReturnType<typeof getApiV1PortfolioSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PortfolioSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PortfolioSummaryQueryKey(options)
});

export const getApiV1PropertiesQueryKey = (options?: Options<GetApiV1PropertiesData>) => createQueryKey('getApiV1Properties', options);

export const getApiV1PropertiesOptions = (options?: Options<GetApiV1PropertiesData>) => queryOptions<GetApiV1PropertiesResponse, GetApiV1PropertiesError, GetApiV1PropertiesResponse, ReturnType<typeof getApiV1PropertiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1Properties({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesQueryKey(options)
});

export const getApiV1PropertiesInfiniteQueryKey = (options?: Options<GetApiV1PropertiesData>): QueryKey<Options<GetApiV1PropertiesData>> => createQueryKey('getApiV1Properties', options, true);

export const getApiV1PropertiesInfiniteOptions = (options?: Options<GetApiV1PropertiesData>) => {
    const opts = infiniteQueryOptions<GetApiV1PropertiesResponse, GetApiV1PropertiesError, InfiniteData<GetApiV1PropertiesResponse>, QueryKey<Options<GetApiV1PropertiesData>>, number | Pick<QueryKey<Options<GetApiV1PropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiV1PropertiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiV1Properties({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiV1PropertiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postApiV1PropertiesMutation = (options?: Partial<Options<PostApiV1PropertiesData>>): UseMutationOptions<PostApiV1PropertiesResponse, PostApiV1PropertiesError, Options<PostApiV1PropertiesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PropertiesResponse, PostApiV1PropertiesError, Options<PostApiV1PropertiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1Properties({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteApiV1PropertiesByIdMutation = (options?: Partial<Options<DeleteApiV1PropertiesByIdData>>): UseMutationOptions<DeleteApiV1PropertiesByIdResponse, DeleteApiV1PropertiesByIdError, Options<DeleteApiV1PropertiesByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PropertiesByIdResponse, DeleteApiV1PropertiesByIdError, Options<DeleteApiV1PropertiesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1PropertiesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PropertiesByIdQueryKey = (options: Options<GetApiV1PropertiesByIdData>) => createQueryKey('getApiV1PropertiesById', options);

export const getApiV1PropertiesByIdOptions = (options: Options<GetApiV1PropertiesByIdData>) => queryOptions<GetApiV1PropertiesByIdResponse, GetApiV1PropertiesByIdError, GetApiV1PropertiesByIdResponse, ReturnType<typeof getApiV1PropertiesByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PropertiesById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesByIdQueryKey(options)
});

export const putApiV1PropertiesByIdMutation = (options?: Partial<Options<PutApiV1PropertiesByIdData>>): UseMutationOptions<PutApiV1PropertiesByIdResponse, PutApiV1PropertiesByIdError, Options<PutApiV1PropertiesByIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PropertiesByIdResponse, PutApiV1PropertiesByIdError, Options<PutApiV1PropertiesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1PropertiesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putApiV1PropertiesByIdAdministratorMutation = (options?: Partial<Options<PutApiV1PropertiesByIdAdministratorData>>): UseMutationOptions<PutApiV1PropertiesByIdAdministratorResponse, PutApiV1PropertiesByIdAdministratorError, Options<PutApiV1PropertiesByIdAdministratorData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PropertiesByIdAdministratorResponse, PutApiV1PropertiesByIdAdministratorError, Options<PutApiV1PropertiesByIdAdministratorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1PropertiesByIdAdministrator({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PropertiesByIdAssignableOwnersQueryKey = (options: Options<GetApiV1PropertiesByIdAssignableOwnersData>) => createQueryKey('getApiV1PropertiesByIdAssignableOwners', options);

export const getApiV1PropertiesByIdAssignableOwnersOptions = (options: Options<GetApiV1PropertiesByIdAssignableOwnersData>) => queryOptions<GetApiV1PropertiesByIdAssignableOwnersResponse, GetApiV1PropertiesByIdAssignableOwnersError, GetApiV1PropertiesByIdAssignableOwnersResponse, ReturnType<typeof getApiV1PropertiesByIdAssignableOwnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PropertiesByIdAssignableOwners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesByIdAssignableOwnersQueryKey(options)
});

export const getApiV1PropertiesByIdAssignableOwnersInfiniteQueryKey = (options: Options<GetApiV1PropertiesByIdAssignableOwnersData>): QueryKey<Options<GetApiV1PropertiesByIdAssignableOwnersData>> => createQueryKey('getApiV1PropertiesByIdAssignableOwners', options, true);

export const getApiV1PropertiesByIdAssignableOwnersInfiniteOptions = (options: Options<GetApiV1PropertiesByIdAssignableOwnersData>) => {
    const opts = infiniteQueryOptions<GetApiV1PropertiesByIdAssignableOwnersResponse, GetApiV1PropertiesByIdAssignableOwnersError, InfiniteData<GetApiV1PropertiesByIdAssignableOwnersResponse>, QueryKey<Options<GetApiV1PropertiesByIdAssignableOwnersData>>, number | Pick<QueryKey<Options<GetApiV1PropertiesByIdAssignableOwnersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiV1PropertiesByIdAssignableOwnersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiV1PropertiesByIdAssignableOwners({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiV1PropertiesByIdAssignableOwnersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postApiV1PropertiesByIdCoOwnerInvitationsMutation = (options?: Partial<Options<PostApiV1PropertiesByIdCoOwnerInvitationsData>>): UseMutationOptions<PostApiV1PropertiesByIdCoOwnerInvitationsResponse, PostApiV1PropertiesByIdCoOwnerInvitationsError, Options<PostApiV1PropertiesByIdCoOwnerInvitationsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PropertiesByIdCoOwnerInvitationsResponse, PostApiV1PropertiesByIdCoOwnerInvitationsError, Options<PostApiV1PropertiesByIdCoOwnerInvitationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PropertiesByIdCoOwnerInvitations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PropertiesByIdHandoverRecipientsQueryKey = (options: Options<GetApiV1PropertiesByIdHandoverRecipientsData>) => createQueryKey('getApiV1PropertiesByIdHandoverRecipients', options);

export const getApiV1PropertiesByIdHandoverRecipientsOptions = (options: Options<GetApiV1PropertiesByIdHandoverRecipientsData>) => queryOptions<GetApiV1PropertiesByIdHandoverRecipientsResponse, GetApiV1PropertiesByIdHandoverRecipientsError, GetApiV1PropertiesByIdHandoverRecipientsResponse, ReturnType<typeof getApiV1PropertiesByIdHandoverRecipientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PropertiesByIdHandoverRecipients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesByIdHandoverRecipientsQueryKey(options)
});

export const getApiV1PropertiesByIdHandoversQueryKey = (options: Options<GetApiV1PropertiesByIdHandoversData>) => createQueryKey('getApiV1PropertiesByIdHandovers', options);

export const getApiV1PropertiesByIdHandoversOptions = (options: Options<GetApiV1PropertiesByIdHandoversData>) => queryOptions<GetApiV1PropertiesByIdHandoversResponse, GetApiV1PropertiesByIdHandoversError, GetApiV1PropertiesByIdHandoversResponse, ReturnType<typeof getApiV1PropertiesByIdHandoversQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PropertiesByIdHandovers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesByIdHandoversQueryKey(options)
});

export const postApiV1PropertiesByIdHandoversMutation = (options?: Partial<Options<PostApiV1PropertiesByIdHandoversData>>): UseMutationOptions<PostApiV1PropertiesByIdHandoversResponse, PostApiV1PropertiesByIdHandoversError, Options<PostApiV1PropertiesByIdHandoversData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PropertiesByIdHandoversResponse, PostApiV1PropertiesByIdHandoversError, Options<PostApiV1PropertiesByIdHandoversData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PropertiesByIdHandovers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1PropertiesByIdHandoversByHandoverIdRevokeMutation = (options?: Partial<Options<PostApiV1PropertiesByIdHandoversByHandoverIdRevokeData>>): UseMutationOptions<PostApiV1PropertiesByIdHandoversByHandoverIdRevokeResponse, PostApiV1PropertiesByIdHandoversByHandoverIdRevokeError, Options<PostApiV1PropertiesByIdHandoversByHandoverIdRevokeData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PropertiesByIdHandoversByHandoverIdRevokeResponse, PostApiV1PropertiesByIdHandoversByHandoverIdRevokeError, Options<PostApiV1PropertiesByIdHandoversByHandoverIdRevokeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PropertiesByIdHandoversByHandoverIdRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putApiV1PropertiesByIdOwnershipSharesMutation = (options?: Partial<Options<PutApiV1PropertiesByIdOwnershipSharesData>>): UseMutationOptions<PutApiV1PropertiesByIdOwnershipSharesResponse, PutApiV1PropertiesByIdOwnershipSharesError, Options<PutApiV1PropertiesByIdOwnershipSharesData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PropertiesByIdOwnershipSharesResponse, PutApiV1PropertiesByIdOwnershipSharesError, Options<PutApiV1PropertiesByIdOwnershipSharesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1PropertiesByIdOwnershipShares({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PropertiesByIdOwnershipTransfersQueryKey = (options: Options<GetApiV1PropertiesByIdOwnershipTransfersData>) => createQueryKey('getApiV1PropertiesByIdOwnershipTransfers', options);

export const getApiV1PropertiesByIdOwnershipTransfersOptions = (options: Options<GetApiV1PropertiesByIdOwnershipTransfersData>) => queryOptions<GetApiV1PropertiesByIdOwnershipTransfersResponse, GetApiV1PropertiesByIdOwnershipTransfersError, GetApiV1PropertiesByIdOwnershipTransfersResponse, ReturnType<typeof getApiV1PropertiesByIdOwnershipTransfersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PropertiesByIdOwnershipTransfers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesByIdOwnershipTransfersQueryKey(options)
});

export const postApiV1PropertiesByIdOwnershipTransfersMutation = (options?: Partial<Options<PostApiV1PropertiesByIdOwnershipTransfersData>>): UseMutationOptions<PostApiV1PropertiesByIdOwnershipTransfersResponse, PostApiV1PropertiesByIdOwnershipTransfersError, Options<PostApiV1PropertiesByIdOwnershipTransfersData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PropertiesByIdOwnershipTransfersResponse, PostApiV1PropertiesByIdOwnershipTransfersError, Options<PostApiV1PropertiesByIdOwnershipTransfersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PropertiesByIdOwnershipTransfers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPropertyCashFlowQueryKey = (options: Options<GetPropertyCashFlowData>) => createQueryKey('getPropertyCashFlow', options);

/**
 * Cash-flow al unei proprietăți: totaluri, seria lunară cu cumulatul și verdictul „pe minus”; 404 dacă proprietatea nu există.
 *
 * Mișcarea reală de bani, pe o proprietate sau pe tot portofoliul (01 BR-LEDGER-02). Încasări: plățile primite, în luna în care au sosit — inclusiv banii încă nerepartizați pe o scadență, care sunt numerar real dar nu aparțin niciunei proprietăți. Plăți: cheltuielile efectiv plătite, INCLUSIV rata integrală a creditului ipotecar — și principal, și dobândă — spre deosebire de P&L economic, unde principalul nu este cost. Garanțiile apar ca linii memo (primite, restituite, reținute) și nu schimbă niciun total: banii nu sunt ai proprietarului. Cheltuielile cu domeniul PERSONAL („Chiriaș la rândul meu”) sunt excluse în SQL, înainte de orice adunare. Cifrele sunt în RON, rotunjite la ban o singură dată, la prezentare. Clasificarea (spec §14; 01 BR-LEDGER-06/07) este calculată pe server și nu se recalculează în client: „lună negativă” și „structural pe minus” sunt câmpuri diferite, decise pe baze diferite — verdictul structural cere atâtea luni CONSECUTIVE cu cash-flow OPERAȚIONAL negativ câte cere configurația (implicit 3), iar one-off-urile / CapEx nu intră în acea bază, ca o reparație mare să facă o lună proastă și nu o proprietate care pierde bani. „Profit redus” este un semnal separat, pe pragul lui (implicit 15% din încasări). Pragurile efective sunt în thresholds. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). Nu există parametru basis: un cash-flow are o singură bază, ziua în care banii s-au mișcat. YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getPropertyCashFlowOptions = (options: Options<GetPropertyCashFlowData>) => queryOptions<GetPropertyCashFlowResponse, GetPropertyCashFlowError, GetPropertyCashFlowResponse, ReturnType<typeof getPropertyCashFlowQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPropertyCashFlow({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPropertyCashFlowQueryKey(options)
});

export const getPropertyEconomicPnlQueryKey = (options: Options<GetPropertyEconomicPnlData>) => createQueryKey('getPropertyEconomicPnl', options);

/**
 * P&L economic al unei proprietăți: totaluri, seria lunară și defalcarea pe categorii; 404 dacă proprietatea nu există.
 *
 * Jumătatea ECONOMICĂ a criteriului 6 din specificație: venituri reale (chirie încasată, garanții reținute) minus TOATE costurile reale, indiferent de statusul lor fiscal — inclusiv cele NEDEDUCTIBILE. Situația fiscală nu apare aici sub nicio formă: este livrată separat de motorul fiscal (M4) și nu se contopește niciodată cu aceste cifre. Cheltuielile cu domeniul PERSONAL („Chiriaș la rândul meu”) sunt excluse în SQL, înainte de orice adunare. Cifrele sunt în RON, rotunjite la ban o singură dată, la prezentare; fluxurile în altă monedă sunt convertite la citire la cursul BNR al datei lor și etichetate „estimativ, curs BNR din …”. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). Baza: basis=ACCRUAL|CASH (implicit ACCRUAL). YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getPropertyEconomicPnlOptions = (options: Options<GetPropertyEconomicPnlData>) => queryOptions<GetPropertyEconomicPnlResponse, GetPropertyEconomicPnlError, GetPropertyEconomicPnlResponse, ReturnType<typeof getPropertyEconomicPnlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPropertyEconomicPnl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPropertyEconomicPnlQueryKey(options)
});

export const listPropertyExpensesQueryKey = (options: Options<ListPropertyExpensesData>) => createQueryKey('listPropertyExpenses', options);

/**
 * Registrul de cheltuieli al unei proprietăți, paginat, cu totalurile întregului set pe fiecare monedă; 404 dacă proprietatea nu există.
 */
export const listPropertyExpensesOptions = (options: Options<ListPropertyExpensesData>) => queryOptions<ListPropertyExpensesResponse, ListPropertyExpensesError, ListPropertyExpensesResponse, ReturnType<typeof listPropertyExpensesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPropertyExpenses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPropertyExpensesQueryKey(options)
});

export const listPropertyExpensesInfiniteQueryKey = (options: Options<ListPropertyExpensesData>): QueryKey<Options<ListPropertyExpensesData>> => createQueryKey('listPropertyExpenses', options, true);

/**
 * Registrul de cheltuieli al unei proprietăți, paginat, cu totalurile întregului set pe fiecare monedă; 404 dacă proprietatea nu există.
 */
export const listPropertyExpensesInfiniteOptions = (options: Options<ListPropertyExpensesData>) => {
    const opts = infiniteQueryOptions<ListPropertyExpensesResponse, ListPropertyExpensesError, InfiniteData<ListPropertyExpensesResponse>, QueryKey<Options<ListPropertyExpensesData>>, number | Pick<QueryKey<Options<ListPropertyExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPropertyExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPropertyExpenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPropertyExpensesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listPropertyRentSchedulesQueryKey = (options: Options<ListPropertyRentSchedulesData>) => createQueryKey('listPropertyRentSchedules', options);

/**
 * Scadențele tuturor contractelor unei proprietăți, paginate, cu totalurile întregului set pe fiecare monedă; 404 dacă proprietatea nu există.
 */
export const listPropertyRentSchedulesOptions = (options: Options<ListPropertyRentSchedulesData>) => queryOptions<ListPropertyRentSchedulesResponse, ListPropertyRentSchedulesError, ListPropertyRentSchedulesResponse, ReturnType<typeof listPropertyRentSchedulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPropertyRentSchedules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPropertyRentSchedulesQueryKey(options)
});

export const listPropertyRentSchedulesInfiniteQueryKey = (options: Options<ListPropertyRentSchedulesData>): QueryKey<Options<ListPropertyRentSchedulesData>> => createQueryKey('listPropertyRentSchedules', options, true);

/**
 * Scadențele tuturor contractelor unei proprietăți, paginate, cu totalurile întregului set pe fiecare monedă; 404 dacă proprietatea nu există.
 */
export const listPropertyRentSchedulesInfiniteOptions = (options: Options<ListPropertyRentSchedulesData>) => {
    const opts = infiniteQueryOptions<ListPropertyRentSchedulesResponse, ListPropertyRentSchedulesError, InfiniteData<ListPropertyRentSchedulesResponse>, QueryKey<Options<ListPropertyRentSchedulesData>>, number | Pick<QueryKey<Options<ListPropertyRentSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPropertyRentSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPropertyRentSchedules({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPropertyRentSchedulesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listPropertyRepairTicketsQueryKey = (options: Options<ListPropertyRepairTicketsData>) => createQueryKey('listPropertyRepairTickets', options);

/**
 * Tichetele de reparație ale unei proprietăți, paginate, cu coloanele panoului; 404 dacă proprietatea nu există.
 */
export const listPropertyRepairTicketsOptions = (options: Options<ListPropertyRepairTicketsData>) => queryOptions<ListPropertyRepairTicketsResponse, ListPropertyRepairTicketsError, ListPropertyRepairTicketsResponse, ReturnType<typeof listPropertyRepairTicketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPropertyRepairTickets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPropertyRepairTicketsQueryKey(options)
});

export const listPropertyRepairTicketsInfiniteQueryKey = (options: Options<ListPropertyRepairTicketsData>): QueryKey<Options<ListPropertyRepairTicketsData>> => createQueryKey('listPropertyRepairTickets', options, true);

/**
 * Tichetele de reparație ale unei proprietăți, paginate, cu coloanele panoului; 404 dacă proprietatea nu există.
 */
export const listPropertyRepairTicketsInfiniteOptions = (options: Options<ListPropertyRepairTicketsData>) => {
    const opts = infiniteQueryOptions<ListPropertyRepairTicketsResponse, ListPropertyRepairTicketsError, InfiniteData<ListPropertyRepairTicketsResponse>, QueryKey<Options<ListPropertyRepairTicketsData>>, number | Pick<QueryKey<Options<ListPropertyRepairTicketsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPropertyRepairTicketsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPropertyRepairTickets({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPropertyRepairTicketsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiV1PropertiesByPropertyIdUnitsQueryKey = (options: Options<GetApiV1PropertiesByPropertyIdUnitsData>) => createQueryKey('getApiV1PropertiesByPropertyIdUnits', options);

export const getApiV1PropertiesByPropertyIdUnitsOptions = (options: Options<GetApiV1PropertiesByPropertyIdUnitsData>) => queryOptions<GetApiV1PropertiesByPropertyIdUnitsResponse, GetApiV1PropertiesByPropertyIdUnitsError, GetApiV1PropertiesByPropertyIdUnitsResponse, ReturnType<typeof getApiV1PropertiesByPropertyIdUnitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PropertiesByPropertyIdUnits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesByPropertyIdUnitsQueryKey(options)
});

export const getApiV1PropertiesByPropertyIdUnitsInfiniteQueryKey = (options: Options<GetApiV1PropertiesByPropertyIdUnitsData>): QueryKey<Options<GetApiV1PropertiesByPropertyIdUnitsData>> => createQueryKey('getApiV1PropertiesByPropertyIdUnits', options, true);

export const getApiV1PropertiesByPropertyIdUnitsInfiniteOptions = (options: Options<GetApiV1PropertiesByPropertyIdUnitsData>) => {
    const opts = infiniteQueryOptions<GetApiV1PropertiesByPropertyIdUnitsResponse, GetApiV1PropertiesByPropertyIdUnitsError, InfiniteData<GetApiV1PropertiesByPropertyIdUnitsResponse>, QueryKey<Options<GetApiV1PropertiesByPropertyIdUnitsData>>, number | Pick<QueryKey<Options<GetApiV1PropertiesByPropertyIdUnitsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiV1PropertiesByPropertyIdUnitsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiV1PropertiesByPropertyIdUnits({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiV1PropertiesByPropertyIdUnitsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postApiV1PropertiesByPropertyIdUnitsMutation = (options?: Partial<Options<PostApiV1PropertiesByPropertyIdUnitsData>>): UseMutationOptions<PostApiV1PropertiesByPropertyIdUnitsResponse, PostApiV1PropertiesByPropertyIdUnitsError, Options<PostApiV1PropertiesByPropertyIdUnitsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PropertiesByPropertyIdUnitsResponse, PostApiV1PropertiesByPropertyIdUnitsError, Options<PostApiV1PropertiesByPropertyIdUnitsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PropertiesByPropertyIdUnits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteApiV1PropertiesByPropertyIdUnitsByUnitIdMutation = (options?: Partial<Options<DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdData>>): UseMutationOptions<DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdError, Options<DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdError, Options<DeleteApiV1PropertiesByPropertyIdUnitsByUnitIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1PropertiesByPropertyIdUnitsByUnitId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PropertiesByPropertyIdUnitsByUnitIdQueryKey = (options: Options<GetApiV1PropertiesByPropertyIdUnitsByUnitIdData>) => createQueryKey('getApiV1PropertiesByPropertyIdUnitsByUnitId', options);

export const getApiV1PropertiesByPropertyIdUnitsByUnitIdOptions = (options: Options<GetApiV1PropertiesByPropertyIdUnitsByUnitIdData>) => queryOptions<GetApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, GetApiV1PropertiesByPropertyIdUnitsByUnitIdError, GetApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, ReturnType<typeof getApiV1PropertiesByPropertyIdUnitsByUnitIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PropertiesByPropertyIdUnitsByUnitId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PropertiesByPropertyIdUnitsByUnitIdQueryKey(options)
});

export const putApiV1PropertiesByPropertyIdUnitsByUnitIdMutation = (options?: Partial<Options<PutApiV1PropertiesByPropertyIdUnitsByUnitIdData>>): UseMutationOptions<PutApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, PutApiV1PropertiesByPropertyIdUnitsByUnitIdError, Options<PutApiV1PropertiesByPropertyIdUnitsByUnitIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1PropertiesByPropertyIdUnitsByUnitIdResponse, PutApiV1PropertiesByPropertyIdUnitsByUnitIdError, Options<PutApiV1PropertiesByPropertyIdUnitsByUnitIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1PropertiesByPropertyIdUnitsByUnitId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1PropertyHandoversAcceptMutation = (options?: Partial<Options<PostApiV1PropertyHandoversAcceptData>>): UseMutationOptions<PostApiV1PropertyHandoversAcceptResponse, PostApiV1PropertyHandoversAcceptError, Options<PostApiV1PropertyHandoversAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PropertyHandoversAcceptResponse, PostApiV1PropertyHandoversAcceptError, Options<PostApiV1PropertyHandoversAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PropertyHandoversAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRecurringExpensesQueryKey = (options?: Options<ListRecurringExpensesData>) => createQueryKey('listRecurringExpenses', options);

/**
 * Regulile de cheltuieli recurente ale portofoliului (scope = PROPERTY), paginate; filtre după proprietate, categorie și stare, plus câte obligații a generat fiecare.
 *
 * Regulile personale („Chiriaș la rândul meu”) NU apar aici. Ele se citesc de la GET /api/v1/owner-tenancies/{id}/recurring-expenses.
 */
export const listRecurringExpensesOptions = (options?: Options<ListRecurringExpensesData>) => queryOptions<ListRecurringExpensesResponse, ListRecurringExpensesError, ListRecurringExpensesResponse, ReturnType<typeof listRecurringExpensesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRecurringExpenses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRecurringExpensesQueryKey(options)
});

export const listRecurringExpensesInfiniteQueryKey = (options?: Options<ListRecurringExpensesData>): QueryKey<Options<ListRecurringExpensesData>> => createQueryKey('listRecurringExpenses', options, true);

/**
 * Regulile de cheltuieli recurente ale portofoliului (scope = PROPERTY), paginate; filtre după proprietate, categorie și stare, plus câte obligații a generat fiecare.
 *
 * Regulile personale („Chiriaș la rândul meu”) NU apar aici. Ele se citesc de la GET /api/v1/owner-tenancies/{id}/recurring-expenses.
 */
export const listRecurringExpensesInfiniteOptions = (options?: Options<ListRecurringExpensesData>) => {
    const opts = infiniteQueryOptions<ListRecurringExpensesResponse, ListRecurringExpensesError, InfiniteData<ListRecurringExpensesResponse>, QueryKey<Options<ListRecurringExpensesData>>, number | Pick<QueryKey<Options<ListRecurringExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListRecurringExpensesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listRecurringExpenses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRecurringExpensesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă o regulă de cheltuială recurentă, pe o proprietate sau pe o chirie personală.
 *
 * Modificarea unei reguli se aplică doar înainte: obligațiile deja generate nu sunt reevaluate, redatate sau șterse (spec §10 — „recalculare fără modificarea istoricului”). O sumă schimbată în iulie lasă ianuarie–iulie neatinse și se aplică de la august. Generarea nu se oprește prin ștergere — regula nu se șterge niciodată — ci prin dezactivare, care păstrează tot istoricul. La salvare, regula scrie imediat obligațiile pe care le datorează până în luna curentă inclusiv (doar pe cele care lipsesc, fără să atingă vreuna existentă); lunile următoare le adaugă motorul lunar, pe 1 ale lunii. generatedCount din răspuns le numără.
 */
export const createRecurringExpenseMutation = (options?: Partial<Options<CreateRecurringExpenseData>>): UseMutationOptions<CreateRecurringExpenseResponse, CreateRecurringExpenseError, Options<CreateRecurringExpenseData>> => {
    const mutationOptions: UseMutationOptions<CreateRecurringExpenseResponse, CreateRecurringExpenseError, Options<CreateRecurringExpenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createRecurringExpense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Următoarele trei obligații pe care regula trimisă le-ar genera. Nu scrie nimic.
 *
 * Rulează exact planificatorul motorului lunar și construiește rândurile prin aceeași fabrică pe care o folosește generarea, așa că datele, sumele, identificatorii și nota de „sumă estimată” sunt cele pe care le-ar scrie următoarea rulare — dar nu se inserează nimic. Regulile de validare sunt cele de la creare: o regulă care ar fi refuzată la salvare este refuzată și aici, cu același cod. Trimite ruleId când editezi o regulă existentă, ca previzualizarea să continue de la cursorul generatorului și nu de la începutul regulii.
 */
export const previewRecurringExpenseMutation = (options?: Partial<Options<PreviewRecurringExpenseData>>): UseMutationOptions<PreviewRecurringExpenseResponse, PreviewRecurringExpenseError, Options<PreviewRecurringExpenseData>> => {
    const mutationOptions: UseMutationOptions<PreviewRecurringExpenseResponse, PreviewRecurringExpenseError, Options<PreviewRecurringExpenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewRecurringExpense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecurringExpenseQueryKey = (options: Options<GetRecurringExpenseData>) => createQueryKey('getRecurringExpense', options);

/**
 * O regulă, cu numele proprietății sau adresa chiriei personale, categoria, cursorul generatorului și numărul de obligații generate.
 */
export const getRecurringExpenseOptions = (options: Options<GetRecurringExpenseData>) => queryOptions<GetRecurringExpenseResponse, GetRecurringExpenseError, GetRecurringExpenseResponse, ReturnType<typeof getRecurringExpenseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecurringExpense({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecurringExpenseQueryKey(options)
});

/**
 * Înlocuiește regula. Se aplică doar generărilor viitoare.
 *
 * Modificarea unei reguli se aplică doar înainte: obligațiile deja generate nu sunt reevaluate, redatate sau șterse (spec §10 — „recalculare fără modificarea istoricului”). O sumă schimbată în iulie lasă ianuarie–iulie neatinse și se aplică de la august. Generarea nu se oprește prin ștergere — regula nu se șterge niciodată — ci prin dezactivare, care păstrează tot istoricul. La salvare, regula scrie imediat obligațiile pe care le datorează până în luna curentă inclusiv (doar pe cele care lipsesc, fără să atingă vreuna existentă); lunile următoare le adaugă motorul lunar, pe 1 ale lunii. generatedCount din răspuns le numără.
 */
export const updateRecurringExpenseMutation = (options?: Partial<Options<UpdateRecurringExpenseData>>): UseMutationOptions<UpdateRecurringExpenseResponse, UpdateRecurringExpenseError, Options<UpdateRecurringExpenseData>> => {
    const mutationOptions: UseMutationOptions<UpdateRecurringExpenseResponse, UpdateRecurringExpenseError, Options<UpdateRecurringExpenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRecurringExpense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Oprește generarea. Obligațiile deja generate rămân neatinse; regula nu se șterge niciodată.
 */
export const deactivateRecurringExpenseMutation = (options?: Partial<Options<DeactivateRecurringExpenseData>>): UseMutationOptions<DeactivateRecurringExpenseResponse, DeactivateRecurringExpenseError, Options<DeactivateRecurringExpenseData>> => {
    const mutationOptions: UseMutationOptions<DeactivateRecurringExpenseResponse, DeactivateRecurringExpenseError, Options<DeactivateRecurringExpenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivateRecurringExpense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRentSchedulesQueryKey = (options?: Options<ListRentSchedulesData>) => createQueryKey('listRentSchedules', options);

/**
 * Programul chiriilor organizației, paginat; filtre după contract, proprietate, an, lună și stare; totalurile întregului set filtrat pe fiecare monedă.
 */
export const listRentSchedulesOptions = (options?: Options<ListRentSchedulesData>) => queryOptions<ListRentSchedulesResponse, ListRentSchedulesError, ListRentSchedulesResponse, ReturnType<typeof listRentSchedulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRentSchedules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRentSchedulesQueryKey(options)
});

export const listRentSchedulesInfiniteQueryKey = (options?: Options<ListRentSchedulesData>): QueryKey<Options<ListRentSchedulesData>> => createQueryKey('listRentSchedules', options, true);

/**
 * Programul chiriilor organizației, paginat; filtre după contract, proprietate, an, lună și stare; totalurile întregului set filtrat pe fiecare monedă.
 */
export const listRentSchedulesInfiniteOptions = (options?: Options<ListRentSchedulesData>) => {
    const opts = infiniteQueryOptions<ListRentSchedulesResponse, ListRentSchedulesError, InfiniteData<ListRentSchedulesResponse>, QueryKey<Options<ListRentSchedulesData>>, number | Pick<QueryKey<Options<ListRentSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListRentSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listRentSchedules({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRentSchedulesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listRepairTicketsQueryKey = (options?: Options<ListRepairTicketsData>) => createQueryKey('listRepairTickets', options);

/**
 * Tichetele de reparație ale organizației, paginate; filtre după stare, proprietate, chiriaș, sursă, vechime, depășire și text, cu numărul de tichete din fiecare coloană a panoului.
 */
export const listRepairTicketsOptions = (options?: Options<ListRepairTicketsData>) => queryOptions<ListRepairTicketsResponse, ListRepairTicketsError, ListRepairTicketsResponse, ReturnType<typeof listRepairTicketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRepairTickets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRepairTicketsQueryKey(options)
});

export const listRepairTicketsInfiniteQueryKey = (options?: Options<ListRepairTicketsData>): QueryKey<Options<ListRepairTicketsData>> => createQueryKey('listRepairTickets', options, true);

/**
 * Tichetele de reparație ale organizației, paginate; filtre după stare, proprietate, chiriaș, sursă, vechime, depășire și text, cu numărul de tichete din fiecare coloană a panoului.
 */
export const listRepairTicketsInfiniteOptions = (options?: Options<ListRepairTicketsData>) => {
    const opts = infiniteQueryOptions<ListRepairTicketsResponse, ListRepairTicketsError, InfiniteData<ListRepairTicketsResponse>, QueryKey<Options<ListRepairTicketsData>>, number | Pick<QueryKey<Options<ListRepairTicketsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListRepairTicketsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listRepairTickets({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRepairTicketsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Deschide un tichet de reparație pe o proprietate.
 *
 * Sursa tichetului nu se trimite de client: pe această rută este întotdeauna „proprietar”. Tichetele venite din portalul chiriașului sau printr-un link fără cont sunt deschise de rutele portalului, prin aceeași comandă, și se recunosc după reportedVia.
 */
export const createRepairTicketMutation = (options?: Partial<Options<CreateRepairTicketData>>): UseMutationOptions<CreateRepairTicketResponse, CreateRepairTicketError, Options<CreateRepairTicketData>> => {
    const mutationOptions: UseMutationOptions<CreateRepairTicketResponse, CreateRepairTicketError, Options<CreateRepairTicketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createRepairTicket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRepairTicketQueryKey = (options: Options<GetRepairTicketData>) => createQueryKey('getRepairTicket', options);

/**
 * Un tichet, cu fotografiile, devizul, furnizorul și stările în care poate trece.
 */
export const getRepairTicketOptions = (options: Options<GetRepairTicketData>) => queryOptions<GetRepairTicketResponse, GetRepairTicketError, GetRepairTicketResponse, ReturnType<typeof getRepairTicketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRepairTicket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRepairTicketQueryKey(options)
});

/**
 * Actualizează descrierea, categoria, urgența, chiriașul, furnizorul, notele și fotografiile unui tichet deschis. Schimbarea urgenței recalculează termenul de rezolvare. Nu schimbă starea.
 */
export const updateRepairTicketMutation = (options?: Partial<Options<UpdateRepairTicketData>>): UseMutationOptions<UpdateRepairTicketResponse, UpdateRepairTicketError, Options<UpdateRepairTicketData>> => {
    const mutationOptions: UseMutationOptions<UpdateRepairTicketResponse, UpdateRepairTicketError, Options<UpdateRepairTicketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRepairTicket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Finalizează tichetul.
 *
 * Închiderea cere fie costul final cu o categorie de reparații (REPAIR_*), fie bifa „fără cost”. Costul final devine o cheltuială pe proprietatea tichetului, legată de el prin expenseId, înregistrată ca planificată: închiderea spune că lucrarea s-a terminat și cât a costat, nu că a fost plătită.
 */
export const closeRepairTicketMutation = (options?: Partial<Options<CloseRepairTicketData>>): UseMutationOptions<CloseRepairTicketResponse, CloseRepairTicketError, Options<CloseRepairTicketData>> => {
    const mutationOptions: UseMutationOptions<CloseRepairTicketResponse, CloseRepairTicketError, Options<CloseRepairTicketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await closeRepairTicket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Înregistrează devizul: suma, furnizorul care l-a dat și documentul. Un tichet „deschis” trece în „în lucru”.
 */
export const recordRepairTicketQuoteMutation = (options?: Partial<Options<RecordRepairTicketQuoteData>>): UseMutationOptions<RecordRepairTicketQuoteResponse, RecordRepairTicketQuoteError, Options<RecordRepairTicketQuoteData>> => {
    const mutationOptions: UseMutationOptions<RecordRepairTicketQuoteResponse, RecordRepairTicketQuoteError, Options<RecordRepairTicketQuoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordRepairTicketQuote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Schimbă starea tichetului în „în lucru” sau „anulat”. Tranzițiile nepermise sunt refuzate cu 422.
 */
export const changeRepairTicketStatusMutation = (options?: Partial<Options<ChangeRepairTicketStatusData>>): UseMutationOptions<ChangeRepairTicketStatusResponse, ChangeRepairTicketStatusError, Options<ChangeRepairTicketStatusData>> => {
    const mutationOptions: UseMutationOptions<ChangeRepairTicketStatusResponse, ChangeRepairTicketStatusError, Options<ChangeRepairTicketStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeRepairTicketStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getReportCatalogQueryKey = (options?: Options<GetReportCatalogData>) => createQueryKey('getReportCatalog', options);

/**
 * Catalogul rapoartelor: codul, denumirea, ruta de date, ruta de export și filtrele pe care fiecare le acceptă.
 *
 * Cele zece rapoarte ale specificației §25, în ordinea din planul de implementare. Catalogul nu este restrâns după permisiunile apelantului: un raport pe care nu îl puteți citi există și primește 403 pe ruta lui de date, nu dispare din listă. requiresFiscalPermission spune care rute de date cer Fiscal.Read în locul lui Reports.Read.
 */
export const getReportCatalogOptions = (options?: Options<GetReportCatalogData>) => queryOptions<GetReportCatalogResponse, GetReportCatalogError, GetReportCatalogResponse, ReturnType<typeof getReportCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReportCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportCatalogQueryKey(options)
});

export const getArrearsReportQueryKey = (options?: Options<GetArrearsReportData>) => createQueryKey('getArrearsReport', options);

/**
 * Restanțe: scadențele neîncasate și întârziate, grupate pe vechime, cu penalitățile acumulate.
 *
 * „Restant” înseamnă zile de întârziere pozitive și o sumă rămasă de încasat — exact predicatul pe care motorul de plăți totalizează „valoare totală restanțe”, nu un filtru pe status: o scadență plătită parțial rămâne PARTIALLY_PAID cât timp datoria stă în picioare. Sumele includ penalitățile și nu se adună între monede diferite. Nu există parametru basis: o restanță nu are două citiri. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getArrearsReportOptions = (options?: Options<GetArrearsReportData>) => queryOptions<GetArrearsReportResponse, GetArrearsReportError, GetArrearsReportResponse, ReturnType<typeof getArrearsReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getArrearsReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getArrearsReportQueryKey(options)
});

export const getPortfolioCashFlowQueryKey = (options?: Options<GetPortfolioCashFlowData>) => createQueryKey('getPortfolioCashFlow', options);

/**
 * Cash-flow al portofoliului: totaluri, seria lunară cu cumulatul, liniile memo ale garanțiilor și câte un rând cu verdict pentru fiecare proprietate.
 *
 * Mișcarea reală de bani, pe o proprietate sau pe tot portofoliul (01 BR-LEDGER-02). Încasări: plățile primite, în luna în care au sosit — inclusiv banii încă nerepartizați pe o scadență, care sunt numerar real dar nu aparțin niciunei proprietăți. Plăți: cheltuielile efectiv plătite, INCLUSIV rata integrală a creditului ipotecar — și principal, și dobândă — spre deosebire de P&L economic, unde principalul nu este cost. Garanțiile apar ca linii memo (primite, restituite, reținute) și nu schimbă niciun total: banii nu sunt ai proprietarului. Cheltuielile cu domeniul PERSONAL („Chiriaș la rândul meu”) sunt excluse în SQL, înainte de orice adunare. Cifrele sunt în RON, rotunjite la ban o singură dată, la prezentare. Clasificarea (spec §14; 01 BR-LEDGER-06/07) este calculată pe server și nu se recalculează în client: „lună negativă” și „structural pe minus” sunt câmpuri diferite, decise pe baze diferite — verdictul structural cere atâtea luni CONSECUTIVE cu cash-flow OPERAȚIONAL negativ câte cere configurația (implicit 3), iar one-off-urile / CapEx nu intră în acea bază, ca o reparație mare să facă o lună proastă și nu o proprietate care pierde bani. „Profit redus” este un semnal separat, pe pragul lui (implicit 15% din încasări). Pragurile efective sunt în thresholds. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). Nu există parametru basis: un cash-flow are o singură bază, ziua în care banii s-au mișcat. YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getPortfolioCashFlowOptions = (options?: Options<GetPortfolioCashFlowData>) => queryOptions<GetPortfolioCashFlowResponse, GetPortfolioCashFlowError, GetPortfolioCashFlowResponse, ReturnType<typeof getPortfolioCashFlowQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolioCashFlow({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioCashFlowQueryKey(options)
});

export const getCashLedgerQueryKey = (options?: Options<GetCashLedgerData>) => createQueryKey('getCashLedger', options);

/**
 * Registrul de casă (Bilanț): fiecare mișcare de bani a ferestrei cu sold curent, subtotaluri lunare, matricea apartament × lună și faptele din afara registrului.
 *
 * Registrul de casă: fiecare mișcare reală de bani din fereastră, ca într-o foaie de calcul — un rând pe mișcare, în ordinea datei, cu sold curent, subtotaluri lunare și o matrice apartament × lună. Rândurile sunt exact cele pe care le numără cash-flow-ul (GET /reports/cash-flow), pe aceeași bază — ziua în care banii s-au mișcat — iar totals este egal cu totalurile acelui raport, la ban. Încasări: alocările plăților, cu chiriașii, perioada stinsă și unitatea; creditul nerepartizat doar pe portofoliu. Plăți: cheltuielile efectiv plătite, cu descrierea, furnizorul și factura — inclusiv rata de principal a creditului ipotecar, marcată cashOnly. Garanțiile sunt rânduri memo: apar, nu intră în niciun total și nu mișcă soldul. Soldul curent pornește de la zero în prima zi a ferestrei — V1 nu are un cont bancar din care să îl deschidă. Cheltuielile cu domeniul PERSONAL nu sunt în nicio cifră a registrului. Secțiunea outside („În afara registrului”) listează faptele cu bani care NU s-au mișcat: cheltuieli planificate scadente în fereastră (și cele fără scadență, după data cheltuielii), chirii cu principal restant (penalitatea alături, în niciun total), plăți anunțate de chiriași și neconfirmate, polițe de asigurare fără cheltuială înregistrată, ratele de credit din fișa proprietății pentru lunile fără o plată cash-only înregistrată și, pe portofoliu, facturile de la furnizori fără cheltuială și cheltuielile PERSONAL ale proprietarului. Totalurile secțiunilor nu intră în totals. position („Imaginea completă”) pune alături rezultatul mișcărilor și o ESTIMARE: rezultatul plus chiria de încasat, minus cheltuielile planificate, minus banii ieșiți neînregistrați (polițe, facturi, rate de credit) și — pe o fereastră YEAR sau YTD — minus impozitul pe venit și CASS ale persoanei autentificate (tax, doar pe portofoliu). Estimarea nu intră în niciun total. outByCategory împarte plățile ferestrei pe categorii de cheltuială. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH), quarter (doar pentru QUARTER); propertyId restrânge la un apartament și răspunde 404 dacă nu există. Cifrele sunt în RON, rotunjite la ban o singură dată, cu suma originală și eticheta cursului pe fiecare rând. O fereastră cu peste 5.000 de rânduri sau peste 2.000 de fapte în afara registrului este refuzată cu 422 reporting-ledger-too-large, niciodată trunchiată. YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getCashLedgerOptions = (options?: Options<GetCashLedgerData>) => queryOptions<GetCashLedgerResponse, GetCashLedgerError, GetCashLedgerResponse, ReturnType<typeof getCashLedgerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCashLedger({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCashLedgerQueryKey(options)
});

export const getDashboardQueryKey = (options?: Options<GetDashboardData>) => createQueryKey('getDashboard', options);

/**
 * Panoul general: proprietăți, chiriile lunii curente, cheltuieli și profit economic, cash-flow curent și YTD, proprietăți profitabile / pe minus, restanțe, obligații fiscale, contracte care expiră, revizii și documente care expiră și notificările critice.
 *
 * Panoul general (spec §4): toate cifrele de care are nevoie Dashboard-ul, într-un singur răspuns, compuse din aceleași citiri pe care le servesc rapoartele — nu recalculate. Cifrele economice sunt raportul P&L economic pe bază de angajamente, cash-flow-ul și toate verdictele („pe minus”, „structural pe minus”, „profit redus”) sunt exact cele din /reports/cash-flow, chiriile lunii sunt totalurile programului de chirii, iar restanțele sunt coloanele scrise de recalcularea restanțelor. Clientul NU recalculează nicio clasificare. Ferestrele sunt fixe: luna curentă și de la începutul anului până la ea, în calendarul românesc — nu există parametru de perioadă; pentru altă fereastră există rutele de raport. Obligațiile fiscale sunt ale persoanei conectate — aceleași rânduri ca în /fiscal/obligations, numărate pe status, cu termenul următor; reviziile și documentele sunt numărate cu filtrele registrului de echipamente (active=true&dueBefore) și ale arhivei (expiringWithinDays), în orizontul din payload.
 */
export const getDashboardOptions = (options?: Options<GetDashboardData>) => queryOptions<GetDashboardResponse, GetDashboardError, GetDashboardResponse, ReturnType<typeof getDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardQueryKey(options)
});

export const getDeclarationStatusReportQueryKey = (options?: Options<GetDeclarationStatusReportData>) => createQueryKey('getDeclarationStatusReport', options);

/**
 * Declarații și statusuri: registrul formularelor pregătite și starea depunerii lor pentru anul cerut.
 *
 * În V1 statusurile de depunere sunt înregistrate manual: aplicația nu apelează niciun serviciu ANAF autentificat, iar „depusă”, „în procesare”, „acceptată” și „respinsă” provin din indexul de încărcare și din recipisa înregistrate de utilizator. fiscalYear implicit este anul calendaristic curent; ownerId restrânge la un proprietar — o declarație nu are coloană de proprietar, ci răspunde unei obligații, iar obligația îl numește. Răspunsul poartă mențiunea legală a specificației §38 (disclaimerRo) și sursele oficiale ale regulilor anului cu data ultimei verificări (ruleSources) — ambele se randează pe orice suprafață fiscală, pe ecran și în PDF deopotrivă (01 BR-LEGAL-01/02).
 */
export const getDeclarationStatusReportOptions = (options?: Options<GetDeclarationStatusReportData>) => queryOptions<GetDeclarationStatusReportResponse, GetDeclarationStatusReportError, GetDeclarationStatusReportResponse, ReturnType<typeof getDeclarationStatusReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeclarationStatusReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeclarationStatusReportQueryKey(options)
});

export const listFiscalDossiersQueryKey = (options?: Options<ListFiscalDossiersData>) => createQueryKey('listFiscalDossiers', options);

/**
 * Dosarele persoanei autentificate, cel mai nou primul.
 *
 * Dosarul fiscal anual: o singură arhivă ZIP pentru persoana autentificată și un an fiscal încheiat, cu toate proprietățile în care aceasta a deținut o cotă în acel an: P&L economic și cash-flow, situația fiscală cu sursele oficiale ale regulilor, artefactele declarațiilor, dovezile depunerii, facturile anului și o copertă cu mențiunea legală. Nu se alege un proprietar: dosarul este întotdeauna al celui care îl cere. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. manifest.json din rădăcina arhivei conține calea, dimensiunea și amprenta SHA-256 ale fiecărui fișier. Linkul de descărcare expiră; după expirare se generează din nou, din datele de atunci. Secțiunea economică arată rezultatele întregi ale proprietăților, nu împărțite pe cote.
 */
export const listFiscalDossiersOptions = (options?: Options<ListFiscalDossiersData>) => queryOptions<ListFiscalDossiersResponse, ListFiscalDossiersError, ListFiscalDossiersResponse, ReturnType<typeof listFiscalDossiersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFiscalDossiers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFiscalDossiersQueryKey(options)
});

export const listFiscalDossiersInfiniteQueryKey = (options?: Options<ListFiscalDossiersData>): QueryKey<Options<ListFiscalDossiersData>> => createQueryKey('listFiscalDossiers', options, true);

/**
 * Dosarele persoanei autentificate, cel mai nou primul.
 *
 * Dosarul fiscal anual: o singură arhivă ZIP pentru persoana autentificată și un an fiscal încheiat, cu toate proprietățile în care aceasta a deținut o cotă în acel an: P&L economic și cash-flow, situația fiscală cu sursele oficiale ale regulilor, artefactele declarațiilor, dovezile depunerii, facturile anului și o copertă cu mențiunea legală. Nu se alege un proprietar: dosarul este întotdeauna al celui care îl cere. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. manifest.json din rădăcina arhivei conține calea, dimensiunea și amprenta SHA-256 ale fiecărui fișier. Linkul de descărcare expiră; după expirare se generează din nou, din datele de atunci. Secțiunea economică arată rezultatele întregi ale proprietăților, nu împărțite pe cote.
 */
export const listFiscalDossiersInfiniteOptions = (options?: Options<ListFiscalDossiersData>) => {
    const opts = infiniteQueryOptions<ListFiscalDossiersResponse, ListFiscalDossiersError, InfiniteData<ListFiscalDossiersResponse>, QueryKey<Options<ListFiscalDossiersData>>, number | Pick<QueryKey<Options<ListFiscalDossiersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFiscalDossiersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFiscalDossiers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFiscalDossiersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Cere generarea dosarului fiscal anual al persoanei autentificate, pentru un an încheiat.
 *
 * Dosarul fiscal anual: o singură arhivă ZIP pentru persoana autentificată și un an fiscal încheiat, cu toate proprietățile în care aceasta a deținut o cotă în acel an: P&L economic și cash-flow, situația fiscală cu sursele oficiale ale regulilor, artefactele declarațiilor, dovezile depunerii, facturile anului și o copertă cu mențiunea legală. Nu se alege un proprietar: dosarul este întotdeauna al celui care îl cere. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. manifest.json din rădăcina arhivei conține calea, dimensiunea și amprenta SHA-256 ale fiecărui fișier. Linkul de descărcare expiră; după expirare se generează din nou, din datele de atunci. Secțiunea economică arată rezultatele întregi ale proprietăților, nu împărțite pe cote.
 */
export const requestFiscalDossierMutation = (options?: Partial<Options<RequestFiscalDossierData>>): UseMutationOptions<RequestFiscalDossierResponse, RequestFiscalDossierError, Options<RequestFiscalDossierData>> => {
    const mutationOptions: UseMutationOptions<RequestFiscalDossierResponse, RequestFiscalDossierError, Options<RequestFiscalDossierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestFiscalDossier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFiscalDossierQueryKey = (options: Options<GetFiscalDossierData>) => createQueryKey('getFiscalDossier', options);

/**
 * Starea unui dosar, pentru ecranul care așteaptă construirea arhivei.
 *
 * Dosarul fiscal anual: o singură arhivă ZIP pentru persoana autentificată și un an fiscal încheiat, cu toate proprietățile în care aceasta a deținut o cotă în acel an: P&L economic și cash-flow, situația fiscală cu sursele oficiale ale regulilor, artefactele declarațiilor, dovezile depunerii, facturile anului și o copertă cu mențiunea legală. Nu se alege un proprietar: dosarul este întotdeauna al celui care îl cere. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. manifest.json din rădăcina arhivei conține calea, dimensiunea și amprenta SHA-256 ale fiecărui fișier. Linkul de descărcare expiră; după expirare se generează din nou, din datele de atunci. Secțiunea economică arată rezultatele întregi ale proprietăților, nu împărțite pe cote.
 */
export const getFiscalDossierOptions = (options: Options<GetFiscalDossierData>) => queryOptions<GetFiscalDossierResponse, GetFiscalDossierError, GetFiscalDossierResponse, ReturnType<typeof getFiscalDossierQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiscalDossier({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiscalDossierQueryKey(options)
});

export const downloadFiscalDossierQueryKey = (options: Options<DownloadFiscalDossierData>) => createQueryKey('downloadFiscalDossier', options);

/**
 * Descarcă arhiva. Descărcarea se jurnalizează în trasabilitatea de audit.
 *
 * Dosarul fiscal anual: o singură arhivă ZIP pentru persoana autentificată și un an fiscal încheiat, cu toate proprietățile în care aceasta a deținut o cotă în acel an: P&L economic și cash-flow, situația fiscală cu sursele oficiale ale regulilor, artefactele declarațiilor, dovezile depunerii, facturile anului și o copertă cu mențiunea legală. Nu se alege un proprietar: dosarul este întotdeauna al celui care îl cere. Arhiva se construiește în fundal — cererea răspunde imediat cu starea, iar descărcarea devine disponibilă când starea este READY. manifest.json din rădăcina arhivei conține calea, dimensiunea și amprenta SHA-256 ale fiecărui fișier. Linkul de descărcare expiră; după expirare se generează din nou, din datele de atunci. Secțiunea economică arată rezultatele întregi ale proprietăților, nu împărțite pe cote.
 */
export const downloadFiscalDossierOptions = (options: Options<DownloadFiscalDossierData>) => queryOptions<DownloadFiscalDossierResponse, DownloadFiscalDossierError, DownloadFiscalDossierResponse, ReturnType<typeof downloadFiscalDossierQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadFiscalDossier({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadFiscalDossierQueryKey(options)
});

export const getPortfolioEconomicPnlQueryKey = (options?: Options<GetPortfolioEconomicPnlData>) => createQueryKey('getPortfolioEconomicPnl', options);

/**
 * P&L economic al portofoliului: totaluri, seria lunară, defalcarea pe categorii și câte un rând pentru fiecare proprietate.
 *
 * Jumătatea ECONOMICĂ a criteriului 6 din specificație: venituri reale (chirie încasată, garanții reținute) minus TOATE costurile reale, indiferent de statusul lor fiscal — inclusiv cele NEDEDUCTIBILE. Situația fiscală nu apare aici sub nicio formă: este livrată separat de motorul fiscal (M4) și nu se contopește niciodată cu aceste cifre. Cheltuielile cu domeniul PERSONAL („Chiriaș la rândul meu”) sunt excluse în SQL, înainte de orice adunare. Cifrele sunt în RON, rotunjite la ban o singură dată, la prezentare; fluxurile în altă monedă sunt convertite la citire la cursul BNR al datei lor și etichetate „estimativ, curs BNR din …”. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). Baza: basis=ACCRUAL|CASH (implicit ACCRUAL). YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getPortfolioEconomicPnlOptions = (options?: Options<GetPortfolioEconomicPnlData>) => queryOptions<GetPortfolioEconomicPnlResponse, GetPortfolioEconomicPnlError, GetPortfolioEconomicPnlResponse, ReturnType<typeof getPortfolioEconomicPnlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolioEconomicPnl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioEconomicPnlQueryKey(options)
});

export const getExpenseCategoryReportQueryKey = (options?: Options<GetExpenseCategoryReportData>) => createQueryKey('getExpenseCategoryReport', options);

/**
 * Cheltuieli pe categorii: costul real defalcat, cu seria operațională separată de cea one-off / CapEx.
 *
 * Jumătatea de cost a P&L economic. Rândurile cash-flow-only (principalul creditului ipotecar) nu sunt cost aici — le exclude indicatorul includeInPnl al cheltuielii, stabilit din categorie. Cifrele sunt cele ale motorului economic (FIN-001): raportul interoghează motorul și nu recalculează nimic, așa că nu pot să difere de P&L economic. Baza: basis=ACCRUAL|CASH (implicit ACCRUAL) — care lună revendică un flux, nu ce intră în el. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getExpenseCategoryReportOptions = (options?: Options<GetExpenseCategoryReportData>) => queryOptions<GetExpenseCategoryReportResponse, GetExpenseCategoryReportError, GetExpenseCategoryReportResponse, ReturnType<typeof getExpenseCategoryReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExpenseCategoryReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExpenseCategoryReportQueryKey(options)
});

export const getFiscalObligationReportQueryKey = (options?: Options<GetFiscalObligationReportData>) => createQueryKey('getFiscalObligationReport', options);

/**
 * Taxe și obligații fiscale: verdictele motorului fiscal pentru anul cerut, cu status, termen și numărul pe fiecare verdict.
 *
 * Rândurile sunt verdictele deja evaluate și stocate — raportul nu recalculează nicio obligație și niciun termen. Verdictele NOT_REQUIRED apar ca oricare altele: absența unei obligații este produsul, nu o linie de ascuns. fiscalYear implicit este anul calendaristic curent; ownerId restrânge la un proprietar. Răspunsul poartă mențiunea legală a specificației §38 (disclaimerRo) și sursele oficiale ale regulilor anului cu data ultimei verificări (ruleSources) — ambele se randează pe orice suprafață fiscală, pe ecran și în PDF deopotrivă (01 BR-LEGAL-01/02).
 */
export const getFiscalObligationReportOptions = (options?: Options<GetFiscalObligationReportData>) => queryOptions<GetFiscalObligationReportResponse, GetFiscalObligationReportError, GetFiscalObligationReportResponse, ReturnType<typeof getFiscalObligationReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiscalObligationReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiscalObligationReportQueryKey(options)
});

export const getIncomeReportQueryKey = (options?: Options<GetIncomeReportData>) => createQueryKey('getIncomeReport', options);

/**
 * Venituri lunare și anuale: chiria efectiv încasată și garanțiile reținute, lună de lună și pe proprietate.
 *
 * Jumătatea de venit a P&L economic, ca raport de sine stătător. Cifrele sunt cele ale motorului economic (FIN-001): raportul interoghează motorul și nu recalculează nimic, așa că nu pot să difere de P&L economic. Baza: basis=ACCRUAL|CASH (implicit ACCRUAL) — care lună revendică un flux, nu ce intră în el. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getIncomeReportOptions = (options?: Options<GetIncomeReportData>) => queryOptions<GetIncomeReportResponse, GetIncomeReportError, GetIncomeReportResponse, ReturnType<typeof getIncomeReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIncomeReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIncomeReportQueryKey(options)
});

export const getInvestmentYieldReportQueryKey = (options?: Options<GetInvestmentYieldReportData>) => createQueryKey('getInvestmentYieldReport', options);

/**
 * Randament investiție: randamentul brut și net raportat la costul de achiziție, cu datele investiției.
 *
 * Formula este tipărită pe raport, în header.definitionRo. Numărătorii vin din P&L economic pe bază de angajamente; numitorul este prețul de achiziție plus celelalte costuri de achiziție. O proprietate fără preț de achiziție, sau cu unul într-o monedă pentru care nu există curs BNR la data achiziției, apare în excluded cu motivul — niciodată cu randament 0. Nu există parametru basis: un randament este o cifră economică. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getInvestmentYieldReportOptions = (options?: Options<GetInvestmentYieldReportData>) => queryOptions<GetInvestmentYieldReportResponse, GetInvestmentYieldReportError, GetInvestmentYieldReportResponse, ReturnType<typeof getInvestmentYieldReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestmentYieldReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestmentYieldReportQueryKey(options)
});

export const getOccupancyReportQueryKey = (options?: Options<GetOccupancyReportData>) => createQueryKey('getOccupancyReport', options);

/**
 * Grad de ocupare: zile acoperite de contract raportate la zile disponibile, pe perioada cerută.
 *
 * Definiția este tipărită pe raport, în header.definitionRo, și este aceeași pe ecran și în PDF. O proprietate cu unități are câte un loc închiriabil pentru fiecare unitate; una fără unități are unul singur. Un contract pe proprietate acoperă toate locurile ei, iar zilele acoperite de două contracte se numără o singură dată. O linie fără zile disponibile are gradul null, nu 0. Perioada: period=MONTH|QUARTER|YEAR|YTD (implicit YTD), year (implicit anul curent), month (doar pentru MONTH, implicit luna curentă), quarter (doar pentru QUARTER, implicit trimestrul curent). YTD pentru un an viitor este refuzat cu 422 reporting-period-in-future.
 */
export const getOccupancyReportOptions = (options?: Options<GetOccupancyReportData>) => queryOptions<GetOccupancyReportResponse, GetOccupancyReportError, GetOccupancyReportResponse, ReturnType<typeof getOccupancyReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOccupancyReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOccupancyReportQueryKey(options)
});

export const exportReportQueryKey = (options: Options<ExportReportData>) => createQueryKey('exportReport', options);

/**
 * Exportă un raport ca PDF, din aceleași cifre pe care le afișează previzualizarea.
 *
 * Randează raportul cerut ca PDF (QuestPDF, ro-RO, cu siglă și diacritice) din exact aceleași cifre pe care le întoarce ruta lui de date — exportul este o randare a răspunsului, nu o a doua interogare. Formatul xlsx este refuzat cu 422 report-export-format-unsupported: exportul Excel se produce în aplicație, din același contract de date (04 §9.8, riscul R1 asumat de 05 REPORT-001). Un cod care nu există în catalog primește 404; un filtru pe care raportul nu îl acceptă primește 422 report-filter-not-supported, pentru că un filtru ignorat în tăcere este un raport pe care apelantul îl crede mai îngust decât este. Parametrul format se citește fără deosebire între majuscule și minuscule, iar o valoare pe care contractul nu o numește primește tot 422 report-export-format-unsupported.
 */
export const exportReportOptions = (options: Options<ExportReportData>) => queryOptions<unknown, ExportReportError, unknown, ReturnType<typeof exportReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportReportQueryKey(options)
});

export const listSuppliersQueryKey = (options?: Options<ListSuppliersData>) => createQueryKey('listSuppliers', options);

/**
 * Furnizorii organizației, paginați; căutare după nume, CUI, IBAN, e-mail sau telefon.
 */
export const listSuppliersOptions = (options?: Options<ListSuppliersData>) => queryOptions<ListSuppliersResponse, ListSuppliersError, ListSuppliersResponse, ReturnType<typeof listSuppliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSuppliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSuppliersQueryKey(options)
});

export const listSuppliersInfiniteQueryKey = (options?: Options<ListSuppliersData>): QueryKey<Options<ListSuppliersData>> => createQueryKey('listSuppliers', options, true);

/**
 * Furnizorii organizației, paginați; căutare după nume, CUI, IBAN, e-mail sau telefon.
 */
export const listSuppliersInfiniteOptions = (options?: Options<ListSuppliersData>) => {
    const opts = infiniteQueryOptions<ListSuppliersResponse, ListSuppliersError, InfiniteData<ListSuppliersResponse>, QueryKey<Options<ListSuppliersData>>, number | Pick<QueryKey<Options<ListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSuppliers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSuppliersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă un furnizor.
 *
 * CUI-ul este verificat local, prin cifra de control (422 cui-invalid-checksum). V1 nu face nicio interogare la ANAF — nici măcar serviciul public de TVA — așa că cuiValidationResult și cuiValidatedAtUtc rămân null și insigna afișată este „neverificat” pentru orice CUI corect. Salvarea nu depinde de nicio verificare externă: un furnizor se poate înregistra oricând. isVatPayer se completează manual în V1.
 */
export const createSupplierMutation = (options?: Partial<Options<CreateSupplierData>>): UseMutationOptions<CreateSupplierResponse, CreateSupplierError, Options<CreateSupplierData>> => {
    const mutationOptions: UseMutationOptions<CreateSupplierResponse, CreateSupplierError, Options<CreateSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ștergere logică; refuzată (422 supplier-has-invoices) cât timp furnizorul are facturi.
 */
export const deleteSupplierMutation = (options?: Partial<Options<DeleteSupplierData>>): UseMutationOptions<DeleteSupplierResponse, DeleteSupplierError, Options<DeleteSupplierData>> => {
    const mutationOptions: UseMutationOptions<DeleteSupplierResponse, DeleteSupplierError, Options<DeleteSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSupplierQueryKey = (options: Options<GetSupplierData>) => createQueryKey('getSupplier', options);

/**
 * Un furnizor, cu numărul de facturi înregistrate și dacă mai poate fi șters.
 */
export const getSupplierOptions = (options: Options<GetSupplierData>) => queryOptions<GetSupplierResponse, GetSupplierError, GetSupplierResponse, ReturnType<typeof getSupplierQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSupplier({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSupplierQueryKey(options)
});

/**
 * Înlocuiește datele furnizorului.
 *
 * CUI-ul este verificat local, prin cifra de control (422 cui-invalid-checksum). V1 nu face nicio interogare la ANAF — nici măcar serviciul public de TVA — așa că cuiValidationResult și cuiValidatedAtUtc rămân null și insigna afișată este „neverificat” pentru orice CUI corect. Salvarea nu depinde de nicio verificare externă: un furnizor se poate înregistra oricând. isVatPayer se completează manual în V1.
 */
export const updateSupplierMutation = (options?: Partial<Options<UpdateSupplierData>>): UseMutationOptions<UpdateSupplierResponse, UpdateSupplierError, Options<UpdateSupplierData>> => {
    const mutationOptions: UseMutationOptions<UpdateSupplierResponse, UpdateSupplierError, Options<UpdateSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTaskItemsQueryKey = (options?: Options<ListTaskItemsData>) => createQueryKey('listTaskItems', options);

/**
 * Sarcinile organizației, paginate: CRITIC întâi, apoi după scadență, apoi după vechime.
 *
 * Lista „Ce trebuie să fac?”. Ordinea este fixă și nu se poate schimba din query string: CRITIC înaintea IMPORTANT înaintea INFORMATIV, apoi după scadență (cele fără scadență la final), apoi cele mai vechi primele. Filtrele sunt cele din SCR-ACT-001: proprietate, tip și stare. Filtrul de proprietate se rezolvă prin sursa sarcinii — o sarcină fără proprietate în spate (cele fiscale, din M4) nu apare într-o listă filtrată pe proprietate. Fără filtru de stare lista conține și istoricul: sarcinile rezolvate și cele respinse. open=true păstrează doar sarcinile care încă așteaptă (deschise sau în lucru), open=false doar pe cele închise (rezolvate sau respinse). due alege fereastra termenului față de ziua de azi din România: OVERDUE (depășit), DUE_SOON (azi sau în următoarele 7 zile), LATER (mai târziu), UNDATED (fără termen). Fiecare rând poartă proprietatea la care duce sursa lui, când duce la una.
 */
export const listTaskItemsOptions = (options?: Options<ListTaskItemsData>) => queryOptions<ListTaskItemsResponse, ListTaskItemsError, ListTaskItemsResponse, ReturnType<typeof listTaskItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTaskItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTaskItemsQueryKey(options)
});

export const listTaskItemsInfiniteQueryKey = (options?: Options<ListTaskItemsData>): QueryKey<Options<ListTaskItemsData>> => createQueryKey('listTaskItems', options, true);

/**
 * Sarcinile organizației, paginate: CRITIC întâi, apoi după scadență, apoi după vechime.
 *
 * Lista „Ce trebuie să fac?”. Ordinea este fixă și nu se poate schimba din query string: CRITIC înaintea IMPORTANT înaintea INFORMATIV, apoi după scadență (cele fără scadență la final), apoi cele mai vechi primele. Filtrele sunt cele din SCR-ACT-001: proprietate, tip și stare. Filtrul de proprietate se rezolvă prin sursa sarcinii — o sarcină fără proprietate în spate (cele fiscale, din M4) nu apare într-o listă filtrată pe proprietate. Fără filtru de stare lista conține și istoricul: sarcinile rezolvate și cele respinse. open=true păstrează doar sarcinile care încă așteaptă (deschise sau în lucru), open=false doar pe cele închise (rezolvate sau respinse). due alege fereastra termenului față de ziua de azi din România: OVERDUE (depășit), DUE_SOON (azi sau în următoarele 7 zile), LATER (mai târziu), UNDATED (fără termen). Fiecare rând poartă proprietatea la care duce sursa lui, când duce la una.
 */
export const listTaskItemsInfiniteOptions = (options?: Options<ListTaskItemsData>) => {
    const opts = infiniteQueryOptions<ListTaskItemsResponse, ListTaskItemsError, InfiniteData<ListTaskItemsResponse>, QueryKey<Options<ListTaskItemsData>>, number | Pick<QueryKey<Options<ListTaskItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTaskItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTaskItems({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTaskItemsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const summarizeTaskItemsQueryKey = (options?: Options<SummarizeTaskItemsData>) => createQueryKey('summarizeTaskItems', options);

/**
 * Câte sarcini are fiecare filă, fereastră de termen și tip, sub celelalte filtre.
 *
 * Numărătorile de deasupra listei „Ce trebuie să fac?”: cele două file (sarcini care așteaptă și sarcini închise), cele patru ferestre de termen ale sarcinilor care așteaptă și numărul pe fiecare tip. Fiecare numărătoare ignoră propriul filtru și le aplică pe celelalte: filele și ferestrele țin cont de proprietate și tip, tipurile țin cont de proprietate, filă (open) și fereastră (due). Aceleași reguli de vizibilitate ca lista.
 */
export const summarizeTaskItemsOptions = (options?: Options<SummarizeTaskItemsData>) => queryOptions<SummarizeTaskItemsResponse, SummarizeTaskItemsError, SummarizeTaskItemsResponse, ReturnType<typeof summarizeTaskItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await summarizeTaskItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: summarizeTaskItemsQueryKey(options)
});

/**
 * Mută o sarcină în „în lucru”, „rezolvat” sau „respins”. Tranzițiile nepermise sunt refuzate cu 422.
 *
 * Stările pe care le poate seta un utilizator sunt cele din câmpul settable al rândului. „Rezolvat” și „respins” sunt finale: o sarcină respinsă revine doar dacă starea de fapt escaladează (restanța trece de la 10 la 30 de zile), iar una rezolvată revine dacă următoarea evaluare găsește condiția tot acolo. Respingerea este o acțiune de utilizator și se auditează. A cere starea în care sarcina se află deja nu este o eroare și nu schimbă nimic.
 */
export const changeTaskItemStatusMutation = (options?: Partial<Options<ChangeTaskItemStatusData>>): UseMutationOptions<ChangeTaskItemStatusResponse, ChangeTaskItemStatusError, Options<ChangeTaskItemStatusData>> => {
    const mutationOptions: UseMutationOptions<ChangeTaskItemStatusResponse, ChangeTaskItemStatusError, Options<ChangeTaskItemStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeTaskItemStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTenantsQueryKey = (options?: Options<ListTenantsData>) => createQueryKey('listTenants', options);

/**
 * Chiriașii organizației, paginați; căutare după nume, CUI, e-mail sau telefon.
 */
export const listTenantsOptions = (options?: Options<ListTenantsData>) => queryOptions<ListTenantsResponse, ListTenantsError, ListTenantsResponse, ReturnType<typeof listTenantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTenants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTenantsQueryKey(options)
});

export const listTenantsInfiniteQueryKey = (options?: Options<ListTenantsData>): QueryKey<Options<ListTenantsData>> => createQueryKey('listTenants', options, true);

/**
 * Chiriașii organizației, paginați; căutare după nume, CUI, e-mail sau telefon.
 */
export const listTenantsInfiniteOptions = (options?: Options<ListTenantsData>) => {
    const opts = infiniteQueryOptions<ListTenantsResponse, ListTenantsError, InfiniteData<ListTenantsResponse>, QueryKey<Options<ListTenantsData>>, number | Pick<QueryKey<Options<ListTenantsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTenantsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTenants({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTenantsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă un chiriaș persoană fizică sau juridică. `forPropertyId` spune sub ce organizație se înregistrează, atunci când contul aparține mai multora.
 *
 * Minimizarea datelor (GDPR, spec §6/§31): un chiriaș persoană fizică este un nume și o cale de contact; CNP-ul nu este cerut și se trimite doar când înregistrarea contractului la ANAF îl justifică. Este acceptat numai pentru persoane fizice, este criptat AES-256-GCM înainte de stocare și nu este returnat de niciun endpoint — răspunsul indică doar hasCnp. Pentru persoane juridice, CUI-ul este verificat local prin cifra de control (422 cui-invalid-checksum); V1 nu face nicio verificare la ANAF, iar cuiValidationResult rămâne null („neverificat”).
 */
export const createTenantMutation = (options?: Partial<Options<CreateTenantData>>): UseMutationOptions<CreateTenantResponse, CreateTenantError, Options<CreateTenantData>> => {
    const mutationOptions: UseMutationOptions<CreateTenantResponse, CreateTenantError, Options<CreateTenantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTenant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ștergere logică; refuzată (422 tenant-has-active-contract) cât timp există un contract activ.
 */
export const deleteTenantMutation = (options?: Partial<Options<DeleteTenantData>>): UseMutationOptions<DeleteTenantResponse, DeleteTenantError, Options<DeleteTenantData>> => {
    const mutationOptions: UseMutationOptions<DeleteTenantResponse, DeleteTenantError, Options<DeleteTenantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTenant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTenantQueryKey = (options: Options<GetTenantData>) => createQueryKey('getTenant', options);

/**
 * Profilul unui chiriaș, cu numărul de contracte active și dacă tipul de contribuabil mai poate fi schimbat.
 */
export const getTenantOptions = (options: Options<GetTenantData>) => queryOptions<GetTenantResponse, GetTenantError, GetTenantResponse, ReturnType<typeof getTenantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTenant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTenantQueryKey(options)
});

/**
 * Înlocuiește profilul; tipul de contribuabil este refuzat (422 taxpayer-type-immutable) cât timp există un contract activ.
 *
 * Minimizarea datelor (GDPR, spec §6/§31): un chiriaș persoană fizică este un nume și o cale de contact; CNP-ul nu este cerut și se trimite doar când înregistrarea contractului la ANAF îl justifică. Este acceptat numai pentru persoane fizice, este criptat AES-256-GCM înainte de stocare și nu este returnat de niciun endpoint — răspunsul indică doar hasCnp. Pentru persoane juridice, CUI-ul este verificat local prin cifra de control (422 cui-invalid-checksum); V1 nu face nicio verificare la ANAF, iar cuiValidationResult rămâne null („neverificat”).
 */
export const updateTenantMutation = (options?: Partial<Options<UpdateTenantData>>): UseMutationOptions<UpdateTenantResponse, UpdateTenantError, Options<UpdateTenantData>> => {
    const mutationOptions: UseMutationOptions<UpdateTenantResponse, UpdateTenantError, Options<UpdateTenantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTenant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTenantContactsQueryKey = (options: Options<GetTenantContactsData>) => createQueryKey('getTenantContacts', options);

/**
 * Toate contactele chiriașului, ca set, nu ca pagină.
 */
export const getTenantContactsOptions = (options: Options<GetTenantContactsData>) => queryOptions<GetTenantContactsResponse, GetTenantContactsError, GetTenantContactsResponse, ReturnType<typeof getTenantContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTenantContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTenantContactsQueryKey(options)
});

/**
 * Înlocuiește întregul set de contacte; cel mult un contact principal pe fiecare tip de canal.
 */
export const setTenantContactsMutation = (options?: Partial<Options<SetTenantContactsData>>): UseMutationOptions<SetTenantContactsResponse, SetTenantContactsError, Options<SetTenantContactsData>> => {
    const mutationOptions: UseMutationOptions<SetTenantContactsResponse, SetTenantContactsError, Options<SetTenantContactsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setTenantContacts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTenantContractsQueryKey = (options: Options<ListTenantContractsData>) => createQueryKey('listTenantContracts', options);

/**
 * Istoricul contractelor chiriașului, paginat; gol până la CON-001.
 */
export const listTenantContractsOptions = (options: Options<ListTenantContractsData>) => queryOptions<ListTenantContractsResponse, ListTenantContractsError, ListTenantContractsResponse, ReturnType<typeof listTenantContractsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTenantContracts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTenantContractsQueryKey(options)
});

export const listTenantContractsInfiniteQueryKey = (options: Options<ListTenantContractsData>): QueryKey<Options<ListTenantContractsData>> => createQueryKey('listTenantContracts', options, true);

/**
 * Istoricul contractelor chiriașului, paginat; gol până la CON-001.
 */
export const listTenantContractsInfiniteOptions = (options: Options<ListTenantContractsData>) => {
    const opts = infiniteQueryOptions<ListTenantContractsResponse, ListTenantContractsError, InfiniteData<ListTenantContractsResponse>, QueryKey<Options<ListTenantContractsData>>, number | Pick<QueryKey<Options<ListTenantContractsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTenantContractsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTenantContracts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTenantContractsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Creează un cont de portal fără e-mail pentru chiriaș și răspunde cu datele de autentificare.
 *
 * Pentru chiriașul care nu are o adresă de e-mail. Contul primește un nume de utilizator derivat din numele chiriașului și o parolă temporară, valabilă 7 zile, pe care proprietarul o tipărește și i-o înmânează. Parola temporară nu deschide o sesiune: la prima autentificare chiriașul își alege propria parolă. Răspunsul este singurul loc în care parola temporară există; în tabel se păstrează doar amprenta ei. Chiriașul cu adresă de e-mail primește 422 portal-tenant-has-email (i se trimite invitația), iar cel care are deja acces 422 portal-tenant-already-linked.
 */
export const createPortalAccountMutation = (options?: Partial<Options<CreatePortalAccountData>>): UseMutationOptions<CreatePortalAccountResponse, CreatePortalAccountError, Options<CreatePortalAccountData>> => {
    const mutationOptions: UseMutationOptions<CreatePortalAccountResponse, CreatePortalAccountError, Options<CreatePortalAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPortalAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Emite o nouă parolă temporară pentru contul fără e-mail al chiriașului.
 *
 * Singura resetare a unui cont fără adresă de e-mail. Parola anterioară nu mai funcționează, sesiunile deschise ale contului se închid, iar blocarea după încercări eșuate se ridică. Se poate cere doar cât timp contul nu are o adresă de e-mail și nu aparține altei organizații decât celei care îl închiriază (altfel 422 portal-account-not-managed); chiriașul fără cont primește 422 portal-account-missing.
 */
export const issuePortalAccountPasswordMutation = (options?: Partial<Options<IssuePortalAccountPasswordData>>): UseMutationOptions<IssuePortalAccountPasswordResponse, IssuePortalAccountPasswordError, Options<IssuePortalAccountPasswordData>> => {
    const mutationOptions: UseMutationOptions<IssuePortalAccountPasswordResponse, IssuePortalAccountPasswordError, Options<IssuePortalAccountPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await issuePortalAccountPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Creează invitația de acces în portal și răspunde cu linkul ei.
 *
 * Adresa este cea a chiriașului și nu se trimite de client. Chiriașul fără email primește 422 portal-tenant-has-no-email, iar cel care are deja acces 422 portal-tenant-already-linked. Răspunsul conține acceptUrl, singurul moment în care linkul există: în tabel se păstrează doar amprenta lui. Linkul pleacă și prin email, se acceptă la /api/v1/invitations/accept ca orice invitație, doar de pe adresa invitată, iar la acceptare fișa chiriașului este legată de cont. Dacă o invitație este deja în așteptare pentru adresa aceasta, ea este anulată și înlocuită de cea nouă. Dacă adresa a primit deja prea multe e-mailuri în ultima vreme, răspunsul este 429 email-recipient-rate-limited și nu se schimbă nimic: invitația aflată deja în căsuța chiriașului rămâne valabilă.
 */
export const invitePortalUserMutation = (options?: Partial<Options<InvitePortalUserData>>): UseMutationOptions<InvitePortalUserResponse, InvitePortalUserError, Options<InvitePortalUserData>> => {
    const mutationOptions: UseMutationOptions<InvitePortalUserResponse, InvitePortalUserError, Options<InvitePortalUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await invitePortalUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) => createQueryKey('getCurrentUser', options);

/**
 * Profilul, organizațiile și permisiunile utilizatorului autentificat.
 */
export const getCurrentUserOptions = (options?: Options<GetCurrentUserData>) => queryOptions<GetCurrentUserResponse, GetCurrentUserError, GetCurrentUserResponse, ReturnType<typeof getCurrentUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCurrentUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentUserQueryKey(options)
});

/**
 * Actualizează numele și telefonul contului autentificat.
 */
export const updateProfileMutation = (options?: Partial<Options<UpdateProfileData>>): UseMutationOptions<UpdateProfileResponse, UpdateProfileError, Options<UpdateProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateProfileResponse, UpdateProfileError, Options<UpdateProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Schimbă parola contului curent; toate sesiunile sunt invalidate.
 */
export const changePasswordMutation = (options?: Partial<Options<ChangePasswordData>>): UseMutationOptions<ChangePasswordResponse, ChangePasswordError, Options<ChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<ChangePasswordResponse, ChangePasswordError, Options<ChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listActiveSessionsQueryKey = (options?: Options<ListActiveSessionsData>) => createQueryKey('listActiveSessions', options);

/**
 * Sesiunile active ale contului autentificat, cea curentă prima.
 */
export const listActiveSessionsOptions = (options?: Options<ListActiveSessionsData>) => queryOptions<ListActiveSessionsResponse, ListActiveSessionsError, ListActiveSessionsResponse, ReturnType<typeof listActiveSessionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActiveSessions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActiveSessionsQueryKey(options)
});

/**
 * Închide toate sesiunile contului autentificat, în afară de cea curentă.
 */
export const endOtherSessionsMutation = (options?: Partial<Options<EndOtherSessionsData>>): UseMutationOptions<EndOtherSessionsResponse, EndOtherSessionsError, Options<EndOtherSessionsData>> => {
    const mutationOptions: UseMutationOptions<EndOtherSessionsResponse, EndOtherSessionsError, Options<EndOtherSessionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await endOtherSessions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Închide o sesiune a contului autentificat; dispozitivul ei pierde accesul la următoarea reîmprospătare, în cel mult 15 minute.
 */
export const endSessionMutation = (options?: Partial<Options<EndSessionData>>): UseMutationOptions<EndSessionResponse, EndSessionError, Options<EndSessionData>> => {
    const mutationOptions: UseMutationOptions<EndSessionResponse, EndSessionError, Options<EndSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await endSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUtilityServicesQueryKey = (options?: Options<ListUtilityServicesData>) => createQueryKey('listUtilityServices', options);

/**
 * Utilitățile organizației, paginate; căutare după furnizor, număr de contract sau POD.
 */
export const listUtilityServicesOptions = (options?: Options<ListUtilityServicesData>) => queryOptions<ListUtilityServicesResponse, ListUtilityServicesError, ListUtilityServicesResponse, ReturnType<typeof listUtilityServicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUtilityServices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUtilityServicesQueryKey(options)
});

export const listUtilityServicesInfiniteQueryKey = (options?: Options<ListUtilityServicesData>): QueryKey<Options<ListUtilityServicesData>> => createQueryKey('listUtilityServices', options, true);

/**
 * Utilitățile organizației, paginate; căutare după furnizor, număr de contract sau POD.
 */
export const listUtilityServicesInfiniteOptions = (options?: Options<ListUtilityServicesData>) => {
    const opts = infiniteQueryOptions<ListUtilityServicesResponse, ListUtilityServicesError, InfiniteData<ListUtilityServicesResponse>, QueryKey<Options<ListUtilityServicesData>>, number | Pick<QueryKey<Options<ListUtilityServicesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListUtilityServicesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listUtilityServices({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUtilityServicesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Adaugă o utilitate pe o proprietate.
 *
 * Fereastra lunară de transmitere a indexului NU se configurează aici: este a organizației, pe regula de notificare METER_INDEX_REQUEST, și se citește în indexWindow. whoPays decide cui i se cere indexul — TENANT și SHARED cer chiriașului, OWNER și INCLUDED_IN_RENT nu cer nimănui.
 */
export const createUtilityServiceMutation = (options?: Partial<Options<CreateUtilityServiceData>>): UseMutationOptions<CreateUtilityServiceResponse, CreateUtilityServiceError, Options<CreateUtilityServiceData>> => {
    const mutationOptions: UseMutationOptions<CreateUtilityServiceResponse, CreateUtilityServiceError, Options<CreateUtilityServiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUtilityService({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUtilityBillsQueryKey = (options?: Options<ListUtilityBillsData>) => createQueryKey('listUtilityBills', options);

/**
 * Facturile de utilități plătite de chiriași, anunțate din portal sau înregistrate de proprietar, paginate; filtre după proprietate, utilitate, contract, stare și lună.
 *
 * O factură de utilități este plătită furnizorului de chiriaș și NU este banul proprietarului: rândul nu scrie nicio încasare, nicio cheltuială și nicio linie de raport. Chiriașul o anunță din portal cu dovada atașată, proprietarul o confirmă sau o respinge; proprietarul poate și înregistra direct o plată văzută, fără dovadă. O lună are cel mult o plată anunțată sau confirmată pe fiecare utilitate; o plată respinsă lasă luna deschisă. Costurile utilităților plătite de proprietar se înregistrează la Cheltuieli, nu aici. Sortabil după periodYear, paidOn, createdAtUtc; implicit cea mai nouă lună întâi.
 */
export const listUtilityBillsOptions = (options?: Options<ListUtilityBillsData>) => queryOptions<ListUtilityBillsResponse, ListUtilityBillsError, ListUtilityBillsResponse, ReturnType<typeof listUtilityBillsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUtilityBills({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUtilityBillsQueryKey(options)
});

export const listUtilityBillsInfiniteQueryKey = (options?: Options<ListUtilityBillsData>): QueryKey<Options<ListUtilityBillsData>> => createQueryKey('listUtilityBills', options, true);

/**
 * Facturile de utilități plătite de chiriași, anunțate din portal sau înregistrate de proprietar, paginate; filtre după proprietate, utilitate, contract, stare și lună.
 *
 * O factură de utilități este plătită furnizorului de chiriaș și NU este banul proprietarului: rândul nu scrie nicio încasare, nicio cheltuială și nicio linie de raport. Chiriașul o anunță din portal cu dovada atașată, proprietarul o confirmă sau o respinge; proprietarul poate și înregistra direct o plată văzută, fără dovadă. O lună are cel mult o plată anunțată sau confirmată pe fiecare utilitate; o plată respinsă lasă luna deschisă. Costurile utilităților plătite de proprietar se înregistrează la Cheltuieli, nu aici. Sortabil după periodYear, paidOn, createdAtUtc; implicit cea mai nouă lună întâi.
 */
export const listUtilityBillsInfiniteOptions = (options?: Options<ListUtilityBillsData>) => {
    const opts = infiniteQueryOptions<ListUtilityBillsResponse, ListUtilityBillsError, InfiniteData<ListUtilityBillsResponse>, QueryKey<Options<ListUtilityBillsData>>, number | Pick<QueryKey<Options<ListUtilityBillsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListUtilityBillsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listUtilityBills({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUtilityBillsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Confirmă o plată anunțată de chiriaș. Nu se modifică nimic din ce a anunțat și nu se înregistrează nimic.
 *
 * O factură de utilități este plătită furnizorului de chiriaș și NU este banul proprietarului: rândul nu scrie nicio încasare, nicio cheltuială și nicio linie de raport. Chiriașul o anunță din portal cu dovada atașată, proprietarul o confirmă sau o respinge; proprietarul poate și înregistra direct o plată văzută, fără dovadă. O lună are cel mult o plată anunțată sau confirmată pe fiecare utilitate; o plată respinsă lasă luna deschisă. Costurile utilităților plătite de proprietar se înregistrează la Cheltuieli, nu aici. O plată deja confirmată sau respinsă răspunde 422 utility-bill-already-reviewed. Necesită Idempotency-Key.
 */
export const confirmUtilityBillMutation = (options?: Partial<Options<ConfirmUtilityBillData>>): UseMutationOptions<ConfirmUtilityBillResponse, ConfirmUtilityBillError, Options<ConfirmUtilityBillData>> => {
    const mutationOptions: UseMutationOptions<ConfirmUtilityBillResponse, ConfirmUtilityBillError, Options<ConfirmUtilityBillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmUtilityBill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Respinge o plată anunțată de chiriaș, cu motivul pe care chiriașul îl citește. Luna rămâne deschisă.
 *
 * O factură de utilități este plătită furnizorului de chiriaș și NU este banul proprietarului: rândul nu scrie nicio încasare, nicio cheltuială și nicio linie de raport. Chiriașul o anunță din portal cu dovada atașată, proprietarul o confirmă sau o respinge; proprietarul poate și înregistra direct o plată văzută, fără dovadă. O lună are cel mult o plată anunțată sau confirmată pe fiecare utilitate; o plată respinsă lasă luna deschisă. Costurile utilităților plătite de proprietar se înregistrează la Cheltuieli, nu aici. Motivul este obligatoriu (422 utility-bill-reject-reason-required). Necesită Idempotency-Key.
 */
export const rejectUtilityBillMutation = (options?: Partial<Options<RejectUtilityBillData>>): UseMutationOptions<RejectUtilityBillResponse, RejectUtilityBillError, Options<RejectUtilityBillData>> => {
    const mutationOptions: UseMutationOptions<RejectUtilityBillResponse, RejectUtilityBillError, Options<RejectUtilityBillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectUtilityBill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ștergere logică; citirile rămân, pentru că istoricul de consum este motivul pentru care utilitatea a existat.
 */
export const deleteUtilityServiceMutation = (options?: Partial<Options<DeleteUtilityServiceData>>): UseMutationOptions<DeleteUtilityServiceResponse, DeleteUtilityServiceError, Options<DeleteUtilityServiceData>> => {
    const mutationOptions: UseMutationOptions<DeleteUtilityServiceResponse, DeleteUtilityServiceError, Options<DeleteUtilityServiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUtilityService({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUtilityServiceQueryKey = (options: Options<GetUtilityServiceData>) => createQueryKey('getUtilityService', options);

/**
 * O utilitate, cu ultimul index citit și fereastra de transmitere a organizației.
 */
export const getUtilityServiceOptions = (options: Options<GetUtilityServiceData>) => queryOptions<GetUtilityServiceResponse, GetUtilityServiceError, GetUtilityServiceResponse, ReturnType<typeof getUtilityServiceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUtilityService({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUtilityServiceQueryKey(options)
});

/**
 * Înlocuiește datele utilității.
 *
 * Fereastra lunară de transmitere a indexului NU se configurează aici: este a organizației, pe regula de notificare METER_INDEX_REQUEST, și se citește în indexWindow. whoPays decide cui i se cere indexul — TENANT și SHARED cer chiriașului, OWNER și INCLUDED_IN_RENT nu cer nimănui.
 */
export const updateUtilityServiceMutation = (options?: Partial<Options<UpdateUtilityServiceData>>): UseMutationOptions<UpdateUtilityServiceResponse, UpdateUtilityServiceError, Options<UpdateUtilityServiceData>> => {
    const mutationOptions: UseMutationOptions<UpdateUtilityServiceResponse, UpdateUtilityServiceError, Options<UpdateUtilityServiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUtilityService({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Înregistrează o factură plătită de chiriaș pentru o lună, direct confirmată.
 *
 * O factură de utilități este plătită furnizorului de chiriaș și NU este banul proprietarului: rândul nu scrie nicio încasare, nicio cheltuială și nicio linie de raport. Chiriașul o anunță din portal cu dovada atașată, proprietarul o confirmă sau o respinge; proprietarul poate și înregistra direct o plată văzută, fără dovadă. O lună are cel mult o plată anunțată sau confirmată pe fiecare utilitate; o plată respinsă lasă luna deschisă. Costurile utilităților plătite de proprietar se înregistrează la Cheltuieli, nu aici. Contractul din corp trebuie să fie pe proprietatea utilității (422 utility-bill-contract-not-on-property). Dovada este opțională; dacă se trimite, trebuie să fie legată de acel contract (422 utility-bill-proof-not-on-contract).
 */
export const recordUtilityBillMutation = (options?: Partial<Options<RecordUtilityBillData>>): UseMutationOptions<RecordUtilityBillResponse, RecordUtilityBillError, Options<RecordUtilityBillData>> => {
    const mutationOptions: UseMutationOptions<RecordUtilityBillResponse, RecordUtilityBillError, Options<RecordUtilityBillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordUtilityBill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUtilityConsumptionQueryKey = (options: Options<GetUtilityConsumptionData>) => createQueryKey('getUtilityConsumption', options);

/**
 * Seria de consum a contorului, cea mai veche întâi — datele graficului din SCR-UTIL-003.
 */
export const getUtilityConsumptionOptions = (options: Options<GetUtilityConsumptionData>) => queryOptions<GetUtilityConsumptionResponse, GetUtilityConsumptionError, GetUtilityConsumptionResponse, ReturnType<typeof getUtilityConsumptionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUtilityConsumption({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUtilityConsumptionQueryKey(options)
});

export const listMeterReadingsQueryKey = (options: Options<ListMeterReadingsData>) => createQueryKey('listMeterReadings', options);

/**
 * Citirile contorului, cele mai recente întâi.
 */
export const listMeterReadingsOptions = (options: Options<ListMeterReadingsData>) => queryOptions<ListMeterReadingsResponse, ListMeterReadingsError, ListMeterReadingsResponse, ReturnType<typeof listMeterReadingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMeterReadings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMeterReadingsQueryKey(options)
});

export const listMeterReadingsInfiniteQueryKey = (options: Options<ListMeterReadingsData>): QueryKey<Options<ListMeterReadingsData>> => createQueryKey('listMeterReadings', options, true);

/**
 * Citirile contorului, cele mai recente întâi.
 */
export const listMeterReadingsInfiniteOptions = (options: Options<ListMeterReadingsData>) => {
    const opts = infiniteQueryOptions<ListMeterReadingsResponse, ListMeterReadingsError, InfiniteData<ListMeterReadingsResponse>, QueryKey<Options<ListMeterReadingsData>>, number | Pick<QueryKey<Options<ListMeterReadingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListMeterReadingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listMeterReadings({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMeterReadingsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Transmite indexul curent al contorului.
 *
 * Indexul anterior este al serverului: se ia din ultima citire a contorului și nu se trimite de client. Consumul este calculat de bază de date. Un index mai mic decât cel anterior este refuzat cu 422 meter-reading-below-previous dacă lipsește isMeterReset; cu el, consumul este întregul index curent, iar citirea rămâne marcată. Citirile transmise prin această rută sunt întotdeauna OWNER — portalul chiriașului (PORTAL-001) și linkul fără cont (PORTAL-003) au rutele lor.
 */
export const submitMeterReadingMutation = (options?: Partial<Options<SubmitMeterReadingData>>): UseMutationOptions<SubmitMeterReadingResponse, SubmitMeterReadingError, Options<SubmitMeterReadingData>> => {
    const mutationOptions: UseMutationOptions<SubmitMeterReadingResponse, SubmitMeterReadingError, Options<SubmitMeterReadingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitMeterReading({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
